{
  "consent": {
    "ariaLabel": "Consentimiento de cookies y análisis",
    "body": "Usamos cookies opcionales de Google Analytics para entender cómo se usa el sitio. El sitio funciona completamente sin ellas y nunca vendemos su información. ¿Desea permitir las cookies de análisis?",
    "privacyLink": "Política de privacidad",
    "accept": "Permitir análisis",
    "decline": "No, gracias",
    "disclaimer": "Información educativa, no consejo médico. Consulte siempre a su equipo de trasplante. En una emergencia, llame al 911."
  },
  "education": {
    "header": {
      "title": "Educación y recursos",
      "subtitle": "Aprenda sobre los programas que ayudan a pagar sus medicinas. Descubra cuáles funcionan mejor para usted."
    },
    "totalAssist": {
      "badge": "Nuevo · Ya disponible",
      "title": "Llegó TotalAssist, el programa caritativo de asistencia al paciente más grande del país",
      "p1": "<strong>TotalAssist</strong> reúne décadas de experiencia en asistencia al paciente en un solo programa. Con más de 50 años de experiencia combinada, su equipo ha ayudado a 3.8 millones de pacientes y ha otorgado más de $7 mil millones en asistencia financiera.",
      "p2": "Desde el <strong>1 de julio de 2026</strong>, TotalAssist reúne toda la asistencia financiera en un solo lugar. Tiene casi 150 fondos para distintas enfermedades, sin listas de espera y, en la mayoría de los casos, le dicen al instante si califica. Las ayudas pueden cubrir copagos, coseguro, deducibles, primas del seguro, consultas médicas y otros costos del tratamiento. La mayoría de los fondos usan un límite de ingresos del 500% del Nivel Federal de Pobreza, ajustado según el tamaño de su hogar y el costo de vida donde vive — así que muchas familias de ingresos medios califican. Según la fecha de su diagnóstico, también pueden devolverle gastos que usted ya pagó en los últimos 6 meses. <strong>TotalAssist tiene un fondo para pacientes de trasplante de órgano sólido — pregunte por él cuando llame o presente su solicitud.</strong>",
      "applyPre": "Solicite en línea o llame al ",
      "phone": "866-512-3861",
      "applyPost": " (lun–vie, 8:30am–5:30pm hora del Este; oprima el 2 para español, o el 3 para otros idiomas).",
      "learnMore": "Conozca más sobre TotalAssist"
    },
    "gotDenied": {
      "title": "¿Le denegaron la cobertura?",
      "text": "¿El seguro dijo que no? No se preocupe, usted puede defenderse. Aprenda por qué ocurren las denegaciones y cómo presentar una apelación. Tenemos modelos de cartas para ayudar a su médico a escribir en su nombre.",
      "cta": "Ver la guía de apelaciones"
    },
    "tabs": {
      "ariaLabel": "Temas de educación",
      "emergency": "¿Sin medicinas?",
      "generics": "Genéricos vs. marca",
      "deductibleTrap": "Trampa del deducible",
      "diversion": "Financiamiento alternativo",
      "directory": "Directorio",
      "insurance": "Seguros",
      "mental": "Salud mental",
      "oop": "Máximo de bolsillo"
    },
    "emergency": {
      "title": "¿Se le acabó el medicamento o está por acabarse?",
      "intro": "El medicamento antirrechazo no es algo que pueda saltarse sin peligro. Si por el costo o un problema con el resurtido (refill) le queda poco, actúe hoy mismo. Aquí le decimos cómo conseguir un suministro puente mientras resuelve el costo.",
      "call911": "Si esto es una emergencia médica, llame al 911.",
      "call911Text": "Las señales de rechazo, fiebre, dolor sobre el trasplante, menos orina, aumento de peso repentino o sentirse muy mal necesitan a su equipo de trasplante de inmediato. No espere. <strong>Nunca cambie ni deje sus dosis por su cuenta.</strong>",
      "orgEscalation": {
        "title": "Ayuda el mismo día de {{name}}",
        "text": "Su centro de trasplante creó este contacto directo para problemas urgentes con los medicamentos. Pueden actuar el mismo día.",
        "callPre": "Llame ahora: "
      },
      "step1Title": "Llame primero a su equipo de trasplante, hoy mismo",
      "step1Text": "Este es el paso más importante. Su centro de trasplante maneja esto todo el tiempo. Pida hablar con el <strong>farmacéutico de trasplante</strong> o el <strong>trabajador social</strong>. Muchas veces pueden enviar una receta de emergencia, darle muestras o iniciar una solicitud de asistencia rápida el mismo día. Dígales con claridad: \"Estoy a punto de quedarme sin medicamento y no puedo pagar el resurtido.\"",
      "step2Title": "Pida a su farmacia un suministro de emergencia",
      "step2Pre": "Algunos estados permiten que el farmacéutico le dé unos días de un medicamento que usted toma con regularidad en una emergencia, para que no pierda dosis. Pregunte: ",
      "step2Quote": "\"¿Me puede despachar (surtir) un suministro de emergencia mientras resuelvo el costo o el resurtido?\"",
      "step2Post": " Lleve su frasco de pastillas o el nombre y la dosis del medicamento.",
      "step2Note": "Su farmacia puede confirmar si un suministro de emergencia está permitido para su medicamento según las reglas de su estado.",
      "step3Title": "Pregunte al fabricante del medicamento por un suministro puente",
      "step3Text": "Algunos fabricantes dan un suministro gratis de corto plazo, llamado \"puente\" o \"inicio rápido\", mientras revisan su solicitud del Programa de Asistencia al Paciente — puede pedirlo aunque apenas vaya a empezar la solicitud. Su equipo de trasplante puede pedirlo, o llame a la línea de apoyo al paciente del fabricante.",
      "step3Link": "Busque su medicamento y su fabricante →",
      "step4Title": "Consulte a las fundaciones por ayuda urgente",
      "step4Text": "Algunas fundaciones de copago revisan los casos urgentes más rápido. Vale la pena llamar cuando está en apuros. Vea los grupos de confianza en nuestro directorio.",
      "step4Link": "Abrir el directorio de recursos →",
      "readyTitle": "Tenga esto a la mano cuando llame",
      "readySubtitle": "Hace que cada llamada sea más rápida:",
      "readyItems": [
        "Los nombres y las dosis de sus medicinas",
        "El nombre y el teléfono de su farmacia",
        "Su tarjeta del seguro (si tiene una)",
        "El número de teléfono de su centro de trasplante"
      ],
      "dontStopTitle": "No deje de tomar su medicamento por su cuenta.",
      "dontStopText": "Perder dosis del medicamento antirrechazo puede poner en riesgo su trasplante. Si de verdad no puede conseguir el suministro completo, pregunte a su equipo de trasplante si es posible un plan seguro de corto plazo, pero deje que ellos tomen esa decisión, no usted.",
      "dontStopCta": "Reciba ayuda para solicitar asistencia a largo plazo"
    },
    "oop": {
      "title": "Combinar programas",
      "intro": "La mayoría de los pacientes de trasplante usan una mezcla de programas de ayuda para pagar sus medicinas. Es como un rompecabezas.",
      "negotiation": {
        "badge": "En vigor desde enero de 2026",
        "title": "Negociación de precios de medicamentos de Medicare",
        "lead": "Por primera vez en la historia, Medicare negoció precios más bajos con los fabricantes de medicamentos.",
        "p1": "Los primeros precios nuevos comienzan el 1 de enero de 2026, con grandes ahorros. Ejemplos: <strong>Eliquis</strong> baja de $521 a $231 al mes (56% menos) y <strong>Januvia</strong> baja de $527 a $113 al mes (79% menos). Esto les ahorrará $1.5 mil millones a los pacientes de Medicare solo en 2026.",
        "p2": "Los primeros 10 medicamentos incluyen medicinas para la insuficiencia cardíaca (Entresto), la diabetes (Jardiance, Farxiga, Januvia), los coágulos de sangre (Eliquis, Xarelto), las enfermedades inmunitarias (Stelara, Enbrel), los cánceres de la sangre (Imbruvica) y la insulina (NovoLog/Fiasp).",
        "p3": "Cerca de 8.8 millones de pacientes de Medicare Parte D usaron estas medicinas en 2023. Ya se eligió una segunda ronda de 15 medicamentos para los precios de 2027.",
        "round3Title": "Tercera ronda anunciada el 27 de enero de 2026",
        "round3P1": "CMS eligió 15 medicamentos nuevos para negociar, incluidos los <strong>primeros medicamentos de la Parte B</strong>. Los precios nuevos entran en vigor el 1 de enero de 2028.",
        "round3P2": "<strong>Selecciones importantes para trasplante:</strong> Orencia (abatacept, relacionado con Belatacept), Trulicity (dulaglutide, para la diabetes después del trasplante), Xolair (omalizumab, trasplante de pulmón), Anoro Ellipta (trasplante de pulmón). También incluye Botox, Biktarvy, Cimzia, Cosentyx, Entyvio, Erleada, Kisqali, Lenvima, Rexulti, Verzenio y Xeljanz."
      },
      "glp1": {
        "badge": "Nuevo a mediados de 2026",
        "title": "Cobertura de Medicare de los GLP-1 para bajar de peso",
        "lead": "Un gran cambio: Medicare ahora cubrirá medicamentos para bajar de peso.",
        "p1": "A partir de mediados de 2026, Medicare cubrirá ciertos medicamentos GLP-1 para bajar de peso, poniendo fin a una regla que dejaba estos medicamentos fuera de la Parte D.",
        "p2": "<strong>Medicamentos cubiertos:</strong> Wegovy y Zepbound estarán cubiertos para pacientes con problemas de salud relacionados con el peso. Su copago debería ser de unos <strong>$50 al mes</strong> después de alcanzar su deducible.",
        "p3": "Eli Lilly y Novo Nordisk acordaron dar estos medicamentos a precios más bajos para los pacientes de Medicare."
      },
      "m3p": {
        "title": "Plan de Pago de Medicamentos Recetados de Medicare",
        "lead": "Un gran cambio gracias a leyes nuevas",
        "p1": "Desde 2025, los pacientes de Medicare Parte D pueden repartir el costo de sus medicamentos a lo largo del año, en vez de pagar cantidades grandes de una sola vez.",
        "p2": "Este programa hace que sus costos sean más estables y fáciles de manejar.",
        "p3": "Llame a su plan de la Parte D (el número está en su tarjeta del plan) y pregunte por este plan de pago. Puede pedirlo en cualquier momento del año, incluida la inscripción abierta de Medicare (del 15 de octubre al 7 de diciembre)."
      },
      "pick": {
        "title": "Parte D vs Medicare Advantage: cómo elegir su plan",
        "intro": "Conocer las diferencias puede ahorrarle mucho dinero en medicinas de trasplante.",
        "partDTitle": "Medicare Parte D (tradicional)",
        "partDDesc": "Un plan de medicamentos que funciona con Medicare Original. Es un plan aparte, solo para medicinas.",
        "partDItems": [
          "Funciona con cualquier proveedor que acepte Medicare",
          "Deducible y prima aparte",
          "Límite de gastos de bolsillo de $2,100 (2026, subió de $2,000 en 2025)"
        ],
        "maTitle": "Medicare Advantage (MA-PD)",
        "maDesc": "Un plan todo en uno que cubre las visitas al médico Y las medicinas.",
        "maItems": [
          "Primas a menudo más bajas o de $0",
          "Las redes de proveedores pueden ser limitadas",
          "Límite de gastos de bolsillo de $2,100 (2026, subió de $2,000 en 2025)"
        ]
      },
      "compare": {
        "title": "Cómo comparar planes según sus medicinas",
        "step1Title": "Revise las listas de medicamentos",
        "step1Text": "Use la herramienta Medicare Plan Finder en medicare.gov para ver qué planes cubren sus medicamentos y cuánto cuestan.",
        "step1Link": "Medicare Plan Finder",
        "step1LinkAria": "Visitar Medicare Plan Finder (se abre en una pestaña nueva)",
        "step2Title": "Compare los costos totales",
        "step2Text": "Mire las primas mensuales, los deducibles, los copagos y qué farmacias puede usar. Recuerde: el límite anual de $2,100 (2026) es solo para los medicamentos de la Parte D; las consultas médicas y otros servicios tienen sus propios costos.",
        "step3Title": "Averigüe sobre la Ayuda Adicional (Extra Help)",
        "step3Text": "Si tiene ingresos bajos, el programa Extra Help (Ayuda Adicional) puede reducir los costos de los planes de la Parte D y de Medicare Advantage con medicamentos (MA-PD). Puede eliminar sus primas mensuales y su deducible ($615 en 2026), y limita los copagos de los medicamentos genéricos y de marca.",
        "step3Link": "Solicitar Extra Help",
        "step3LinkAria": "Solicitar Extra Help (se abre en una pestaña nueva)",
        "step4Title": "Obtenga ayuda gratis",
        "step4Text": "Llame a su Programa Estatal de Asistencia con el Seguro Médico (SHIP) para recibir ayuda gratis al elegir un plan.",
        "step4Link": "Encuentre su SHIP local",
        "step4LinkAria": "Encuentre su SHIP local (se abre en una pestaña nueva)"
      },
      "parts": {
        "title": "Las partes de Medicare para los medicamentos de trasplante",
        "intro": "Saber qué parte de Medicare paga sus medicinas de trasplante es clave.",
        "partATitle": "Parte A (hospital)",
        "partADesc": "Paga los medicamentos que le dan mientras usted está en el hospital.",
        "partAItem": "Agentes de inducción (Thymoglobulin, Simulect)",
        "partBTitle": "Parte B (médica)",
        "partBDesc": "Paga algunos medicamentos que usted recibe en clínicas. También cubre los medicamentos antirrechazo si usted no tiene Parte D.",
        "partBItem": "Infusiones IV (Belatacept/Nulojix)",
        "partDTitle": "Parte D (recetas)",
        "partDDesc": "Paga la mayoría de las pastillas que usted toma en casa cada día.",
        "partDItem": "Tacrolimus, Mycophenolate, etc."
      },
      "strategies": {
        "title": "Estrategias según el tipo de seguro",
        "commercialTitle": "¿Seguro privado o del trabajo (comercial)?",
        "commercialItem1": "Use las <strong>tarjetas de copago de los fabricantes</strong> para bajar lo que paga en la farmacia.",
        "commercialItem2": "Use las <strong>fundaciones</strong> para los deducibles.",
        "medicareTitle": "¿Medicare?",
        "medicareItem1": "Use las <strong>fundaciones</strong> para los copagos.",
        "medicareItem2": "Revise los <strong>precios en efectivo</strong> de los genéricos para comparar los ahorros."
      },
      "keyInsightTitle": "Dato clave",
      "keyInsightText": "Muchos pacientes combinan programas; por ejemplo, un paciente de Medicare puede recibir ayudas económicas de fundaciones para sus copagos. Revise también los precios en efectivo de los medicamentos genéricos.",
      "glossary": {
        "title": "Palabras del seguro explicadas de forma simple",
        "intro": "Saber qué significan estas palabras le ayuda a manejar los costos y a encontrar ayuda. (Al seguro también se le llama 'plan médico', y a la cobertura, 'cubierta', especialmente en Puerto Rico.)",
        "premiumTerm": "Prima",
        "premiumDef": "La cantidad que usted paga cada mes por tener seguro. Piense en ella como una membresía de gimnasio: paga todos los meses, la use o no.",
        "deductibleTerm": "Deducible",
        "deductibleDef": "La cantidad que usted debe pagar por su cuenta antes de que su seguro empiece a ayudar. Si su deducible es de $500, usted paga los primeros $500 en medicinas. Después de eso, el seguro ayuda a pagar.",
        "copayTerm": "Copago",
        "copaySuffix": "",
        "copayDef": "Una cantidad fija que usted paga cada vez que recibe una medicina. Ejemplo: puede pagar $10 por cada receta, y el seguro paga el resto.",
        "coinsuranceTerm": "Coseguro (coaseguro)",
        "coinsuranceDef": "El porcentaje que usted paga después de alcanzar su deducible. Si su coseguro es del 20%, usted paga $20 por cada $100 del costo de la medicina. El seguro paga los otros $80.",
        "oopMaxPre": "Límite de gasto anual (",
        "oopMaxTerm": "Máximo de gastos de bolsillo",
        "oopMaxPost": ")",
        "oopMaxDef": "Lo máximo que usted pagará en un año. Cuando llega a esa cantidad, el seguro paga el 100% de las medicinas cubiertas. Es su red de seguridad.",
        "formularyPre": "Lista de medicinas cubiertas (",
        "formularyTerm": "Formulario",
        "formularyPost": ")",
        "formularyDef": "La lista de medicinas que su seguro va a cubrir. Piense en ella como el menú de la aseguradora. Si su medicina no está en la lista, puede pagar más o necesitar una aprobación especial.",
        "tierTerm": "Nivel (tier)",
        "tierDef": "La forma en que el seguro agrupa las medicinas por costo. Los niveles bajos (1-2) cuestan menos. Los niveles altos (3-4-5) cuestan más.",
        "tier1": "<strong>Nivel 1:</strong> Normalmente medicamentos genéricos (el costo más bajo)",
        "tier2": "<strong>Nivel 2:</strong> Medicamentos de marca preferidos",
        "tier3": "<strong>Niveles 3-5:</strong> Medicamentos no preferidos o especializados (el costo más alto)",
        "paTerm": "Autorización previa",
        "paDef": "Cuando usted necesita la aprobación de la aseguradora antes de que pague una medicina. Su médico debe explicar por qué usted necesita esa medicina en específico.",
        "paWiserTitle": "Nuevo en 2026: el piloto WISeR de CMS",
        "paWiserPre": "WISeR es un programa nuevo de Medicare (en inglés: Wasteful and Inappropriate Service Reduction). Funciona en 6 estados: Arizona, Nueva Jersey, Ohio, Oklahoma, Texas y Washington. Exige un permiso del seguro (autorización previa) antes de 17 tipos de procedimientos fuera del hospital de Medicare Parte B. No afecta directamente los medicamentos de trasplante, pero puede agregar pasos para algunos procedimientos. ",
        "paWiserLink": "Conozca más en nuestra página de apelaciones",
        "paWiserPost": ".",
        "genericTerm": "Medicina genérica",
        "genericSuffix": "",
        "genericDef": "Una medicina que funciona igual que la de marca pero cuesta menos. Como el cereal de la marca de la tienda frente al de marca famosa: es lo mismo, en otro empaque.",
        "brandTerm": "Medicina de marca",
        "brandDef": "La versión original de una medicina, hecha por la compañía que la inventó. Normalmente cuesta más que la genérica.",
        "specialtyTerm": "Medicamento de especialidad (especializado)",
        "specialtySuffix": "",
        "specialtyDef": "Medicinas caras que necesitan un manejo o control especial. La mayoría de las medicinas de trasplante son medicamentos especializados. Suelen costar $600 o más al mes.",
        "partDTerm": "Medicare Parte D",
        "partDDef": "La parte de Medicare que ayuda a pagar las medicinas recetadas. Debe inscribirse en ella por separado.",
        "oopCapTerm": "Límite anual de gastos de bolsillo (Parte D)",
        "oopCapDef": "Un límite anual de lo que usted paga de su bolsillo por los medicamentos de Medicare Parte D. En 2026 el tope es de $2,100. Cuando lo alcanza, paga $0 por los medicamentos cubiertos el resto del año.",
        "catastrophicTerm": "Cobertura catastrófica",
        "catastrophicDef": "Después de alcanzar el límite anual de la Parte D ($2,100 en 2026), Medicare paga el 100% y usted paga $0 por los medicamentos cubiertos el resto del año.",
        "inNetworkTerm": "Farmacia dentro de la red",
        "inNetworkDef": "Una farmacia que trabaja con su seguro. Aquí usted paga menos. Piense en ella como un socio preferido.",
        "outNetworkTerm": "Farmacia fuera de la red",
        "outNetworkDef": "Una farmacia que no tiene acuerdo con su seguro. Aquí puede pagar más o no tener cobertura.",
        "pbmTerm": "PBM (administrador de beneficios farmacéuticos)",
        "pbmDef": "La compañía que administra la cobertura de medicamentos recetados de su seguro. Ellos deciden qué medicinas se cubren y cuánto cuestan.",
        "papPre": "Programa de Asistencia al Paciente (",
        "papTerm": "PAP",
        "papPost": ")",
        "papDef": "Programas de medicinas gratis o a bajo costo que manejan las compañías farmacéuticas. Si no puede pagar su medicina, estos programas podrían ayudarle.",
        "copayCardTerm": "Tarjeta o cupón de copago",
        "copayCardDef": "Ayuda de las compañías farmacéuticas para bajar lo que usted paga por las medicinas de marca. <strong>Importante:</strong> Muchas veces no funcionan con Medicare.",
        "mfrTerm": "Asistencia del fabricante",
        "mfrDef": "Ayuda directa de la compañía que hace su medicina. Puede ser medicina gratis, ayuda con el copago o descuentos.",
        "mailTerm": "Farmacia de pedido por correo",
        "mailDef": "Una farmacia que envía la medicina a su casa. Normalmente le da 90 días de medicina de una vez. Suele costar menos que comprar 30 días en una farmacia local.",
        "stepTerm": "Terapia escalonada",
        "stepDef": "Cuando el seguro le exige probar primero una medicina más barata antes de pagar una más cara. Como tener que probar la versión básica antes de recibir la versión premium.",
        "exclusionTerm": "Exclusión",
        "exclusionDef": "Una medicina que el seguro no va a cubrir para nada. Usted debe pagar el precio completo o buscar otra ayuda.",
        "whyTitle": "Por qué esto importa para los pacientes de trasplante",
        "whyIntro": "Sus medicinas antirrechazo son medicamentos especializados. Son caras. Entender estas palabras le ayuda a:",
        "whyItems": [
          "Saber cuánto va a pagar",
          "Encontrar ayuda cuando los costos son muy altos",
          "Hablar con su equipo de trasplante sobre sus opciones",
          "Solicitar programas de asistencia"
        ],
        "askTitle": "Preguntas para hacer",
        "askItems": [
          "¿En qué nivel están mis medicinas de trasplante?",
          "¿De cuánto es mi deducible?",
          "¿Cuándo alcanzo mi máximo de gastos de bolsillo (mi límite del año)?",
          "¿Están mis medicinas en la lista de medicinas cubiertas?",
          "¿Puedo usar el pedido por correo para ahorrar dinero?"
        ]
      }
    },
    "directory": {
      "title": "Directorio de recursos de confianza",
      "visitAria": "Visitar {{name}} (se abre en una pestaña nueva)",
      "emptyTitle": "No hay recursos disponibles",
      "emptyText": "Estamos trabajando para agregar recursos de confianza. Vuelva pronto para ver enlaces y organizaciones útiles.",
      "statusPaused": "Las solicitudes están pausadas por ahora",
        "statusPausedNote": "Esta fundación no acepta solicitudes nuevas por ahora. Vuelva a revisar más adelante o pregunte a su trabajador social de trasplante por otras ayudas.",
        "categories": {
        "Foundation": "Fundación",
        "Low-Cost Pharmacy": "Farmacia de bajo costo",
        "Support Group": "Grupo de apoyo",
        "Medication Database": "Base de datos de medicamentos",
        "Discount Program": "Programa de descuentos",
        "Government": "Gobierno",
        "Caregiver Support": "Apoyo para cuidadores",
        "Foundation Directory": "Directorio de fundaciones",
        "Search Engine": "Buscador"
      }
    },
    "insurance": {
      "wiser": {
        "title": "Nuevo en 2026: el piloto de autorización previa WISeR de CMS",
        "intro": "A partir de enero de 2026, CMS lanzó el modelo <strong>WISeR (Wasteful and Inappropriate Service Reduction)</strong>. Este agrega autorización previa para 17 servicios ambulatorios de Medicare Parte B en 6 estados.",
        "statesTitle": "Estados afectados",
        "stateAz": "Arizona",
        "stateNj": "Nueva Jersey",
        "stateOh": "Ohio",
        "stateOk": "Oklahoma",
        "stateTx": "Texas",
        "stateWa": "Washington",
        "knowTitle": "Lo que los pacientes de trasplante deben saber",
        "know1": "WISeR se aplica solo a ciertos procedimientos que se hacen sin internarse en el hospital (como cuidado de heridas o procedimientos de columna), <strong>no</strong> a los medicamentos de trasplante",
        "know2": "Sus medicamentos inmunosupresores NO se ven afectados",
        "know3": "Si necesita alguno de los 17 procedimientos de la lista (por ejemplo, cuidado de heridas con sustitutos de piel), su proveedor debe obtener una autorización previa",
        "know4": "Las decisiones de cobertura se toman en un plazo de 72 horas (48 horas en casos urgentes)",
        "footer": "El modelo WISeR va de enero de 2026 a diciembre de 2031. Se aplica solo a Medicare Original (pago por servicio), no a los planes Medicare Advantage. Si vive en uno de estos estados y necesita un procedimiento cubierto, hable con su proveedor sobre el proceso de autorización previa."
      },
      "note": "Cada tipo de seguro tiene sus propios beneficios, costos y mejores formas de ahorrar.",
      "infographicAlt": "Tabla comparativa de la ayuda con medicamentos de trasplante según el tipo de seguro: comercial, Medicare, Medicaid y sin seguro",
      "infographicDesc": "Esta infografía compara la ayuda disponible con los medicamentos de trasplante en cuatro tipos de seguro. Seguro comercial: seguro a través de su trabajo o que usted compra por su cuenta. Puede calificar para tarjetas de copago del fabricante, programas de asistencia al paciente y fundaciones de copago. Usted paga primas mensuales, copagos y deducibles, y luego el seguro cubre el resto. Los problemas comunes incluyen deducibles altos, requisitos de autorización previa y acumuladores de copago. Siguiente paso: busque sus medicamentos para encontrar tarjetas de copago y programas de asistencia. Medicare: seguro del gobierno para personas de 65 años o más o con discapacidades. Puede calificar para programas de asistencia al paciente, la Ayuda Adicional (Extra Help) o el Subsidio por Bajos Ingresos, y fundaciones de copago. La Parte D cubre la mayoría de los medicamentos de trasplante con primas mensuales y copagos. Los problemas comunes incluyen los costos de la Parte D y que no se pueden usar tarjetas de copago del fabricante. Siguiente paso: revise si califica para Extra Help y busque programas de asistencia al paciente. Medicaid: seguro del gobierno para personas con ingresos bajos. Puede calificar para programas de asistencia al paciente y programas específicos de su estado. Cubre la mayoría de los medicamentos de trasplante con copagos muy bajos o sin copagos. Los problemas comunes incluyen redes de farmacias limitadas, restricciones del formulario (la lista de medicamentos que cubre su plan) y la pérdida de la cobertura si cambian sus ingresos. Siguiente paso: busque sus medicamentos y consulte con la oficina de Medicaid de su estado. Sin seguro o pago por cuenta propia: sin cobertura de seguro en este momento. Puede calificar para programas de asistencia al paciente del fabricante con medicamentos gratis, programas estatales y tarjetas de descuento. Usted paga el precio completo de venta al público sin ayuda. Los problemas comunes incluyen costos muy altos, la falta de precios negociados y la dificultad para pagar medicamentos especializados. Siguiente paso: solicite programas de asistencia al paciente de inmediato, ya que la mayoría ofrece medicamentos gratis a los pacientes que califican. La infografía termina con un mensaje de ánimo: usted no está solo y hay ayuda disponible sin importar el tipo de seguro que tenga.",
      "medicareGuide": {
        "title": "Guía de Medicare",
        "partsTitle": "Las partes de Medicare para los medicamentos de trasplante",
        "partATitle": "Parte A (hospital)",
        "partAItems": [
          "Agentes de inducción",
          "(Thymoglobulin, Simulect)"
        ],
        "partBTitle": "Parte B (médica)",
        "partBItems": [
          "Infusiones IV (Belatacept)",
          "Medicamentos antirrechazo (si es elegible para la Parte B-ID, la cobertura de Medicare para inmunosupresores)",
          "2026: prima de $202.90/mes, deducible de $283",
          "Prima de la Parte B-ID (cubre los antirrechazo de por vida a pacientes de riñón): $121.60/mes"
        ],
        "partCTitle": "Parte C (Medicare Advantage)",
        "partCItems": [
          "Combina A, B y normalmente D",
          "Puede tener beneficios adicionales",
          "Debe usar ciertos médicos"
        ],
        "partDTitle": "Parte D (recetas)",
        "partDItems": [
          "Tacrolimus",
          "Mycophenolate",
          "Valcyte, etc."
        ],
        "chooseTitle": "Parte D vs Medicare Advantage: cómo elegir su plan",
        "tradTitle": "Parte D (tradicional)",
        "tradItems": [
          "Funciona con cualquier proveedor que acepte Medicare",
          "Deducible y prima aparte",
          "Límite de gastos de bolsillo de $2,100 (2026)"
        ],
        "maTitle": "Medicare Advantage (MA-PD)",
        "maItems": [
          "Primas a menudo más bajas o de $0",
          "Las redes de proveedores pueden ser limitadas",
          "Límite de gastos de bolsillo de $2,100 (2026)"
        ]
      },
      "commercial": {
        "title": "Seguro comercial (privado o del trabajo)",
        "intro": "Seguro de su trabajo o comprado por su cuenta. Si también tiene Medicare por enfermedad de los riñones, este seguro paga primero ('pagador principal') durante los primeros 30 meses; después se invierte el orden.",
        "keyPointsTitle": "Puntos clave",
        "keyPoints": [
          "Puede usar la mayoría de los programas de asistencia al paciente (PAP) de los fabricantes",
          "Las tarjetas de copago suelen funcionar",
          "Las fundaciones ayudan con los copagos altos",
          "Puede que tenga que usar una farmacia en específico"
        ],
        "strategyTitle": "Mejor estrategia",
        "strategy": "Empiece con los PAP de los fabricantes y luego use las fundaciones para los copagos o deducibles que queden."
      },
      "va": {
        "title": "Atención médica del VA",
        "intro": "Para veteranos que califican.",
        "strategyTitle": "Mejor estrategia",
        "strategy": "El VA asigna a cada veterano un 'Grupo de Prioridad' (del 1 al 8). En los grupos 1 a 6, las medicinas cuestan $0. Use primero la farmacia del VA. Trabaje con su equipo de trasplante del VA.",
        "link": "Información de recetas del VA",
        "linkAria": "Visitar la información de recetas del VA (se abre en una pestaña nueva)"
      },
      "tricare": {
        "title": "TRICARE",
        "intro": "Para miembros del ejército y sus familias.",
        "strategyTitle": "Mejor estrategia",
        "strategy": "Use la farmacia militar (copago de $0). Use el pedido por correo de TRICARE para las medicinas continuas. Consulte la herramienta de búsqueda de la lista de medicamentos.",
        "link": "Búsqueda de la lista de medicamentos de TRICARE",
        "linkAria": "Visitar la búsqueda del formulario de TRICARE (se abre en una pestaña nueva)"
      },
      "noInsurance": {
        "title": "Sin seguro",
        "intro": "Para pacientes sin seguro.",
        "strategyTitle": "Mejor estrategia",
        "items": [
          "Empiece con los programas de asistencia al paciente (PAP) de los fabricantes",
          "Revise los precios de Cost Plus Drugs",
          "Use herramientas de descuento (GoodRx, SingleCare, etc.)",
          "Averigüe sobre Medicaid o los planes del Mercado de Seguros"
        ],
        "link": "Buscar opciones de seguro",
        "linkAria": "Explorar opciones de seguro en Healthcare.gov (se abre en una pestaña nueva)"
      },
      "medicaid": {
        "title": "Medicaid (según el estado)",
        "intro": "Un programa para personas con ingresos bajos. Lo que cubre depende de su estado.",
        "selectLabel": "Elija su estado:",
        "selectPlaceholder": "-- Elija un estado --",
        "go": "Ir al sitio oficial",
        "goAria": "Visitar el sitio web de Medicaid de su estado (se abre en una pestaña nueva)",
        "leaving": "Está saliendo de esta aplicación para visitar un sitio web del gobierno."
      },
      "ihs": {
        "title": "Indian Health Service (Servicio de Salud Indígena, IHS) / Programas tribales",
        "intro": "Para pacientes indígenas americanos y nativos de Alaska que califican.",
        "findTitle": "Encuentre un centro",
        "findText": "Use el buscador oficial del IHS para encontrar clínicas y farmacias cerca de usted.",
        "findCta": "Abrir el buscador del IHS",
        "findAria": "Encontrar un centro del IHS (se abre en una pestaña nueva)",
        "strategyTitle": "Mejor estrategia",
        "strategy": "Use su programa local del IHS o el Urban Indian Program, normalmente con costo de $0."
      }
    },
    "deductibleTrap": {
      "title": "La trampa del deducible",
      "subtitle": "Por qué las tarjetas de descuento para recetas pueden costarles más a los pacientes de trasplante",
      "warning": {
        "title": "⚠️ Advertencia importante para pacientes de trasplante",
        "lead": "Usar tarjetas de descuento como GoodRx o SingleCare puede costarle MILES de dólares extra cada año.",
        "boxTitle": "Cuídese de \"la trampa del deducible\". Esto es lo que pasa:",
        "boxP1Pre": "Si usa una tarjeta de descuento, ",
        "boxP1Highlight": "el dinero que paga NO cuenta para su deducible ni para su límite anual de gastos de bolsillo",
        "boxP1Post": ".",
        "boxP2": "Por eso el seguro nunca llega a pagar el 100%. Usted sigue pagando de su bolsillo, por estas medicinas y por el resto de su atención, todo el año.",
        "boxP3": "Qué hacer: llame al número de servicio al cliente de su tarjeta del seguro y pregunte: '¿Ya alcancé mi deducible y mi límite anual de gastos de bolsillo? ¿Me conviene usar el seguro o una tarjeta de descuento para este medicamento?'",
        "trumpRxBold": "Esto también aplica a TrumpRx.gov.",
        "trumpRxText": "Los precios de TrumpRx son precios en efectivo fuera de su seguro: ese gasto tampoco cuenta para su deducible ni para su máximo de gastos de bolsillo, y muchos cupones de TrumpRx no se pueden combinar con el seguro. Precio en efectivo es precio en efectivo, no importa quién lo ofrezca.",
        "trumpRxLink": "Lea nuestra guía de TrumpRx para pacientes de trasplante →",
        "trumpRxHref": "/es/trumprx"
      },
      "example": {
        "title": "Ejemplo de la vida real",
        "rightBadge": "✅ La forma correcta",
        "rightTitle": "Usando el seguro",
        "rightM13Label": "Meses 1-3:",
        "rightM13": "Paga $2,100 de su bolsillo. Cada dólar cuenta para su deducible y su límite anual de gastos de bolsillo, y usted alcanza el límite.",
        "rightM412Label": "Meses 4-12:",
        "rightM412": "El seguro paga el 100% de sus medicinas, laboratorios y consultas = $0 de su bolsillo",
        "rightTotal": "Costo total del año: $2,100",
        "trapBadge": "❌ La trampa de la tarjeta de descuento",
        "trapTitle": "Usando GoodRx/SingleCare",
        "trapM112Label": "Meses 1-12:",
        "trapM112": "Paga el precio con descuento (~$200/mes = $2,400), pero NADA cuenta para su deducible ni su límite anual",
        "trapResultLabel": "Resultado:",
        "trapResult": "Nunca alcanza su límite anual, así que el seguro nunca llega a pagar el 100%.",
        "trapRestLabel": "Lo demás:",
        "trapRest": "Sigue pagando de su bolsillo los laboratorios, las consultas y sus otras medicinas todo el año — muchas veces entre $3,000 y $8,000 más.",
        "trapTotal": "Costo total del año: $2,400 + muchas veces entre $3,000 y $8,000 más por el resto de su atención",
        "takeaway": "El precio con descuento parece un ahorro pequeño cada mes. Pero como nada cuenta para su límite anual, el seguro nunca llega a pagar el 100%, y así la trampa puede sumar miles de dólares en un año."
      },
      "whenToUse": {
        "title": "¿Cuándo deben usar tarjetas de descuento los pacientes de trasplante?",
        "s1Title": "Situación 1: medicamento NO cubierto por el seguro",
        "s1Text": "Para una medicina que NO está en la lista de su seguro y que no tiene una opción genérica más barata.",
        "s2Title": "Situación 2: medicamentos de bajo costo y por una sola vez",
        "s2Text": "Para medicinas de corto plazo que no tienen que ver con su trasplante (como un tratamiento de antibióticos), cuando el precio con descuento es menor que su copago.",
        "s3Title": "Situación 3: deducible extremadamente alto",
        "s3Text": "Si tiene un deducible muy alto Y el precio en efectivo es mucho más bajo; pero aun así, piense bien en el costo de no alcanzar su límite anual.",
        "neverTitle": "🛑 NUNCA use tarjetas de descuento para:",
        "neverP1": "Sus medicinas antirrechazo de todos los días, como tacrolimus, micofenolato (Mycophenolate) o ciclosporina (Cyclosporine).",
        "neverP2": "Estas son las medicinas que le ayudan a alcanzar su límite anual rápido."
      },
      "alternatives": {
        "title": "Mejores alternativas",
        "papsTitle": "Programas de Asistencia al Paciente (PAP)",
        "papsText": "Medicinas gratis o a bajo costo directamente de los fabricantes.",
        "foundationsTitle": "Fundaciones de copago",
        "foundationsText": "Grupos que ayudan a pagar sus copagos y deducibles.",
        "copayTitle": "Tarjetas de copago de los fabricantes",
        "copayText": "Ayuda de los fabricantes para las medicinas de marca (no para pacientes de Medicare).",
        "counts": "✅ Cuenta para su límite anual",
        "countsCopay": "⚠️ Puede no contar para su límite anual",
        "countsCopayAsk": "Muchos planes usan \"acumuladores de copago\" que impiden que el dinero de la tarjeta cuente. Antes de usar una, pregunte a su plan: \"¿El dinero de mi tarjeta de copago contará para lo que debo?\""
      },
      "takeaways": {
        "title": "Puntos clave",
        "t1Bold": "Su meta cada año es llegar a su máximo de gastos de bolsillo (lo máximo que paga cada año).",
        "t1Rest": "Cuando lo alcanza, el seguro paga el 100% por el resto del año.",
        "t2Bold": "Las tarjetas de descuento hacen que sus pagos no cuenten para esta meta.",
        "t2Rest": "Pueden ahorrarle unos dólares por medicina, pero costarle miles durante el año.",
        "t3Bold": "Use siempre primero los PAP y las fundaciones de copago.",
        "t3Rest": "Estos programas le ayudan a pagar las medicinas Y a alcanzar su límite anual más rápido.",
        "t4Bold": "Hable con su equipo de trasplante.",
        "t4Rest": "Ellos pueden conectarlo con personas que conocen estos programas y pueden guiarlo por el sistema."
      },
      "questionsTitle": "¿Preguntas?",
      "questionsText": "¿No está seguro de si una tarjeta de descuento le conviene? Pregunte al asesor financiero o al trabajador social de su centro de trasplante. Ellos pueden revisar su plan de seguro y ayudarle a elegir."
    },
    "diversion": {
      "title": "Cuando el seguro lo manda a otra parte",
      "subtitle": "Los programas de \"financiamiento alternativo\" son empresas que su plan de seguro contrata para pasar sus medicamentos costosos a programas de caridad y de medicamentos gratis — así el plan evita pagar. Aprenda a detectarlo y qué hacer.",
      "warning": {
        "title": "Advertencia: su plan podría mandarlo a otra parte",
        "lead": "Algunos planes no quieren pagar medicamentos costosos. Pueden obligarle a pedir primero medicamentos gratis a los fabricantes.",
        "boxTitle": "¿Qué significa esto?",
        "boxP1Pre": "Su plan puede decirle: ",
        "boxP1Highlight": "\"No pagaremos su medicamento hasta que usted primero le pida medicina gratis a un fabricante.\"",
        "boxP2": "Esto le ahorra dinero a su plan. Pero puede dejarle sin medicina mientras espera. Y puede que no le den los medicamentos gratis."
      },
      "types": {
        "title": "Tres formas en que los planes hacen esto",
        "intro": "Estos trucos tienen nombres elegantes. Pero todos hacen lo mismo: hacer que otro pague sus medicamentos.",
        "whyHurts": "Por qué le perjudica:",
        "acc": {
          "title": "Acumulador de copago",
          "pre": "Los fabricantes le dan ayuda con el copago. Su plan toma esa ayuda. Pero ",
          "highlight": "no cuenta para lo que usted debe pagar en el año",
          "post": ".",
          "why": [
            "Su tarjeta de copago se acaba más rápido",
            "Cuando se acaba, usted debe el precio completo",
            "Usted sigue pagando todo el año"
          ]
        },
        "max": {
          "title": "Maximizador de copago",
          "pre": "Su plan reparte su tarjeta de copago a lo largo del año. Pero ",
          "highlight": "el plan se queda con los ahorros, no usted",
          "post": ".",
          "why": [
            "La ayuda del fabricante va a su plan, no a usted",
            "Usted sigue pagando más de lo que debería",
            "Cuando la ayuda se acaba, usted debe mucho"
          ]
        },
        "afp": {
          "title": "Financiamiento alternativo (en inglés: Alternative Funding Program, AFP)",
          "pre": "El plan de su trabajo le dice: ",
          "highlight": "\"No cubriremos este medicamento. Pídalo gratis al fabricante.\"",
          "why": [
            "Usted espera semanas o meses por sus medicamentos",
            "Puede que no le den los medicamentos gratis",
            "Si no recibe los medicamentos gratis, paga el precio completo",
            "Su plan ahorra dinero. Usted corre el riesgo."
          ]
        }
      },
      "identify": {
        "title": "Cómo saber si esto le está pasando a usted",
        "signsTitle": "Señales de alerta:",
        "signs": [
          "Los papeles de su plan dicen \"copay accumulator\" (acumulador de copago)",
          "El dinero de la tarjeta de copago no aparece en el registro de su plan",
          "Le dicen que llame primero a otra compañía",
          "Su medicamento quedó \"fuera del plan\" (no está cubierto)",
          "Le exigen pedir medicamentos gratis antes de que su plan ayude"
        ],
        "askTitle": "Haga estas preguntas a su plan:",
        "questions": [
          "\"¿Usan un acumulador de copago?\"",
          "\"¿Mi tarjeta de copago contará para lo que debo pagar?\"",
          "\"¿Mi medicamento está totalmente cubierto?\"",
          "\"¿Tengo que pedir medicamentos gratis primero?\""
        ]
      },
      "protect": {
        "title": "Cómo protegerse",
        "s1Title": "Lea los papeles de su plan",
        "s1Text": "Busque palabras como \"accumulator\" (acumulador), \"maximizer\" (maximizador) o \"alternative funding\" (financiamiento alternativo). Son pistas.",
        "s2Title": "Lleve la cuenta de lo que paga",
        "s2Text": "Guarde sus recibos. Revise si el dinero de su tarjeta de copago aparece en el registro de su plan. Si no aparece, puede que tenga un plan con acumulador.",
        "s3Title": "Apele si le dicen que no",
        "s3Text": "Si su plan no quiere cubrir su medicamento, usted puede defenderse. Pida a su equipo de trasplante que escriba una carta que diga que usted necesita este medicamento.",
        "s4Title": "Llame a la oficina de seguros de su estado",
        "s4Text": "Muchos estados tienen leyes para protegerlo. Llame al Departamento de Seguros de su estado (búsquelo en internet: 'departamento de seguros' y el nombre de su estado). Pueden decirle cuáles son sus derechos y ayudarle a presentar una queja.",
        "s5Title": "Hable con su empleador (si su seguro es del trabajo)",
        "s5Text": "Su empleador elige el plan. Cuéntele a Recursos Humanos cómo esto le perjudica. Pídales que elijan un plan mejor."
      },
      "stateLaws": {
        "title": "Estados que le protegen",
        "intro": "Algunos estados hicieron leyes para detener estos trucos. En estos estados, el dinero de la tarjeta de copago debe contar para lo que usted debe pagar.",
        "listTitle": "Estados con leyes que ayudan (hasta 2026):",
        "list": "Arizona, Arkansas, California, Connecticut, Delaware, Georgia, Illinois, Kentucky, Luisiana, Maine, Maryland, Minnesota, Misuri, Nueva Jersey, Nueva York, Carolina del Norte, Ohio, Oklahoma, Oregón, Puerto Rico, Tennessee, Texas, Virginia, Washington, Virginia Occidental y más.",
        "note": "Llame al Departamento de Seguros de su estado para conocer las leyes nuevas. Cada año más estados agregan protecciones."
      },
      "whyMatters": {
        "title": "Por qué los pacientes de trasplante deben saber esto",
        "t1Bold": "Usted no puede saltarse sus medicamentos.",
        "t1Rest": "Perder dosis puede dañar su trasplante. Esperar semanas por medicamentos gratis es arriesgado.",
        "t2Bold": "Los medicamentos gratis no son cosa segura.",
        "t2Rest": "Los fabricantes tienen reglas. Puede que usted no califique. El dinero puede acabarse.",
        "t3Bold": "Usted paga por su plan.",
        "t3Rest": "Usted paga cada mes. Pero algunos planes hacen que los fabricantes paguen sus medicamentos en su lugar.",
        "t4Bold": "Las cuentas grandes pueden llegar rápido.",
        "t4Rest": "Cuando su tarjeta de copago se acaba, puede deber mucho dinero de una sola vez."
      },
      "help": {
        "title": "¿Necesita ayuda?",
        "text": "¿Cree que esto le está pasando? Hable con el asesor financiero o el trabajador social de su centro de trasplante. Ellos saben cómo ayudar.",
        "pafPre": "También puede llamar a ",
        "pafLink": "TotalAssist",
        "pafPost": " para recibir ayuda gratis."
      }
    },
    "mental": {
      "title": "Recursos de salud mental",
      "subtitle": "Su salud mental importa. Reciba apoyo gratis y privado cuando lo necesite.",
      "crisis": {
        "title": "¿Necesita hablar con alguien ahora mismo?",
        "name": "Línea Nacional de Prevención del Suicidio y Crisis",
        "availability": "24/7 • Gratis • Privado",
        "callTitle": "Llame o envíe un mensaje de texto",
        "callText": "Marque o envíe un mensaje de texto al <strong>988</strong> desde cualquier teléfono (para atención en español, oprima el 2)",
        "chatTitle": "Chat en línea (también en español)"
      },
      "samhsa": {
        "aria": "Visitar SAMHSA (se abre en una pestaña nueva)",
        "title": "SAMHSA",
        "badge": "Recurso del gobierno",
        "desc": "<strong>Administración de Servicios de Salud Mental y Abuso de Sustancias (SAMHSA)</strong>: encuentre centros de tratamiento, grupos de apoyo y ayuda de salud mental cerca de usted.",
        "availability": "Ayuda para encontrar tratamiento a cualquier hora (24/7)"
      },
      "helplineLabel": "Línea de ayuda:",
      "transplant": {
        "title": "El trasplante y la salud mental",
        "intro": "Es normal sentirse preocupado, triste o estresado durante el proceso del trasplante. Usted no está solo.",
        "items": [
          "Pregunte a su equipo de trasplante sobre servicios de consejería",
          "Muchos centros de trasplante tienen trabajadores sociales y expertos en salud mental",
          "Medicare y la mayoría de los planes de seguro cubren los servicios de salud mental"
        ]
      },
      "nami": {
        "aria": "Visitar los grupos de apoyo de NAMI (se abre en una pestaña nueva)",
        "title": "Grupos de apoyo de NAMI",
        "desc": "NAMI ofrece grupos de apoyo gratis para personas con problemas de salud mental y sus familias."
      },
      "findTreatment": {
        "aria": "Visitar FindTreatment.gov (se abre en una pestaña nueva)",
        "desc": "Un sitio del gobierno que le ayuda a aprender sobre la salud mental, encontrar tratamiento y encontrar servicios cerca de usted."
      },
      "caregivers": {
        "title": "Apoyo para cuidadores y compañeros de cuidado",
        "intro": "Usted es esencial en el proceso del trasplante. Su bienestar también importa. Cuidar a un ser querido puede sentirse gratificante, pero también exige mucho física y emocionalmente. Cuídese para poder seguir dando el mejor apoyo.",
        "tipsTitle": "Consejos de autocuidado para cuidadores",
        "tips": [
          "Ponga límites y pida ayuda cuando la necesite",
          "Tome descansos y mantenga sus propias citas médicas",
          "Conéctese con otros cuidadores que entienden su experiencia",
          "Considere la consejería o los grupos de apoyo para cuidadores"
        ],
        "nacAria": "Visitar la National Alliance for Caregiving (se abre en una pestaña nueva)",
        "nacTitle": "National Alliance for Caregiving",
        "nacDesc": "Un grupo nacional sin fines de lucro que apoya a quienes cuidan a un familiar. Encuentre recursos, estudios y apoyo para su labor como cuidador.",
        "nacBadge": "Recurso para cuidadores"
      },
      "remember": {
        "title": "Recuerde",
        "text": "Buscar ayuda para la salud mental es una señal de fortaleza, no de debilidad. El proceso del trasplante exige mucho física y emocionalmente. Cuidar su salud mental es tan importante como tomar sus medicamentos. Si lo está pasando mal, busque apoyo; hay personas que quieren ayudarle."
      }
    },
    "simulator": {
      "title": "Simulador de cambio de seguro",
      "subtitle": "Vea cómo cambian sus opciones de medicamentos al cambiar de seguro",
      "currentLabel": "Seguro actual",
      "futureLabel": "Seguro futuro",
      "selectCurrent": "-- Elija el actual --",
      "selectFuture": "-- Elija el futuro --",
      "cta": "Ver qué cambia",
      "recommendedAction": "📋 Acción recomendada",
      "comingSoon": "Pronto tendremos información detallada de la transición para esta combinación. Contacte a su coordinador de trasplante para recibir orientación.",
      "selectDifferent": "Elija tipos de seguro diferentes para ver los cambios de la transición.",
      "insuranceTypes": {
        "commercial": "Seguro comercial/del empleador",
        "medicare": "Medicare (Parte D)",
        "medicaid": "Medicaid",
        "marketplace": "Mercado de Seguros Médicos (ACA)",
        "uninsured": "Sin seguro"
      },
      "transitions": {
        "commercial_medicare": {
          "title": "Comercial → Medicare",
          "timing": "Común a los 65 años o después de 24 meses con beneficios por incapacidad del Seguro Social (SSDI)",
          "changes": [
            {
              "title": "Tarjetas de copago",
              "desc": "La mayoría de las tarjetas de copago del fabricante NO se permiten con Medicare. Este es un cambio grande."
            },
            {
              "title": "Acceso a los PAP",
              "desc": "Ahora podría calificar para los Programas de Asistencia al Paciente si sus ingresos son lo bastante bajos (muchos tienen límites más altos para pacientes de Medicare)."
            },
            {
              "title": "Ayuda de fundaciones",
              "desc": "Fundaciones como PAN, PANF y HealthWell SÍ pueden ayudar a los pacientes de Medicare con los copagos."
            },
            {
              "title": "Opción Parte B-ID",
              "desc": "Los pacientes de trasplante de riñón pueden calificar para la cobertura de inmunosupresores de la Parte B (Parte B-ID). Prima: $121.60/mes en 2026 (subió de $110.40 en 2025), más 20% de coseguro después del deducible de $283."
            },
            {
              "title": "Límite de 2026",
              "desc": "Límite anual de gastos de bolsillo en medicamentos de la Parte D: $2,100 en 2026 (subió de $2,000 en 2025)."
            }
          ],
          "action": "Solicite los PAP de los fabricantes 3 meses antes de la fecha en que empieza su Medicare. Regístrese temprano con las fundaciones, porque los fondos se acaban."
        },
        "commercial_medicaid": {
          "title": "Comercial → Medicaid",
          "timing": "Por un cambio de ingresos o por discapacidad",
          "changes": [
            {
              "title": "Tarjetas de copago",
              "desc": "Las tarjetas de copago normalmente no se pueden usar con Medicaid."
            },
            {
              "title": "Costo bajo o de $0",
              "desc": "Medicaid normalmente tiene copagos de $0 a $3 por las recetas."
            },
            {
              "title": "Acceso a los PAP",
              "desc": "Algunos PAP siguen disponibles como asistencia secundaria."
            },
            {
              "title": "Medicinas cubiertas",
              "desc": "Puede que necesite cambiar a los medicamentos preferidos de Medicaid o conseguir una autorización previa."
            }
          ],
          "action": "Trabaje con su coordinador de trasplante para asegurarse de que sus medicamentos estén en la lista de medicinas cubiertas de Medicaid antes de cambiar."
        },
        "medicaid_medicare": {
          "title": "Medicaid → Medicare (doble elegibilidad)",
          "timing": "A los 65 años o al calificar para Medicare",
          "changes": [
            {
              "title": "Doble elegibilidad",
              "desc": "Puede calificar como \"doble elegible\" y conservar algunos beneficios de Medicaid junto con Medicare."
            },
            {
              "title": "Extra Help/LIS",
              "desc": "Es probable que califique para el Subsidio por Bajos Ingresos (Extra Help), que cubre la mayoría de los costos de la Parte D."
            },
            {
              "title": "Pagador principal",
              "desc": "Medicare pasa a ser el principal y Medicaid el secundario para los servicios cubiertos."
            },
            {
              "title": "Programas MSP",
              "desc": "Los Programas de Ahorro de Medicare pueden pagar su prima de la Parte B ($202.90/mes en 2026)."
            }
          ],
          "action": "Contacte a su Programa Estatal de Asistencia con el Seguro Médico (SHIP) para recibir consejería gratis sobre los beneficios de doble elegibilidad."
        },
        "commercial_marketplace": {
          "title": "Comercial → Mercado de Seguros (ACA)",
          "timing": "Por pérdida del trabajo, trabajo por cuenta propia o jubilación antes de los 65",
          "changes": [
            {
              "title": "Tarjetas de copago OK",
              "desc": "Las tarjetas de copago del fabricante SÍ se pueden usar con los planes del Mercado de Seguros."
            },
            {
              "title": "Subsidios disponibles",
              "desc": "Los créditos fiscales para las primas, según sus ingresos, pueden reducir mucho los costos."
            },
            {
              "title": "Cambios de red",
              "desc": "Antes de inscribirse, revise que su centro de trasplante y su farmacia estén dentro de la red."
            },
            {
              "title": "Ayuda extra con los costos",
              "desc": "Si sus ingresos son bajos o moderados, elija un plan Silver (plata): el gobierno le baja los deducibles y los copagos automáticamente."
            }
          ],
          "action": "Use healthcare.gov para comparar planes. Filtre por sus medicamentos y sus médicos para encontrar la mejor opción."
        },
        "uninsured_medicare": {
          "title": "Sin seguro → Medicare",
          "timing": "Al cumplir 65 años o al calificar por discapacidad",
          "changes": [
            {
              "title": "Cobertura de medicamentos",
              "desc": "La Parte D da cobertura de recetas con un límite de gastos de bolsillo de $2,100 (2026)."
            },
            {
              "title": "PAP + fundaciones",
              "desc": "Acceso completo a los Programas de Asistencia al Paciente y a la ayuda con copagos de las fundaciones."
            },
            {
              "title": "Tarjetas de descuento",
              "desc": "GoodRx/SingleCare normalmente no se pueden usar una vez que tiene cobertura de la Parte D."
            },
            {
              "title": "Parte B-ID",
              "desc": "Pacientes de riñón: la Parte B-ID cubre los inmunosupresores incluso sin Parte A/B. Prima: $121.60/mes (2026)."
            }
          ],
          "action": "Inscríbase durante su Período Inicial de Inscripción. Solicite Extra Help (LIS) si sus ingresos son limitados."
        },
        "uninsured_medicaid": {
          "title": "Sin seguro → Medicaid",
          "timing": "Si sus ingresos califican (varía según el estado)",
          "changes": [
            {
              "title": "Cobertura",
              "desc": "Cobertura completa que incluye las recetas, muchas veces con copagos de $0 a $3."
            },
            {
              "title": "Retroactiva",
              "desc": "La cobertura puede aplicarse hasta 3 meses antes de la fecha de su solicitud."
            },
            {
              "title": "Medicinas cubiertas",
              "desc": "Debe usar la lista de medicinas cubiertas de Medicaid; puede necesitar aprobación previa para algunos medicamentos de trasplante."
            }
          ],
          "action": "Solicite en la oficina de Medicaid de su estado o en healthcare.gov. Lleve prueba de ingresos y sus papeles del trasplante."
        },
        "uninsured_marketplace": {
          "title": "Sin seguro → Mercado de Seguros (ACA)",
          "timing": "Durante la inscripción abierta o por un evento de vida que califique",
          "changes": [
            {
              "title": "Subsidios",
              "desc": "Ayuda para pagar el seguro según sus ingresos; puede conseguir planes con prima de $0."
            },
            {
              "title": "Tarjetas de copago",
              "desc": "Puede usar la ayuda de las compañías farmacéuticas para lo que debe pagar en los planes del Mercado de Seguros."
            },
            {
              "title": "Condiciones preexistentes OK",
              "desc": "No le pueden negar el seguro ni cobrarle más por su historial de trasplante."
            },
            {
              "title": "Elección del plan",
              "desc": "Si sus ingresos son bajos o moderados, el plan Silver (plata) suele ser la mejor opción: el gobierno le baja los deducibles y los copagos."
            }
          ],
          "action": "Solicite en healthcare.gov durante la Inscripción Abierta (del 1 de noviembre al 15 de enero) o después de un evento que califique."
        }
      }
    },
    "coverage101": {
      "logoAlt": "Transplant Medication Navigator",
      "eyebrow": "Cobertura 101",
      "title": "Cómo se pagan los medicamentos de trasplante.",
      "sub": "Las cuatro formas más comunes en que los pacientes tienen cobertura: qué saber, qué vigilar y qué hacer después.",
      "whoQualifies": "Quién califica",
      "howItWorks": "Cómo funciona",
      "watchFor": "Tenga cuidado con",
      "nextSteps": "Próximos pasos",
      "footnote": "Información educativa solamente. Las reglas de elegibilidad y los detalles de cobertura cambian; verifique con su aseguradora, la oficina de Medicaid de su estado y su equipo de trasplante.",
      "commercial": {
        "eyebrow": "Comercial",
        "name": "Seguro de su trabajo o que usted compró por su cuenta.",
        "tag": "A través de un empleador, el Mercado de Seguros o el plan de su cónyuge, padre o madre.",
        "who": [
          "Empleados de compañías que ofrecen beneficios",
          "Planes comprados por cuenta propia en Healthcare.gov",
          "Dependientes en el plan de un familiar"
        ],
        "how": "Usted paga una prima mensual. El seguro empieza a pagar más cuando usted alcanza su <strong>deducible</strong>. Después, en la farmacia usted paga copagos y coseguro hasta llegar a su <strong>máximo de gastos de bolsillo</strong> (su límite del año); de ahí en adelante, el seguro paga todo lo demás.",
        "warn": "Gastos de bolsillo altos antes de alcanzar su deducible. Redes limitadas. Demoras por autorización previa.",
        "steps": [
          "Revise la lista de medicamentos cubiertos (el 'formulario') de su plan para confirmar que incluya los medicamentos de trasplante.",
          "Conozca su deducible y su máximo de gastos de bolsillo.",
          "Confirme que su centro de trasplante esté dentro de la red."
        ]
      },
      "medicare": {
        "eyebrow": "Medicare",
        "name": "Seguro federal para mayores de 65 años y ciertas discapacidades.",
        "tag": "Incluye la enfermedad renal en etapa terminal y la discapacidad de largo plazo que califica.",
        "who": [
          "Adultos de 65 años o más",
          "Personas con discapacidades que califican (24+ meses con SSDI)",
          "Cualquier persona con enfermedad renal en etapa terminal"
        ],
        "how": "La <strong>Parte A</strong> cubre las estadías en el hospital. La <strong>Parte B</strong> cubre las consultas y tratamientos fuera del hospital, y también sus medicamentos antirrechazo si Medicare ayudó a pagar el trasplante. La <strong>Parte D</strong> cubre la mayoría de los demás medicamentos recetados. Muchos se inscriben en <strong>Medicare Advantage</strong> para tener una cobertura combinada.",
        "warn": "Las primas de la Parte B y la Parte D suman. <strong>Las tarjetas de copago no están permitidas</strong> con Medicare.",
        "steps": [
          "Inscríbase en Medicare Parte A, B y D (o Advantage).",
          "Solicite Extra Help si sus ingresos son limitados.",
          "Revise cada otoño la lista de medicamentos cubiertos (el 'formulario') de su Parte D.",
          "¿Trasplante de riñón? El Medicare por enfermedad renal termina 36 meses después del trasplante. Antes de esa fecha, pregunte al Seguro Social (1-800-772-1213, tienen español) por la Parte B-ID."
        ]
      },
      "medicaid": {
        "eyebrow": "Medicaid",
        "name": "Cobertura estatal y federal para personas con ingresos limitados.",
        "tag": "La elegibilidad, los beneficios y las reglas varían según el estado.",
        "who": [
          "Hogares por debajo del límite de ingresos de su estado",
          "Niños, pacientes embarazadas y personas con discapacidades",
          "Algunas personas con cuidado a largo plazo o exenciones (waivers)"
        ],
        "how": "El estado paga la mayoría de los servicios cubiertos con un costo de bolsillo bajo o de cero. Cada estado maneja su propio programa; sus beneficios, las reglas de recetas y la lista de proveedores dependen de dónde vive.",
        "warn": "Aplican límites de ingresos y de bienes. Si los supera, puede perder la cobertura. Las redes de proveedores pueden ser limitadas. <strong>Las tarjetas de copago no están permitidas</strong>.",
        "steps": [
          "Contacte a la oficina de Medicaid de su estado para solicitar.",
          "Reúna documentos de ingresos, residencia y de su hogar.",
          "Vuelva a verificar su elegibilidad en la fecha de renovación."
        ]
      },
      "selfpay": {
        "eyebrow": "Sin seguro / Pago propio",
        "name": "Pagar usted mismo el costo completo, sin seguro.",
        "tag": "Entre trabajos, antes de Medicare o sin cobertura por otra razón.",
        "who": [
          "Personas entre trabajos o que perdieron su cobertura",
          "Personas que esperan a que empiece Medicare o Medicaid",
          "Cualquier persona sin seguro en este momento"
        ],
        "how": "Usted recibe la cuenta completa de venta al público. Los precios en efectivo de los medicamentos de trasplante pueden ser de cientos a miles de dólares al mes. Los hospitales y las farmacias muchas veces negocian u ofrecen planes de pago si usted lo pide.",
        "warn": "Cuentas muy altas y riesgo de deudas médicas. Algunos pacientes saltan dosis por el costo, y eso pone en peligro el trasplante: pida ayuda antes de saltar una dosis.",
        "steps": [
          "Solicite primero los Programas de Asistencia al Paciente de los fabricantes.",
          "Negocie precios en efectivo y pregunte por planes de pago.",
          "Vuelva a revisar su elegibilidad para Medicaid y los planes del Mercado de Seguros."
        ]
      }
    },
    "generics": {
      "eyebrow": "Seguridad con los medicamentos",
      "title": "Medicinas genéricas vs. de marca",
      "intro": "Los genéricos pueden ahorrarle mucho dinero, y para la mayoría de las medicinas son una opción inteligente y segura. Para los pacientes de trasplante, solo hay una regla importante que los mantiene seguros. Esto es lo que debe saber.",
      "real": {
        "title": "Los genéricos son medicina de verdad",
        "li1": "• Un genérico tiene el <strong>mismo ingrediente activo</strong> que el de marca.",
        "li2": "• La FDA lo aprueba y le exige funcionar de la misma forma.",
        "li3": "• Normalmente cuesta mucho menos.",
        "li4": "• Para la mayoría de las medicinas, elegir el genérico es una forma segura de ahorrar dinero."
      },
      "extraCare": {
        "title": "Los medicamentos de trasplante necesitan cuidado extra",
        "p1": "Los medicamentos antirrechazo como <strong>tacrolimus (Prograf)</strong>, <strong>cyclosporine</strong>,<strong> sirolimus (Rapamune)</strong> y <strong>everolimus</strong> son medicamentos de \"índice terapéutico estrecho\". Eso significa que hasta un cambio pequeño en cuánto llega a su sangre importa:",
        "li1": "• <strong>Muy poco</strong> → su cuerpo podría rechazar el órgano.",
        "li2": "• <strong>Demasiado</strong> → más efectos secundarios y toxicidad.",
        "p2": "Los productos de distintos fabricantes pueden absorberse de forma un poco diferente. Así que el riesgo real no es el genérico en sí. El riesgo es <strong>el cambio</strong> (de marca a genérico, o de un fabricante genérico a otro)."
      },
      "safeWay": {
        "title": "La forma segura de ahorrar con un genérico",
        "li1": "Elija una versión y quédese con ella. Un genérico está bien. Solo mantenga el <strong>mismo fabricante</strong> cada vez que le despachen (resurtan) su receta.",
        "li2": "Pida a su farmacia que siempre le dé el mismo fabricante y que le llame <strong>antes</strong> de cualquier cambio.",
        "li3": "Pida a su médico que escriba el fabricante en su receta (o <strong>\"No sustituir\"</strong> si su equipo quiere la de marca).",
        "li4": "Después de <strong>cualquier</strong> cambio, pida un análisis de sangre dentro de una semana.",
        "li5": "Siempre avise a su equipo de trasplante <strong>antes</strong> de cambiar cualquier cosa."
      },
      "brand": {
        "title": "Cuándo pedir la de marca",
        "intro": "Puede convenirle pedir la de marca si:",
        "li1": "• Sus niveles del medicamento han estado estables con ella.",
        "li2": "• Tuvo problemas después de un cambio anterior.",
        "li3": "• Su centro de trasplante la exige.",
        "appealLink": "Si el seguro dice que no, aprenda a apelar"
      },
      "bottomLine": {
        "title": "En resumen",
        "text": "Los genéricos pueden ahorrarle dinero <strong>y</strong> ser seguros. La clave es la constancia: use la misma versión cada vez y mantenga informado a su equipo de trasplante.<strong> Nunca cambie por su cuenta solo para ahorrar dinero.</strong>"
      },
      "footer": "¿Tiene una pregunta sobre un cambio? Llame a su equipo de trasplante antes de su próximo resurtido (refill)."
    }
  },
  "faq": {
    "cob": {
      "results": {
        "medicare_employer_working": {
          "title": "El seguro de su trabajo paga primero",
          "primary": "El seguro de su empleador",
          "secondary": "Medicare",
          "summary": "¡Buenas noticias! Como usted o su cónyuge todavía trabaja, el seguro del trabajo paga primero. Esto significa que SÍ puede usar tarjetas de copago para bajar sus costos.",
          "tips": [
            "Muestre primero la tarjeta del seguro de su trabajo en la farmacia",
            "Puede usar tarjetas de copago de los fabricantes de medicamentos",
            "Guarde su tarjeta de Medicare como respaldo"
          ]
        },
        "medicare_retiree": {
          "title": "Medicare paga primero",
          "primary": "Medicare",
          "secondary": "Su plan de jubilado",
          "summary": "Como usted se jubiló, ahora Medicare paga primero. No puede usar tarjetas de copago con Medicare. Pero todavía puede recibir ayuda de los Programas de Asistencia al Paciente.",
          "tips": [
            "Solicite Programas de Asistencia al Paciente (PAP) para obtener medicamentos gratis",
            "Averigüe si las fundaciones pueden ayudar con sus costos",
            "Su plan de jubilado ayuda a pagar lo que Medicare no cubre"
          ]
        },
        "medicare_medicaid": {
          "title": "Usted tiene muy buena cobertura",
          "primary": "Medicare + Medicaid",
          "secondary": "Los dos trabajan juntos",
          "summary": "Usted tiene cobertura doble. Esto normalmente significa costos muy bajos o ningún costo por sus medicinas. Medicaid ayuda a pagar lo que Medicare no cubre.",
          "tips": [
            "Sus copagos deberían ser muy bajos o de $0",
            "Asegúrese de que las dos tarjetas estén registradas en su farmacia",
            "Pregunte por \"Ayuda Adicional\" (Extra Help) para bajar los costos aún más"
          ]
        },
        "esrd_employer": {
          "title": "Reglas especiales para pacientes de riñón",
          "primary": "El seguro de su empleador (los primeros 30 meses)",
          "secondary": "Medicare",
          "summary": "Los pacientes de riñón tienen reglas especiales. Durante los primeros 30 meses, el seguro de su trabajo paga primero. Después de 30 meses, Medicare paga primero y ya no puede usar tarjetas de copago. Los 30 meses cuentan desde que usted pudo tener Medicare por enfermedad de los riñones (no desde el trasplante); si no sabe la fecha, llame al 1-800-633-4227.",
          "tips": [
            "Use tarjetas de copago ahora, mientras el seguro de su trabajo paga primero",
            "Marque en su calendario cuándo se cumplen los 30 meses",
            "Planee con tiempo: solicite los PAP antes de que Medicare pase a pagar primero"
          ]
        },
        "not_sure": {
          "title": "Vamos a averiguarlo",
          "primary": "Necesitamos más información",
          "secondary": "",
          "summary": "Las reglas de los seguros pueden ser complicadas. La mejor forma de saberlo con seguridad es llamar a las dos aseguradoras y preguntar: \"¿Qué plan paga primero?\"",
          "tips": [
            "Llame a Medicare: 1-800-633-4227 (1-800-MEDICARE); tienen ayuda en español",
            "Llame a su otra compañía de seguros",
            "Pida ayuda al trabajador social de su equipo de trasplante"
          ]
        }
      },
      "start": {
        "title": "¿Tiene usted dos planes de seguro médico?",
        "subtitle": "Muchos pacientes de trasplante tienen más de un seguro. Este cuestionario le ayuda a saber cuál paga primero.",
        "whyTitle": "¿Por qué importa esto?",
        "whyText": "El seguro que paga primero cambia la ayuda que usted puede recibir. Algunos programas de ahorro solo funcionan con ciertos tipos de seguro.",
        "reasonsTitle": "Razones comunes por las que los pacientes de trasplante tienen dos planes:",
        "reasons": {
          "kidney": "<strong>Enfermedad de los riñones</strong>: Puede recibir Medicare aunque tenga menos de 65 años",
          "disability": "<strong>Incapacidad</strong>: Después de 2 años con beneficios por incapacidad del Seguro Social (SSDI), usted recibe Medicare",
          "working": "<strong>Sigue trabajando a los 65+</strong>: Tiene Medicare Y seguro del trabajo",
          "spouse": "<strong>El seguro de su cónyuge</strong>: El trabajo de su cónyuge también le cubre a usted"
        },
        "startButton": "Comenzar el cuestionario",
        "duration": "Toma alrededor de 1 minuto"
      },
      "progress": "{{current}} de {{total}}",
      "questionLabel": "Pregunta {{number}}",
      "question1": {
        "title": "¿Tiene usted más de un plan de seguro médico?",
        "subtitle": "Por ejemplo: Medicare Y un seguro del trabajo",
        "yes": "Sí, tengo dos o más planes",
        "no": "No, tengo solo un plan",
        "startOver": "Empezar de nuevo"
      },
      "question2": {
        "title": "¿Cuál describe mejor su situación?",
        "subtitle": "Elija la opción que mejor le corresponda",
        "options": {
          "medicare_employer_working": {
            "label": "Tengo Medicare Y seguro del trabajo",
            "detail": "Yo o mi cónyuge todavía trabaja"
          },
          "medicare_retiree": {
            "label": "Tengo Medicare Y seguro de jubilado",
            "detail": "Estoy jubilado pero todavía tengo cobertura de mi antiguo trabajo"
          },
          "medicare_medicaid": {
            "label": "Tengo Medicare Y Medicaid",
            "detail": "Tengo los dos programas del gobierno"
          },
          "esrd_employer": {
            "label": "Tengo Medicare por enfermedad de los riñones Y seguro del trabajo",
            "detail": "Recibí Medicare por insuficiencia renal (ESRD)"
          },
          "not_sure": {
            "label": "No estoy seguro / Otra situación",
            "detail": "Mi situación es diferente"
          }
        },
        "goBack": "Regresar"
      },
      "result": {
        "onePlanTitle": "Usted tiene un solo plan de seguro",
        "onePlanText": "Como tiene solo un plan, no necesita preocuparse por cuál paga primero. Use nuestro cuestionario principal para encontrar programas de ayuda para su situación.",
        "findHelp": "Buscar programas de ayuda",
        "takeAgain": "Hacer el cuestionario otra vez",
        "paysFirst": "PAGA PRIMERO",
        "paysSecond": "PAGA DESPUÉS",
        "copayQuestion": "¿Puede usar tarjetas de copago?",
        "copayCards": "Tarjetas de copago",
        "copayYes": "¡Sí, puede usarlas!",
        "copayNo": "No, no cuando Medicare paga primero",
        "copayDepends": "Depende de su situación",
        "papTitle": "Programas de medicamentos gratis",
        "papYes": "Sí, puede solicitar los PAP",
        "nextTitle": "Qué hacer ahora:"
      }
    },
    "page": {
      "title": "Preguntas frecuentes",
      "subtitle": "Encuentre respuestas a preguntas comunes sobre los medicamentos de trasplante, los programas de asistencia y el uso de este sitio.",
      "searchLabel": "Buscar una pregunta",
      "searchPlaceholder": "Buscar una pregunta...",
      "clearSearch": "Borrar la búsqueda",
      "startHere": "Empiece aquí",
      "startHereText": "¿Es nuevo en la asistencia con medicamentos? Estas cinco preguntas cubren lo básico.",
      "allTopics": "Todos los temas",
      "topicsAria": "Filtrar las preguntas por tema",
      "resultsCount_one": "{{count}} pregunta coincide con su búsqueda",
      "resultsCount_other": "{{count}} preguntas coinciden con su búsqueda",
      "noResultsTitle": "Ninguna pregunta coincide",
      "noResultsText": "Pruebe con otra palabra, o borre la búsqueda para ver todas las preguntas.",
      "emptyTitle": "No hay preguntas frecuentes disponibles",
      "emptyText": "Vuelva más tarde para ver las preguntas frecuentes.",
      "browseResources": "Ver recursos",
      "stillTitle": "¿Todavía tiene preguntas?",
      "stillText": "El trabajador social o el coordinador financiero de su centro de trasplante es su mejor recurso para recibir orientación personalizada.",
      "startQuiz": "Comenzar el cuestionario Mi Camino"
    }
  },
  "applicationHelp": {
    "header": {
      "title": "Educación sobre solicitudes",
      "subtitle": "Domine las solicitudes de asistencia con guía paso a paso y consejos útiles.",
      "quizPromptTitle": "¿No sabe a qué programas solicitar?",
      "quizPromptText": "Haga primero el cuestionario Mi Camino para recibir recomendaciones personalizadas"
    },
    "tabs": {
      "ariaLabel": "Secciones de ayuda con las solicitudes",
      "start": "Cómo empezar",
      "income": "Ingresos",
      "steps": "Pasos",
      "checklist": "Lista",
      "letters": "Cartas",
      "meds": "Medicamentos"
    },
    "start": {
      "goodNews": {
        "title": "Buenas noticias",
        "item1": "Los PAP y las fundaciones piden la misma información.",
        "item2": "Reúna los documentos una sola vez → solicite a varios programas."
      },
      "whatArePaps": {
        "title": "¿Qué son los Programas de Asistencia al Paciente?",
        "p1": "Los Programas de Asistencia al Paciente (PAP) los crean las compañías que fabrican los medicamentos. Ofrecen medicamentos recetados gratis o a bajo costo a las personas que necesitan ayuda para pagarlos.",
        "p2": "<strong>Importante:</strong> Los Programas de Asistencia al Paciente no son solo para quienes no tienen seguro. La mayor\u00eda son para pacientes con Medicare, Medicaid o sin cobertura, y se basan en los ingresos m\u00e1s que en si usted tiene seguro. Los programas var\u00edan, as\u00ed que revise cada uno: si tiene seguro comercial o del trabajo, por lo general su opci\u00f3n es una tarjeta de copago."
      },
      "cards": {
        "pap": {
          "title": "Programas de Asistencia al Paciente",
          "text": "Medicamentos gratis o a bajo costo directamente de la compañía farmacéutica. La mayoría de los programas son para pacientes con Medicare, Medicaid o sin seguro, y lo califican según sus ingresos."
        },
        "copay": {
          "title": "Tarjetas de copago",
          "text": "Las tarjetas de copago del fabricante ayudan a reducir lo que usted paga de su bolsillo en la farmacia.",
          "eligibility": "<strong>Quién puede usar las tarjetas de copago:</strong> Solo con seguro que recibe a través de su trabajo o que compra por su cuenta. No sirven con Medicare, Medicaid ni los beneficios del VA. Si tiene alguno de estos, revise los Programas de Asistencia al Paciente."
        },
        "insurance": {
          "title": "Ayuda para pagar el seguro",
          "text": "Pida a la fundación que le ayude a pagar lo que usted debe a su compañía de seguros para mantener su cobertura médica o de medicamentos recetados."
        }
      },
      "compare": {
        "bestForLabel": "Ideal para:",
        "approvalTimeLabel": "Tiempo de aprobación",
        "pap": {
          "title": "Programa de Asistencia al Paciente (PAP)",
          "subtitle": "Directo del fabricante",
          "description": "Medicamentos gratis o a bajo costo entregados directamente por la compañía farmacéutica.",
          "bestFor": [
            "Pacientes con Medicare",
            "Pacientes con Medicaid",
            "Sin seguro",
            "Con seguro insuficiente"
          ],
          "approvalTime": "2–4 semanas"
        },
        "foundation": {
          "title": "Ayuda económica de una fundación",
          "subtitle": "Asistencia de organizaciones sin fines de lucro",
          "description": "Ayuda con copagos, primas, deducibles y gastos de bolsillo.",
          "bestFor": [
            "Pacientes con Medicare",
            "Pacientes con copagos altos",
            "Primas difíciles de pagar"
          ],
          "approvalTime": "1–3 semanas"
        }
      },
      "safety": {
        "title": "Aviso importante de seguridad",
        "text": "Recuerde: las organizaciones verdaderas NUNCA piden pagos. Si alguien le pide un pago o los datos de su tarjeta de crédito, es una estafa."
      },
      "reminders": {
        "title": "Recordatorios importantes",
        "applyOnceTitle": "Solicite una sola vez",
        "applyOnceText": "Enviar varias solicitudes a la misma fundación retrasa la aprobación.",
        "applyAnytimeTitle": "Solicite en cualquier momento",
        "applyAnytimeText": "No hay \"temporada\". Solicite cuando el costo se vuelva un obstáculo.",
        "peopleHelpTitle": "La gente quiere ayudar",
        "peopleHelpText": "La mayoría de los equipos de los PAP y las fundaciones son amables y pacientes.",
        "faxTitle": "El fax todavía se usa",
        "faxText": "Los formularios enviados por fax llegan directamente a un equipo seguro y dedicado."
      }
    },
    "income": {
      "title": "Quién puede recibir ayuda",
      "intro": "La mayoría de las compañías farmacéuticas publican requisitos de ingresos claros. Esto es lo que necesita saber:",
      "dontCountOut": "No se descarte: muchos programas tienen límites de ingresos mucho más altos de lo que usted imagina.",
      "howLimitsTitle": "Cómo funcionan los límites de ingresos",
      "howLimitsItems": [
        "Se basan en porcentajes del Nivel Federal de Pobreza (FPL). Ejemplo: '400% del FPL' significa ganar hasta 4 veces esa cifra y aún calificar",
        "Varían según el tamaño del hogar",
        "Se actualizan cada año con los cambios del FPL"
      ],
      "whereTitle": "Dónde encontrar los requisitos",
      "whereItems": [
        "El sitio web del fabricante",
        "Los resultados de búsqueda de MAT.org",
        "Llame directamente al programa"
      ],
      "checkerTitle": "Verificador rápido de ingresos",
      "checkerText": "Use estos recursos para consultar las guías actuales del Nivel Federal de Pobreza:",
      "hhsLink": "Pautas de pobreza del HHS",
      "hhsAriaLabel": "Visitar las Pautas de pobreza del HHS (se abre en una pestaña nueva)",
      "phrmaLink": "Asistencia al paciente de PhRMA",
      "phrmaAriaLabel": "Visitar los recursos de asistencia al paciente de PhRMA (se abre en una pestaña nueva)"
    },
    "steps": {
      "title": "Aplique estos principios tanto a los PAP como a las fundaciones",
      "bothRequire": "Ambos piden:",
      "requirements": [
        "Su nombre e información de contacto",
        "Contacto de su médico o coordinador",
        "Ingresos y tamaño del hogar",
        "Diagnóstico + lista de medicamentos",
        "Información del seguro",
        "Historial del paciente"
      ]
    },
    "checklist": {
      "title": "Lista \"Antes de solicitar\"",
      "printAriaLabel": "Imprimir la lista",
      "print": "Imprimir",
      "yourResponsibility": "Su responsabilidad",
      "percentReady": "{{progress}}% listo",
      "progressAriaLabel": "Progreso de preparación de la solicitud: {{progress}} por ciento completado",
      "gatherNote": "Reúna estos documentos antes de solicitar. Haga clic para marcarlos como listos.",
      "itemsAriaLabel": "Elementos de la lista de solicitud",
      "complete": "🎉 ¡Ya tiene todo lo que necesita! Es hora de solicitar.",
      "clinicTitle": "De qué se encarga la clínica",
      "clinicIntro": "Usted <strong>NO</strong> necesita proporcionar esto. Su proveedor lo completará:",
      "clinicItems": [
        "Códigos de diagnóstico ICD-10",
        "Números NPI del proveedor",
        "Firmas del médico que receta",
        "Notas del expediente médico",
        "Fechas de inicio del tratamiento"
      ],
      "crucialTitle": "Paso crucial",
      "crucialText": "Es <strong>importante dar seguimiento</strong> para asegurarse de que el proveedor envíe los documentos de vuelta al programa."
    },
    "letters": {
      "builder": {
        "title": "Creador de cartas",
        "intro": "Elija un tipo de carta, escriba sus datos y genere una carta profesional que puede copiar y usar.",
        "letterTypeLabel": "Tipo de carta",
        "typeAppeal": "Carta de apelación al seguro",
        "typePap": "Carta de reconsideración para un PAP",
        "typeDoctor": "Solicitar el apoyo de su médico",
        "typeHardship": "Declaración de dificultad económica",
        "yourNameLabel": "Su nombre",
        "yourNamePlaceholder": "Su nombre completo",
        "medicationLabel": "Nombre del medicamento",
        "medicationPlaceholder": "Por ejemplo: Tacrolimus",
        "appealReasonLabel": "Motivo de la apelación",
        "reasonFinancial": "Dificultad económica",
        "reasonAccess": "Problemas de acceso (tiempos/entrega)",
        "reasonStability": "Estabilidad clínica (ya está estable)",
        "transplantTypeLabel": "Tipo de trasplante",
        "transplantTypePlaceholder": "Por ejemplo: riñón, hígado, corazón",
        "transplantDateLabel": "Fecha del trasplante (opcional)",
        "transplantDatePlaceholder": "Por ejemplo: enero de 2023",
        "doctorNameLabel": "Nombre del médico",
        "doctorNamePlaceholder": "Por ejemplo: Smith",
        "programNameLabel": "Nombre(s) del programa",
        "programNamePlaceholder": "Por ejemplo: Astellas Patient Assistance",
        "situationLabel": "Describa su situación",
        "situationPlaceholder": "Describa brevemente su situación económica...",
        "generate": "Generar carta",
        "generatedHeading": "Carta generada:",
        "copied": "¡Copiado!",
        "copyText": "Copiar texto"
      },
      "scripts": {
        "title": "Guiones telefónicos",
        "intro": "Use estos guiones cuando llame a los fabricantes y a las fundaciones.",
        "manufacturerTitle": "Para llamar a los fabricantes",
        "manufacturerPre": "\"Soy paciente de trasplante. ¿Tienen un Programa de Asistencia al Paciente para ",
        "manufacturerHighlight": "[nombre del medicamento]",
        "manufacturerPost": "?\"",
        "foundationTitle": "Para llamar a las fundaciones",
        "foundationPre": "\"Hola, llamo para saber si el fondo ",
        "foundationHighlight1": "[nombre del fondo de la enfermedad]",
        "foundationMid": " está abierto en este momento. Tengo seguro, pero necesito ayuda con mis ",
        "foundationHighlight2": "[copagos / primas]",
        "foundationPost": ".\""
      }
    },
    "meds": {
      "title": "Medicamentos y programas PAP",
      "intro": "Vea sus medicamentos junto con sus Programas de Asistencia al Paciente. Busque medicamentos para ver los enlaces de solicitud.",
      "loadedBanner_one": "Cargamos {{count}} medicamento de su cuestionario Mi Camino o de la importación de su sistema de salud. Agregue más medicamentos a continuación o vea los detalles de los programas.",
      "loadedBanner_other": "Cargamos {{count}} medicamentos de su cuestionario Mi Camino o de la importación de su sistema de salud. Agregue más medicamentos a continuación o vea los detalles de los programas.",
      "clearListAriaLabel": "Borrar los medicamentos cargados de su cuestionario Mi Camino o de la importación de su sistema de salud",
      "clearList": "Borrar la lista",
      "searchTitle": "Buscar medicamentos",
      "searchIntro": "Busque sus medicamentos de trasplante para ver la información de sus Programas de Asistencia al Paciente.",
      "searchLabel": "Buscar medicamentos",
      "searchPlaceholder": "Escriba el nombre del medicamento (por ejemplo: Prograf, Tacrolimus)...",
      "searchingAriaLabel": "Buscando",
      "clearSearchAriaLabel": "Borrar la búsqueda",
      "added": "Agregado",
      "add": "Agregar",
      "noMatches": "No se encontraron resultados",
      "noMatchesPre": "Pruebe con otra forma de escribirlo o revise nuestra ",
      "noMatchesLink": "página de búsqueda de medicamentos",
      "noMatchesPost": ".",
      "insurance": {
        "question": "¿Tiene seguro comercial?",
        "explanation": "El seguro comercial es la cobertura que recibe a través de un empleador, del mercado de ACA o que compra por su cuenta; no es Medicare, Medicaid ni TRICARE. Las tarjetas de copago solo están disponibles con seguro comercial, así que esto nos ayuda a mostrarle los programas de ahorro correctos.",
        "yes": "Sí",
        "no": "No",
        "yesInfo": "<strong>¡Las tarjetas de copago pueden ayudarle!</strong> Con seguro comercial, las tarjetas de copago del fabricante pueden bajar su costo a $0-$50 al mes para muchos medicamentos de trasplante.",
        "noInfo": "<strong>Los Programas de Asistencia al Paciente (PAP) pueden ayudarle.</strong> Los fabricantes de medicamentos ofrecen programas de medicamentos gratis para los pacientes que califican según sus ingresos. Las fundaciones también pueden ayudar con los copagos."
      },
      "yourMedications": "Sus medicamentos ({{count}})",
      "cardShows": "Cada tarjeta de medicamento muestra:",
      "cardShowsAssistance": "<strong>Pestaña Asistencia:</strong> programas PAP y tarjetas de copago con enlaces directos para solicitar",
      "cardShowsPrice": "<strong>Pestaña Precio:</strong> costos estimados en diferentes farmacias",
      "cardShowsOverview": "<strong>Pestaña Resumen:</strong> información básica del medicamento",
      "readyTitle": "¿Listo para solicitar?",
      "readyText": "Revise las otras pestañas de esta página para encontrar guía paso a paso para solicitar, listas de verificación y modelos de cartas.",
      "viewSteps": "Ver los pasos de la solicitud",
      "viewChecklist": "Ver la lista",
      "emptyTitle": "Todavía no ha agregado medicamentos",
      "emptyText": "Use el cuadro de búsqueda de arriba para encontrar sus medicamentos, o haga el cuestionario Mi Camino para crear su lista; allí puede conectarse a su sistema de salud para importarlos automáticamente.",
      "takeQuiz": "Hacer el cuestionario Mi Camino",
      "fullSearch": "Búsqueda completa de medicamentos"
    }
  },
  "layout": {
    "notFound": {
      "title": "Página no encontrada",
      "text": "No pudimos encontrar la página que busca. Puede que se haya movido o que ya no exista.",
      "goHome": "Ir al inicio",
      "goHomeAria": "Volver a la página de inicio",
      "startPath": "Comenzar el cuestionario Mi Camino",
      "startPathAria": "Comenzar el cuestionario de asistencia con medicamentos"
    },
    "banner": {
      "urgentText": "¿Se quedó sin medicamento, o le quedan solo unos días?",
      "urgentLink": "Reciba ayuda hoy"
    },
    "skipLink": "Saltar al contenido principal",
    "nav": {
      "brandAriaLabel": "Inicio de Transplant Medication Navigator™",
      "brandLine1": "Transplant Medication",
      "brandLine2": " Navigator",
      "brandTm": "™",
      "logoAlt": "Logotipo de Transplant Medication Navigator",
      "mainAriaLabel": "Navegación principal",
      "mobileAriaLabel": "Navegación móvil",
      "openMenu": "Abrir menú",
      "closeMenu": "Cerrar menú",
      "simpleView": "Letra grande: no",
      "simplePrompt": {
        "ariaLabel": "Opción de tamaño de pantalla",
        "text": "¿Necesita letra más grande? Podemos agrandar todas las páginas.",
        "tryIt": "Activar la letra grande",
        "dismissAria": "Cerrar este mensaje"
      },
      "simpleViewExit": "Letra grande: sí",
      "links": {
        "home": {
          "label": "Inicio",
          "ariaLabel": "Ir a la página de inicio"
        },
        "wizard": {
          "label": "Mi Camino",
          "ariaLabel": "Comenzar el cuestionario Mi Camino de medicamentos"
        },
        "education": {
          "label": "Recursos",
          "ariaLabel": "Explorar recursos, educación y guías de cobertura"
        },
        "applicationHelp": {
          "label": "Cómo solicitar",
          "ariaLabel": "Cómo solicitar ayuda para pagar sus medicamentos"
        },
        "faq": {
          "label": "Preguntas",
          "ariaLabel": "Ver preguntas frecuentes"
        },
        "feedback": {
          "label": "Comentarios",
          "ariaLabel": "Compartir sus comentarios"
        }
      }
    },
    "footer": {
      "disclaimer": "<strong>Aviso:</strong> Esta herramienta ofrece información educativa para ayudarle a encontrar opciones de asistencia con sus medicamentos. No sustituye el consejo médico profesional. Consulte siempre a su equipo de trasplante o a su proveedor de salud si tiene preguntas sobre su afección médica o su tratamiento.",
      "nlm": "Usamos información de la U.S. National Library of Medicine (NLM). La NLM no respalda ni recomienda esta herramienta.",
      "lastUpdated": "Verificado cada tres meses · Última verificación: {{date}}",
      "copyright": "© 2026 Transplant Medication Navigator™. Todos los derechos reservados.",
      "createdBy": "Creado por Lorrinda Gray-Davis · Fundado en agosto de 2025",
      "nondiscrimination": {
        "label": "Aviso de no discriminación:",
        "text": " Conforme a la Sección 504 de la Ley de Rehabilitación de 1973 (Rehabilitation Act of 1973), TransplantNav LLC no discrimina por motivos de discapacidad.",
        "link": "Aviso de la Sección 504 y procedimiento de quejas"
      },
      "links": {
        "terms": "Términos del Servicio",
        "privacy": "Política de privacidad",
        "accessibility": "Accesibilidad y Sección 504",
        "feedback": "Comentarios",
        "hospitals": "Hospitales",
        "pricing": "Planes y precios",
        "evidence": "La evidencia",
        "privacyChoices": "Opciones de privacidad"
      }
    }
  },
  "home": {
    "hero": {
      "title1": "Su equipo de trasplante decide sus medicamentos.",
      "title2": "Nosotros le ayudamos a conseguirlos.",
      "subtitle": "Cuánto debería costar, qué programas podrían estar disponibles para usted y qué hacer cuando su plan cambia las reglas.",
      "cta": "Responda 5 preguntas y vea todas sus opciones",
      "ctaHint": "Unos 2 minutos. Sin nombre y sin cuenta. Revisa tarjetas de copago, programas de asistencia, fundaciones y precios a la vez."
    },
    "flow": {
      "ariaLabel": "Cómo funciona, en tres pasos",
      "step1": "Busque o importe sus medicamentos",
      "step2": "Elija su seguro",
      "step3": "Vea sus opciones"
    },
    "steps": {
      "medsLabel": "1 · Sus medicamentos",
      "searchAriaLabel": "Escriba el nombre de su medicamento para buscar",
      "searchPlaceholder": "Escriba un medicamento...",
      "resultsAriaLabel": "Medicamentos que coinciden",
      "noResults": "Todavía no tenemos ese.",
      "noResultsLink": "Pruebe la búsqueda completa de medicamentos",
      "or": "o",
      "mychartButton": "Importar mi lista desde MyChart",
      "mychartFootnote": "Incluido en el Epic Connection Hub. Iniciará sesión en el portal de su propio hospital — nunca guardamos sus credenciales. Importa su lista real desde más de 400 sistemas de salud con Epic, incluso si usted toma la versión de marca o la genérica. Sus datos se quedan en su dispositivo.",
      "examplesAriaLabel": "Medicamentos comunes de trasplante",
      "tagGeneric": "genérico",
      "tagBrand": "marca",
      "browseAll": "Vea la lista completa de {{count}} medicamentos",
      "browseAllAria": "Vea la lista completa de {{count}} medicamentos",
      "selectedOne": "Su medicamento:",
      "selectedMany": "Sus {{count}} medicamentos:",
      "removeSelected": "Quitar {{name}}",
      "addAnotherHint": "¿Toma más? Busque o toque otro para agregarlo a su lista.",
      "seeOptions": "Ver mis opciones",
      "seeOptionsHint": "Primero elija un medicamento en el paso 1.",
      "insuranceLabel": "2 · Su seguro",
      "insuranceAriaLabel": "Elija su tipo de seguro",
      "insCommercial": "Del trabajo / Mercado de Salud",
      "insMedicare": "Medicare",
      "insMedicaid": "Medicaid",
      "insUninsured": "Sin seguro",
      "multiplePre": "¿Toma más de uno?",
      "multipleLink": "Responda 5 preguntas y los revisamos todos a la vez",
      "previewSummary": "Vea las 5 preguntas primero",
      "previewIntro": "Rápido y anónimo. Unos 2 minutos, sin nombre y sin cuenta.",
      "previewQ1": "Sobre usted: antes o después del trasplante",
      "previewQ2": "Su trasplante: qué órgano",
      "previewQ3": "Sus medicamentos: elíjalos de una lista o impórtelos",
      "previewQ4": "Su cobertura: qué seguro tiene",
      "previewQ5": "Sus costos: qué tan difícil es manejarlos"
    },
    "trust": "{{count}} medicamentos de trasplante · Gratis, sin cuenta · Sus respuestas se quedan en su dispositivo · Creado por una receptora de un trasplante de hígado",
    "explainer": {
      "title": "¿No sabe si toma la marca o el genérico?",
      "intro": "Muchos pacientes de trasplante toman genéricos y nunca se lo dijeron. Su frasco tiene la respuesta, y eso determina qué opciones son suyas.",
      "genericTitle": "Su etiqueta dice “Tacrolimus”",
      "genericText": "Tacrolimus es el nombre propio del medicamento, así que este es el genérico. El frasco suele indicar un fabricante como Sandoz o Accord.",
      "genericAction": "Compare precios en efectivo. No existe tarjeta de copago.",
      "brandTitle": "Su etiqueta dice “Prograf”",
      "brandText": "Prograf es un nombre de marca. La misma medicina, distinto precio, distintos programas.",
      "brandAction": "Tarjeta de copago o asistencia del fabricante.",
      "neverTitle": "Nunca le decimos que cambie su medicamento.",
      "neverText": "Esa es una decisión de su equipo de trasplante — incluido el cambio entre marca y genérico, o entre fabricantes de genéricos. Le mostramos cuánto debería costarle la medicina que le recetaron."
    },
    "cards": {
      "ariaLabel": "Guías y programas",
      "learn": {
        "title": "Aprenda el proceso",
        "text": "Llene las solicitudes de asistencia por su cuenta, gratis. Listas de verificación y guiones para llamadas.",
        "ariaLabel": "Ver la guía de solicitud",
        "link": "Ver la guía"
      },
      "coverage": {
        "title": "Educación sobre cobertura",
        "text": "Medicare Parte B-ID, Parte D, Medicaid, VA y los beneficios de IHS, explicados.",
        "ariaLabel": "Aprenda sobre la cobertura y sus opciones",
        "link": "Aprenda sobre la cobertura"
      },
      "grants": {
        "title": "Ayudas y fundaciones",
        "text": "{{programs}} programas de asistencia y fundaciones, más {{copayCards}} tarjetas de copago. Verificados, con enlaces directos y sin estafas. Actualizado en {{date}}.",
        "ariaLabel": "Explorar programas de ayudas económicas y fundaciones",
        "link": "Explorar programas"
      }
    },
    "story": {
      "ariaLabel": "Historia real de ahorro de un paciente",
      "badge": "Si toma una medicina de marca con seguro médico del trabajo",
      "quotePre": "“Mi receta costaba ",
      "price1": "$624",
      "quoteMid1": ". Con el seguro bajó a ",
      "price2": "$195",
      "quoteMid2": ". Pero nadie me habló de las tarjetas de copago. Encontré una por mi cuenta y ahora pago solo ",
      "price3": "$10",
      "quotePost": ".”",
      "attribution": "Receptora de trasplante de hígado, 2025. Nombre omitido a petición de la paciente. Los ahorros varían según el medicamento y el seguro."
    },
    "testimonial": {
      "ariaLabel": "Testimonio de un paciente",
      "quote": "\u201cEl Transplant Medication Navigator me ha ahorrado dinero y me ha dado tranquilidad. Cuando mi hepatólogo de trasplante cambió uno de mis medicamentos inmunosupresores, pude usar el Navigator allí mismo, durante mi consulta, para ver cuánto podría costar el nuevo medicamento. Pone información valiosa en las manos de los receptores de trasplante justo cuando más la necesitamos.\u201d",
      "name": "Mike Birdsong",
      "role": "Receptor de trasplante de hígado",
      "disclaimer": "Compartido con su permiso. Los ahorros varían según el medicamento y el seguro."
    },
    "evidence": {
      "ariaLabel": "Lo que muestra la investigación",
      "stat": "1 de cada 4",
      "text": "<strong>candidatos a trasplante de hígado gasta más del 10% de sus ingresos en costos médicos — incluso antes de entrar en la lista.</strong> Dos estudios nacionales revisados por pares documentan el problema que esta herramienta busca resolver.",
      "link": "Vea la evidencia"
    },
    "founder": {
      "photoAlt": "Lorrinda Gray-Davis, fundadora de Transplant Medication Navigator",
      "name": "Lorrinda Gray-Davis",
      "role": "Receptora de un trasplante de hígado · Vicepresidenta del Comité de Asuntos del Paciente de la OPTN",
      "bio": "Lorrinda creó esto desde su propia experiencia en el mostrador de la farmacia. Su investigación sobre los costos que enfrentan los pacientes de trasplante está publicada en revistas revisadas por pares.",
      "link": "Lea su historia"
    },
    "hotline": {
      "title": "¿Está luchando con algo más que el costo?",
      "intro": "Ser paciente de trasplante puede ser duro para sus emociones. Puede recibir ayuda gratis y privada a cualquier hora, de día o de noche.",
      "lifeline": "Línea Nacional de Prevención del Suicidio y Crisis",
      "availability": "24/7 • Confidencial",
      "encouragement": "Pedir ayuda es señal de fortaleza, no de debilidad. La vida después de un trasplante es dura para su cuerpo y sus emociones. Cuidar cómo se siente es tan importante como tomar su medicina. ¿Está pasando por un momento difícil? Por favor, busque ayuda. Queremos ayudarle.",
      "callTitle": "Llame o envíe un mensaje de texto",
      "callText": "Marque o envíe un mensaje de texto al <strong>988</strong> desde cualquier teléfono (para atención en español, oprima el 2)",
      "chatTitle": "Chat en línea (también en español)"
    }
  },
  "about": {
    "back": "Volver al inicio",
    "heading": "Creado por alguien que ya pasó por esto",
    "photoAlt": "Lorrinda Gray-Davis, fundadora de Transplant Medication Navigator",
    "name": "Lorrinda Gray-Davis",
    "role": "Sobreviviente de cáncer de hígado, receptora de un trasplante de hígado y presidenta de Transplant Recipients International Organization (TRIO)",
    "bio1": "En 2017, a Lorrinda le diagnosticaron enfermedad hepática terminal y un cáncer de hígado inoperable. Recibió su trasplante de hígado en 2018, y creó Transplant Medication Navigator porque sabe lo que es estar frente al mostrador de la farmacia con un precio que no puede pagar.",
    "bio3": "Es presidenta de Transplant Recipients International Organization (TRIO) y vicepresidenta del Comité de Asuntos del Paciente de la OPTN. También forma parte de dos órganos de HRSA: el Panel de Expertos Técnicos sobre Estándares de Seguridad y Calidad para las Organizaciones de Procuración de Órganos (OPO) y el Comité de Asignación Fuera de Secuencia (AOOS).",
    "stat1Label": "Receptora de trasplante desde",
    "stat4Label": "Trabajos de investigación y presentaciones publicados",
    "credsTitle": "Liderazgo y reconocimientos",
    "credentials": [
      "Vicepresidenta del Comité de Asuntos del Paciente de la OPTN",
      "Miembro del Panel de Expertos Técnicos de HRSA sobre Estándares de Seguridad y Calidad para las Organizaciones de Procuración de Órganos (2025–presente)",
      "Miembro del Comité de Asignación Fuera de Secuencia (AOOS) de HRSA (2025–presente)",
      "Comité de Nominaciones de Transición de HRSA (2025)",
      "Presidenta de TRIO (más de 1,500 miembros)",
      "Harrison Fellow, Fatty Liver Foundation",
      "Grupo Asesor de Pacientes de la AASLD",
      "Carta de reconocimiento de HRSA (2025)",
      "Co-primera autora, Hepatology Communications",
      "Destacada en la revista Cancer Today (2025)"
    ],
    "pubsTitle": "Investigación y presentaciones publicadas (7 publicaciones)",
    "pubsNote": "Los títulos se muestran en inglés porque los trabajos se publicaron en inglés.",
    "badgePeer": "Revista revisada por pares",
    "badgeDistinction": "Póster de distinción",
    "badgePoster": "Póster de congreso",
    "badgeWtc": "World Transplant Congress",
    "pub1Venue": "Hepatology Communications, Vol. 10, núm. 2 (2026) · Co-primera autora",
    "pub2Venue": "Liver Transplantation, 2026 · Primera autora",
    "pub3Venue": "Hepatology, Vol. 82, S1 · AASLD The Liver Meeting 2025 (Washington, DC) · Primera autora",
    "pub4Venue": "Hepatology, Vol. 82, S1 · AASLD The Liver Meeting 2025 (Washington, DC) · Coautora",
    "pub5Venue": "Hepatology, Vol. 80, S1 · AASLD The Liver Meeting 2024 (San Diego, CA) · Primera autora",
    "pub6Venue": "Hepatology, Vol. 80, S1 · AASLD The Liver Meeting 2024 (San Diego, CA) · Primera autora",
    "pub7Venue": "American Journal of Transplantation, Vol. 25, S1 · WTC 2025 (San Francisco, CA) · Coautora",
    "whyTitle": "Por qué creamos esto: la evidencia independiente",
    "whyText": "Dos estudios nacionales revisados por pares documentan lo que esta herramienta busca resolver: 1 de cada 4 candidatos a trasplante de hígado enfrenta una carga económica alta antes de entrar en la lista, y casi el 40% de los receptores de trasplante dejan de surtir sus medicamentos por el costo.",
    "evidenceLink": "Lea la evidencia",
    "learnMore": "Conozca más sobre Lorrinda"
  },
  "evidence": {
    "hero": {
      "title": "La evidencia: por qué importa la navegación de medicamentos y finanzas",
      "intro": "Nuevas investigaciones revisadas por pares confirman lo que los pacientes de trasplante siempre han sabido: el costo de sobrevivir es un problema clínico, no solo personal. Dos estudios nacionales ahora lo documentan a lo largo de todo el camino del trasplante: antes del trasplante, la carga financiera amenaza la candidatura; después del trasplante, el costo de los medicamentos amenaza el órgano trasplantado."
    },
    "burden": {
      "title": "1 de cada 4 candidatos a trasplante de hígado enfrenta una alta carga financiera",
      "intro": "Un estudio multicéntrico de EE. UU. de 2026, publicado en <em>Hepatology Communications</em> — que abarcó más de una docena de centros de trasplante, incluyendo Massachusetts General Hospital, University of Minnesota, USC, Duke y Montefiore Einstein — encuestó a 453 adultos en evaluación para trasplante de hígado. Los hallazgos fueron contundentes:",
      "stat1": "reportó una alta carga financiera: costos médicos de bolsillo del 10% o más del ingreso del hogar",
      "stat2": "seguían con empleo al momento de la evaluación del trasplante",
      "stat3": "de los pacientes con carga alta retrasaron la atención médica o no la recibieron (vs. 33.5% de los pacientes con carga baja)",
      "stat4": "no podían pagar necesidades básicas como comida, calefacción o renta (vs. 11.3%)",
      "stat5": "de los pacientes con carga alta perdieron ahorros o bienes",
      "stat6": "de los pacientes con carga alta enfrentaron deuda médica o bancarrota"
    },
    "odds": {
      "title": "La carga financiera predice angustia en todas las dimensiones",
      "intro": "La carga financiera no es un tema secundario. Después de ajustar por edad, ingresos, seguro, gravedad de la enfermedad y otros factores, los pacientes con alta carga financiera tuvieron probabilidades mucho mayores de sufrir daño:",
      "caption": "Probabilidades ajustadas de angustia financiera para candidatos a trasplante de hígado con carga alta vs. baja",
      "colOutcome": "Resultado",
      "colOdds": "Probabilidades ajustadas",
      "colOddsQualifier": " (carga alta vs. baja)",
      "row1": "Problemas para pagar cuentas médicas",
      "row2": "Pérdida de ahorros o bienes",
      "row3": "Incapacidad de pagar necesidades básicas",
      "row4": "Cualquier angustia financiera material",
      "row5": "Cualquier angustia financiera psicológica",
      "row6": "Cualquier angustia financiera de conducta (retrasar u omitir atención)",
      "row7": "Deuda médica o bancarrota",
      "work": "La carga financiera también llegó al trabajo: los pacientes empleados con alta carga financiera faltaron al trabajo el doble que sus pares con carga baja (34.1% vs. 16.9% de ausentismo). Para los candidatos a trasplante, el empleo no es un detalle menor: a menudo es la fuente del seguro y de los ingresos de los que depende la candidatura."
    },
    "graft": {
      "title": "Después del trasplante, la carga no termina — amenaza el órgano trasplantado",
      "intro": "La encuesta de pacientes más grande jamás encargada por la American Society of Transplantation, publicada en el <em>American Journal of Transplantation</em> en 2025, reunió 10,091 respuestas de receptores de trasplante en 232 centros de trasplante de EE. UU. — abarcando todos los órganos, todas las edades y todos los tipos de seguro, con un promedio de 6.6 años después del trasplante. Sus hallazgos sobre costos deberían alarmar a todo programa de trasplante:",
      "stat1Value": "~40%",
      "stat1Label": "de los receptores dejó de surtir o resurtir un medicamento en el último año debido al costo",
      "stat2Value": "1 de cada 4",
      "stat2Label": "omitió o redujo dosis de inmunosupresores debido al costo, \"a veces\" o \"con frecuencia\"",
      "p1": "Para los receptores de trasplante, estos no son descuidos comunes. Las dosis omitidas de inmunosupresores están entre los factores más fuertes que se conocen de rechazo, pérdida del órgano trasplantado y regreso a la lista de espera — resultados que traen un enorme costo humano y económico para pacientes, programas y aseguradoras por igual.",
      "p2": "Leídos en conjunto, los dos estudios describen un solo camino: la carga financiera que aparece durante la evaluación del trasplante no se resuelve después de la cirugía — se convierte en falta de adherencia por costos que pone en riesgo el órgano trasplantado, años después."
    },
    "gap": {
      "title": "Lo que recomiendan los investigadores — y dónde falla el sistema",
      "quote": "Los autores del estudio concluyen que <strong>la detección rutinaria de la carga financiera es crítica en los candidatos a trasplante de hígado y debe acompañarse de estrategias específicas para reducir su impacto.</strong>",
      "text": "Esa segunda mitad es la brecha. La detección le dice a un programa de trasplante <em>cuáles</em> pacientes se están ahogando. No les lanza una cuerda. Un paciente identificado con carga alta todavía enfrenta un laberinto fragmentado de programas de fabricantes, fundaciones, reglas de seguros y papeleo — el mismo laberinto que hizo que el 66% de los pacientes con carga alta retrasaran o dejaran de buscar atención."
    },
    "tmn": {
      "title": "Transplant Medication Navigator es la estrategia específica",
      "intro": "TMN fue creado para ser la intervención que la investigación pide: el paso entre identificar la carga financiera y resolverla.",
      "s1Title": "Integrado donde ocurre la atención",
      "s1Text": "TMN es una aplicación SMART on FHIR listada en el Epic Connection Hub, con más de 500 descargas de organizaciones, para que la navegación viva dentro del propio flujo de trabajo del centro de trasplante.",
      "s2Title": "Orientación según su seguro",
      "s2Text": "El programa correcto depende de la cobertura. TMN dirige a los pacientes con seguro comercial hacia tarjetas de copago de los fabricantes, y a los pacientes de Medicare hacia programas de asistencia al paciente (PAP) y fundaciones benéficas — dos caminos distintos que los pacientes confunden con frecuencia, y esa confusión les sale cara.",
      "s3Title": "Más allá de los medicamentos",
      "s3Text": "Como la investigación muestra que la carga se extiende a primas, cuentas, viajes y necesidades básicas, TMN también conecta a los pacientes con fundaciones de copago, servicios de manejo de casos y opciones de farmacia de bajo costo como Cost Plus Drugs.",
      "s4Title": "Creado desde la experiencia vivida",
      "s4Text": "Creado por una receptora de trasplante de hígado y defensora nacional de pacientes — diseñado según cómo los pacientes realmente encuentran estas barreras, no como el sistema supone que lo hacen."
    },
    "whyNow": {
      "title": "Por qué esto importa a los programas de trasplante ahora",
      "p1": "La rendición de cuentas basada en valor está llegando al trasplante. El modelo IOTA de CMS ahora vincula el pago de los programas de trasplante de riñón al volumen de trasplantes y a los resultados después del trasplante — y la dirección es clara para todos los órganos. Esta investigación muestra que la carga financiera provoca atención retrasada, ausencias en el trabajo y angustia psicológica: precisamente las fuerzas que erosionan la candidatura, la adherencia y la supervivencia del órgano trasplantado.",
      "p2": "Los programas que detectan la carga financiera sin una respuesta operativa están documentando el riesgo, no manejándolo.",
      "scopeLabel": "Una nota sobre el alcance:",
      "scopeText": " el estudio de carga financiera examinó específicamente a candidatos a trasplante de hígado, por lo que sus cifras exactas no deben asumirse idénticas para otros órganos. La encuesta de la AST, sin embargo, abarcó todos los tipos de órganos sólidos — y su hallazgo de que el costo provoca resurtidos perdidos y dosis omitidas en aproximadamente 4 de cada 10 receptores confirma que el problema abarca todo el trasplante, no un solo órgano.",
      "ctaPrograms": "Vea la solución para programas de trasplante",
      "ctaBriefing": "Solicite una sesión sobre la evidencia"
    },
    "patient": {
      "title": "¿Usted enfrenta estos costos?",
      "p1": "No tiene que navegar el laberinto solo. Haga el cuestionario gratuito de 2 minutos para encontrar tarjetas de copago, programas de asistencia al paciente y ayudas de fundaciones para sus medicamentos.",
      "p2": "Y si ahora no puede trabajar — en el estudio, solo alrededor de 1 de cada 4 candidatos seguía empleado al momento de la evaluación para el trasplante — puede calificar para programas que no sabía que existían.",
      "cta": "Encuentre su camino hacia medicamentos que pueda pagar"
    },
    "sources": {
      "title": "Fuentes",
      "openAccess": "(acceso abierto)",
      "study1Summary": "En resumen: este estudio siguió a 453 candidatos a trasplante de hígado en 13 centros de EE. UU. Casi 1 de cada 4 gastaba más del 10% de sus ingresos en costos médicos, y esa carga se asoció con mucho más estrés económico y con retrasar o saltarse atención médica. (El artículo completo está disponible solo en inglés.)",
      "study2Summary": "En resumen: esta encuesta nacional de más de 10,000 receptores de trasplante encontró que casi el 40% dejó de surtir un medicamento en el último año por el costo, y más de 1 de cada 4 tomó menos dosis de sus medicamentos antirrechazo por la misma razón. (El artículo completo está disponible solo en inglés.)",
      "disclaimer": "Esta página resume investigaciones independientes revisadas por pares. Transplant Medication Navigator no participó en los estudios. Este contenido es educativo y no es consejo médico, legal ni financiero."
    }
  },
  "wizard": {
    "progress": {
      "labels": [
        "Sobre usted",
        "Trasplante",
        "Medicamentos",
        "Cobertura",
        "Costos"
      ],
      "ariaLabel": "Progreso del cuestionario"
    },
    "nav": {
      "back": "Atrás",
      "backAria": "Atrás: volver a la sección anterior",
      "nextSection": "Siguiente sección",
      "nextAria": "Continuar a la siguiente sección"
    },
    "organs": {
      "Kidney": "Riñón",
      "Liver": "Hígado",
      "Heart": "Corazón",
      "Lung": "Pulmón",
      "Pancreas": "Páncreas",
      "Intestine": "Intestino",
      "Multi-organ": "Multiórgano",
      "Other": "Otro"
    },
    "aboutYou": {
      "title": "Sobre usted",
      "intro": "Empecemos con algunos datos básicos para personalizar su experiencia.",
      "note": "<strong>Nota:</strong> Esta herramienta ofrece información educativa para ayudarle a conocer sus opciones de asistencia con los medicamentos. No reemplaza el consejo médico profesional. Consulte siempre a su equipo de trasplante o a su proveedor de salud si tiene preguntas sobre su afección médica o su tratamiento.",
      "roleBadge": "1a",
      "roleQuestion": "¿A quién estoy ayudando hoy?",
      "roleAria": "Seleccione su rol",
      "rolePatient": "Paciente",
      "roleCarepartner": "Cuidador / familiar",
      "roleSocialWorker": "Trabajador social / coordinador",
      "statusBadge": "1b",
      "statusQuestion": "¿En qué parte del proceso de trasplante se encuentra?",
      "statusAria": "Seleccione su etapa del trasplante",
      "statusPreEval": "Antes del trasplante (Evaluación/Lista de espera)",
      "statusPostAcute": "Después del trasplante (Primer año)",
      "statusPostStable": "Después del trasplante (Más de 1 año)",
      "confidenceBadge": "1c",
      "confidenceQuestionSelf": "¿Cuánta confianza tiene en que puede pagar sus medicamentos de trasplante?",
      "confidenceQuestionOther": "¿Cuánta confianza tiene en que la persona a la que ayuda puede pagar sus medicamentos de trasplante?",
      "confidenceAria": "Califique su confianza del 1, ninguna confianza, al 5, mucha confianza",
      "confidenceOptionAria": "{{score}} de 5",
      "confidenceLow": "Ninguna confianza",
      "confidenceHigh": "Mucha confianza",
      "confidenceNote": "Lo preguntamos una vez ahora y otra al final para saber si esta herramienta ayuda. Su respuesta es anónima y nunca se vincula con usted."
    },
    "transplant": {
      "title": "Su trasplante",
      "intro": "Seleccione su tipo de órgano; puede elegir más de uno.",
      "groupAria": "Seleccione los tipos de órgano"
    },
    "meds": {
      "title": "Sus medicamentos",
      "intro": "Conéctese a su sistema de salud (MyChart, el portal de su hospital) para traer su lista de medicamentos.",
      "selectedHeading": "Sus medicamentos seleccionados ({{count}})",
      "removeAria": "Quitar {{name}}",
      "separatorAria": "O agregue sus medicamentos usted mismo",
      "separatorLabel": "O agregue sus medicamentos a continuación",
      "searchHeadingPre": "Escriba el medicamento y presione el botón ",
      "searchHeadingPost": " para agregarlo a su lista",
      "searchLabel": "Buscar medicamentos",
      "searchPlaceholder": "Escriba el nombre del medicamento (p. ej., Prograf, tacrolimus)...",
      "searchingAria": "Buscando",
      "clearSearchAria": "Borrar la búsqueda",
      "added": "Agregado",
      "add": "Agregar",
      "noResults": "No se encontraron medicamentos. Pruebe otra forma de escribirlo o revise la lista a continuación.",
      "medicalInfoTitle": "Información médica importante",
      "medicalInfoText": "Tomar sus medicamentos de por vida es esencial para el éxito del trasplante. Consulte siempre a su equipo de trasplante antes de cambiar sus medicamentos o agregar uno nuevo, incluidas las medicinas sin receta y los suplementos.",
      "continueButton": "Mis medicamentos se ven bien, continuar →",
      "noMedsTitle": "Todavía no ha agregado ningún medicamento",
      "noMedsText": "Sus resultados relacionan los programas con los medicamentos de su lista. Sin uno, las siguientes páginas solo pueden mostrar opciones generales.",
      "noMedsAdd": "Agregar un medicamento",
      "noMedsContinue": "Continuar sin medicamentos",
      "guide": {
        "title": "Medicamentos comunes por tipo de órgano",
        "basedOnPre": "Según su trasplante de ",
        "and": " y ",
        "basedOnPost": ", hemos filtrado los medicamentos más comunes.",
        "selectBelow": "Seleccione sus medicamentos de las opciones a continuación.",
        "selectCore": "Primero seleccione sus inmunosupresores principales y luego agregue cualquier otro medicamento relacionado con su trasplante que usted tome.",
        "clickPre": "Haga clic en un tipo de órgano para ver los medicamentos típicos y luego toque ",
        "addWord": "Agregar",
        "clickPost": " junto a cada uno que usted toma. También puede usar la barra de búsqueda a continuación para encontrar cualquier medicamento.",
        "thMedication": "Medicamento",
        "thClass": "Clase",
        "thNotes": "Notas",
        "thAdd": "Agregar",
        "addToListAria": "Agregar {{name}} a su lista",
        "removeFromListAria": "Quitar {{name}} de su lista"
      },
      "preGuide": {
        "title": "Medicamentos comunes antes del trasplante por tipo de órgano",
        "intro": "Haga clic en un tipo de órgano para ver los medicamentos típicos que se usan antes del trasplante para manejar su condición mientras espera el trasplante.",
        "thClass": "Clase de medicamento",
        "thExamples": "Ejemplos",
        "thPurpose": "Propósito",
        "addedAria": "{{name}} agregado a su lista"
      }
    },
    "coverage": {
      "title": "Su cobertura",
      "tip": "¡Tener seguro no significa que no pueda recibir ayuda adicional!",
      "insuranceBadge": "3a",
      "insuranceQuestion": "¿Qué tipo de seguro médico (plan médico) tiene?",
      "insuranceAria": "Seleccione su tipo de seguro",
      "commercialLabel": "Seguro comercial (plan privado)",
      "commercialDescription": "De mi trabajo, del trabajo de mi cónyuge, o lo compré por mi cuenta",
      "commercialHelp": "Puede usar tarjetas de copago del fabricante + PAP",
      "medicareLabel": "Medicare",
      "medicareDescription": "El programa para personas de 65 años o más o con discapacidades",
      "medicareHelp": "La Parte B-ID (cobertura especial de Medicare para los medicamentos antirrechazo) es importante para pacientes de riñón. Con Medicare puede usar los programas de asistencia al paciente (PAP), pero NO las tarjetas de copago",
      "medicaidLabel": "Medicaid",
      "medicaidDescription": "Programa estatal para personas con ingresos más bajos",
      "medicaidHelp": "Puede tener cobertura completa; revise la lista de medicamentos cubiertos (el 'formulario') de su estado",
      "tricareLabel": "TRICARE o VA (Veteranos)",
      "tricareDescription": "Beneficios militares o para veteranos",
      "tricareHelp": "Con seguro del gobierno puede usar programas de asistencia",
      "ihsLabel": "Indian Health Service (Servicio de Salud Indígena)",
      "ihsDescription": "Programas de salud tribales",
      "ihsHelp": "Puede usar programas de asistencia",
      "uninsuredLabel": "No tengo seguro",
      "uninsuredDescription": "Sin cobertura de seguro en este momento",
      "uninsuredHelp": "Los PAP de los fabricantes son su opción principal",
      "pharmacyBadge": "3b",
      "pharmacyQuestion": "¿Su plan exige una farmacia especializada en específico?",
      "pharmacyIntro": "Algunos planes comerciales le exigen usar una farmacia en específico para los medicamentos de trasplante.",
      "pharmacyAria": "Requisito de farmacia especializada",
      "yes": "Sí",
      "no": "No",
      "notSure": "No estoy seguro"
    },
    "costs": {
      "title": "Sus costos",
      "intro": "¿Cómo describiría los costos actuales de sus medicamentos?",
      "note": "Esto nos ayuda a priorizar los mejores programas de asistencia para usted. Su respuesta es anónima y nunca se vincula con usted.",
      "groupAria": "Seleccione su situación económica",
      "manageableLabel": "Manejables",
      "manageableDesc": "Puedo pagar mis medicamentos, pero me gustaría ahorrar dinero",
      "challengingLabel": "Difíciles, pero los pago",
      "challengingDesc": "Los costos de los medicamentos son una carga pesada",
      "unaffordableLabel": "Casi no puedo pagarlos",
      "unaffordableDesc": "Me cuesta mucho pagar mis medicamentos",
      "crisisLabel": "Ya me he saltado dosis o me he quedado sin medicinas",
      "crisisDesc": "Necesito ayuda ahora mismo para seguir tomando mis medicamentos"
    },
    "results": {
      "backAria": "Atrás: volver al paso anterior",
      "title": "Su estrategia de medicamentos",
      "subtitle": "Según sus respuestas, así puede manejar sus costos.",
      "printAria": "Imprimir su plan de medicamentos",
      "printButton": "Imprimir el plan",
      "bestNextStep": {
        "title": "Siguiente paso",
        "crisis": "Si se le acabó el medicamento o está a punto de acabarse, llame hoy a su equipo de trasplante y use la guía de emergencia. Todo lo demás en esta página puede esperar.",
        "default": "Empiece con el primer programa listado bajo sus medicamentos abajo. Está emparejado con su seguro, y una sola solicitud es suficiente para empezar."
      },
      "medicareAlert": {
        "title": "Importante: Medicare Parte B-ID",
        "text": "Como usted recibió un trasplante de riñón y tiene Medicare, puede calificar para <strong>Medicare Parte B-ID</strong>. Este beneficio cubre los medicamentos inmunosupresores de por vida. En 2026 cuesta <strong>$121.60 al mes</strong> (la prima). Además, cada año usted paga los primeros $283 (el deducible) y después el 20% del costo de cada medicamento; Medicare paga el resto.",
        "cta": "Revise si Califica en Medicare.gov"
      },
      "extraHelp": {
        "title": "Extra Help (Ayuda Adicional) de Medicare es lo que más puede bajar sus costos",
        "text": "<strong>Extra Help</strong> (también llamado Subsidio por Bajos Ingresos) es un programa de Medicare para personas con ingresos y ahorros limitados. Puede eliminar la prima mensual y el deducible de la Parte D y dejarle copagos fijos pequeños por cada receta, genérica o de marca. En 2026 el límite de ingresos es de aproximadamente {{single}} al año para una persona o {{couple}} para una pareja, y muchas personas que califican nunca lo solicitan.",
        "note": "La solicitud en línea con el Seguro Social toma unos 10 minutos, o llame al 1-800-772-1213 (hay atención en español). Si no califica, pregunte si su estado tiene un Programa Estatal de Asistencia Farmacéutica.",
        "cta": "Solicitar Extra Help",
        "ctaAria": "Solicitar Extra Help de Medicare en ssa.gov (se abre en una pestaña nueva)"
      },
      "programs": {
        "title": "Sus programas, por medicamento",
        "subtitle": "Emparejados con su lista de medicamentos y su seguro. Estos son los primeros programas para revisar según la información que usted ingresó.",
        "papBadge": "Medicamento gratis",
        "copayBadge": "Tarjeta de copago",
        "genericBadge": "Genérico",
        "likelyQualify": "Es probable que califique: {{insurance}}, ingresos de hasta {{income}}.",
        "likelyQualifyNoIncome": "Es probable que califique con {{insurance}}; revise los requisitos de ingresos del programa.",
        "checkEligibility": "Consulte con el programa si usted califica.",
        "copayGenericBenefit": "Puede bajar su copago, muchas veces a $0-$50 al mes.",
        "papFallbackName": "Programa de Asistencia al Paciente de {{manufacturer}}",
        "copayFallbackName": "Tarjeta de copago de {{manufacturer}}",
        "applyButton": "Solicitar",
        "applyAria": "Solicitar {{program}} para {{med}} (se abre en una pestaña nueva)",
        "genericNote": "Este es un genérico, y los programas del fabricante suelen ser solo para las versiones de marca. La buena noticia: los genéricos suelen costar mucho menos. Compare precios en efectivo con el enlace de abajo.",
        "noProgramNote": "No tenemos un programa del fabricante en nuestra base de datos para este medicamento. Compare precios en efectivo con el enlace de abajo.",
        "medicareCallout": "Como usted tiene Medicare, las tarjetas de copago del fabricante no aplican para usted (es una regla federal). Use las fundaciones en su lugar:",
        "uninsuredCallout": "Sin seguro, los programas del fabricante de arriba son su mejor ruta. Pueden darle el medicamento completamente gratis si usted califica.",
        "foundationIncome": "Ayuda con copagos, normalmente con ingresos de hasta {{income}}. Los fondos abren y cierran; vuelva a revisar si está cerrado.",
        "foundationIncomeGeneric": "Ayuda con copagos; los requisitos se basan en la necesidad. Los fondos abren y cierran; vuelva a revisar si está cerrado.",
        "foundationAria": "Solicitar en {{program}} (se abre en una pestaña nueva)",
        "othersTitle": "Sus otros medicamentos ({{count}})",
        "othersTitleAll": "Sus medicamentos seleccionados ({{count}})",
        "othersNote": "Estos son genéricos o no tienen programa del fabricante; es normal, y los genéricos suelen costar mucho menos. Compare sus precios en efectivo con el enlace de abajo.",
        "detailsLink": "Vea precios y todos los detalles de estos medicamentos",
        "insuranceLabels": {
          "commercial": "seguro comercial",
          "medicare": "Medicare",
          "medicaid": "Medicaid",
          "uninsured": "sin seguro"
        }
      },
      "medListTitle": "Su lista de medicamentos",
      "addMoreLabel": "Agregar más medicamentos",
      "addMorePlaceholder": "Agregar más medicamentos...",
      "noResults": "No se encontraron medicamentos",
      "viewPricesAria": "Ver precios estimados de sus medicamentos seleccionados",
      "viewPricesButton": "Ver precios estimados de estos medicamentos",
      "toolsTitle": "Herramientas útiles",
      "toolsIntro": "Cuando haya identificado el programa que necesita (PAP o fundación), use nuestra guía para ayudarle a presentar la solicitud.",
      "appEducationAria": "Ver la guía de educación sobre solicitudes",
      "appEducationTitle": "Educación sobre solicitudes",
      "appEducationDesc": "Guiones, listas de verificación y modelos",
      "insuranceAria": "Ver seguro y recursos",
      "insuranceTitle": "Seguro y recursos",
      "insuranceDesc": "Directorio de Medicaid, guías de Medicare",
      "manageable": {
        "title": "Aproveche al máximo sus ahorros",
        "priorityBadge": "Prioridad",
        "priorityAria": "Recomendación prioritaria",
        "copayPre": "Use las tarjetas de ",
        "copayTerm": "copago",
        "copayPost": " del fabricante.",
        "copayText": "Aunque pueda pagar el copago, estas tarjetas pueden bajarlo hasta $0. Busque cada uno de sus medicamentos de marca.",
        "compareBadge": "Compare",
        "compareAria": "Consejo de comparación",
        "cashTitle": "Revise los precios en efectivo.",
        "cashText": "Compare el copago de su seguro con los precios en efectivo en Mark Cuban Cost Plus Drugs o usando GoodRx.",
        "verifyBadge": "Verifique",
        "verifyAria": "Paso de verificación",
        "spTerm": "Farmacia especializada",
        "spPost": ".",
        "spText": "Asegúrese de usar la farmacia que exige su plan para evitar cuentas sorpresa a precio completo.",
        "tipPre": "Consejo: Aún podría calificar para los ",
        "tipTerm": "PAP",
        "tipPost": " según sus ingresos, incluso si ahora los costos le parecen manejables."
      },
      "challenging": {
        "title": "Reduzca su carga",
        "step1Badge": "Paso 1",
        "step1Aria": "Paso uno",
        "papTitle": "Revise los PAP de los fabricantes.",
        "papText": "Solicite sus programas emparejados de arriba; cada botón de Solicitar va directo al programa del fabricante. Si califica, el medicamento es gratis.",
        "papTitleGeneric": "Revise primero los precios de los genéricos.",
        "papTextGeneric": "Los PAP de los fabricantes suelen ser solo para medicamentos de marca, y sus medicamentos son genéricos. La buena noticia: los genéricos suelen costar mucho menos. Pida el precio en efectivo en su farmacia y compárelo en el Paso 3.",
        "step2Badge": "Paso 2",
        "step2Aria": "Paso dos",
        "foundationsPre": "Solicite ayuda a las ",
        "foundationsTerm": "fundaciones",
        "foundationsPost": " de copago.",
        "foundationsText": "Organizaciones como HealthWell o TotalAssist ayudan a pagar los copagos. Presente su solicitud en el fondo de su enfermedad específica.",
        "step3Badge": "Paso 3",
        "step3Aria": "Paso tres",
        "cashTitle": "Compare con el precio en efectivo.",
        "cashText": "A veces el precio en efectivo (p. ej., Cost Plus Drugs) es más barato que el copago de su seguro."
      },
      "crisis": {
        "title": "Camino de asistencia inmediata",
        "callTeamTitle": "Llame hoy a su equipo de trasplante o a su farmacia",
        "callTeamText": "Si no puede pagar su medicamento ahora mismo, el trabajador social o el farmacéutico de su equipo de trasplante muchas veces puede conseguirle un suministro de emergencia o una ayuda puente el mismo día.",
        "notEmergency": "Este cuestionario es educativo y no es un servicio de emergencia. Si cree que puede tener una emergencia médica, llame a su médico o al 911.",
        "emergencyLink": "¿Se quedó sin medicamento o le quedan solo unos días? Vea los pasos de emergencia →",
        "notAlone": "Usted no está solo. Hay ayuda disponible. Por favor, siga estos pasos en orden.",
        "papTitle": "PAP de los fabricantes (medicamento gratis).",
        "papText": "Sus programas emparejados están arriba, en \"Sus programas, por medicamento\": solicite hoy el programa del fabricante de cada uno. Si califica, el medicamento es gratis.",
        "papTitleGeneric": "Genéricos de bajo costo.",
        "papTextGeneric": "Los programas de los fabricantes suelen ser limitados para medicamentos genéricos. Revise las reglas actuales de cada programa y compare las fundaciones y los precios en efectivo (p. ej., Cost Plus Drugs). Su equipo de trasplante también puede ayudar.",
        "papLinkText": "Vea precios y todos los detalles",
        "papLinkPost": " de cada uno de sus medicamentos.",
        "papLinkPostGeneric": " para comparar los precios en efectivo.",
        "medicaidTitle": "Revise si califica para Medicaid.",
        "medicaidText": "Si tiene ingresos bajos, revise si califica para el Medicaid de su estado o para \"Extra Help\" (Ayuda Adicional, si tiene Medicare).",
        "ihsTitle": "Contacte al IHS / Salud Tribal.",
        "ihsText": "Es probable que tenga cobertura para estos medicamentos a costo $0 en los centros del IHS.",
        "notQualifyTitle": "Si no califica — o si un fondo está cerrado",
        "notQualifyIntro": "Un “no” de un programa no es el final. Pruebe estas opciones:",
        "tryPrograms": "<strong>Solicite en varios programas a la vez.</strong> Los límites de ingresos y los fondos abiertos cambian con frecuencia, así que no se quede con uno solo.",
        "tryCharity": "<strong>Pregunte en su centro de trasplante por la atención caritativa.</strong> Muchos centros tienen sus propios programas de asistencia económica o de descuento del hospital — su trabajador social puede iniciar uno.",
        "tryCash": "<strong>Pregunte en la farmacia por los precios en efectivo y los precios según sus ingresos.</strong> Cost Plus Drugs y los programas de descuento de farmacias a veces son más baratos que un copago.",
        "appealTitle": "Apele una denegación.",
        "appealMid": " Muchas denegaciones se revierten. ",
        "appealLink": "Vea cómo apelar",
        "appealPost": ".",
        "getHelpLink": "Obtenga ayuda paso a paso para solicitar →"
      },
      "confidence": {
        "title": "Una última pregunta",
        "questionSelf": "Ahora que tiene su plan, ¿cuánta confianza tiene en que puede pagar sus medicamentos de trasplante?",
        "questionOther": "Ahora que tiene el plan, ¿cuánta confianza tiene en que la persona a la que ayuda puede pagar sus medicamentos de trasplante?",
        "aria": "Califique su confianza ahora, del 1, ninguna confianza, al 5, mucha confianza",
        "thanks": "Gracias. Su respuesta nos ayuda a mejorar esta herramienta.",
        "before": "Antes",
        "now": "Ahora",
        "note": "Anónimo y nunca vinculado con usted."
      },
      "restart": "Reiniciar el cuestionario",
      "restartAria": "Reiniciar el cuestionario desde el principio"
    },
    "email": {
      "errorRequired": "Por favor, escriba su correo electrónico",
      "errorInvalid": "Por favor, escriba un correo electrónico válido"
    },
    "loading": "Cargando..."
  },
  "appeals": {
    "header": {
      "back": "Volver a Educación y recursos",
      "title": "¿Le negaron? No se rinda.",
      "tagline": "¡Usted puede defenderse y GANAR!",
      "intro": "El seguro le dice \"no\" a casi todo el mundo en algún momento. ¿La buena noticia? <strong>Muchas personas ganan cuando apelan.</strong> Esta guía interactiva le muestra cómo hacerlo, paso a paso.",
      "stats": {
        "winRate": "40-75%",
        "winRateLabel": "De las denegaciones apeladas se revierten",
        "days": "60+",
        "daysLabel": "Días para apelar — su carta indica su fecha límite",
        "free": "Gratis",
        "freeLabel": "Presentar una apelación",
        "sourcesIntro": "Fuentes: ",
        "source1": "HHS OIG (2018): los planes Medicare Advantage revirtieron el 75% de las denegaciones apeladas",
        "source2": "KFF: cerca de 4 de cada 10 denegaciones apeladas en el Mercado se revirtieron",
        "deadlineNote": "Las fechas límite dependen de su plan: Medicare da 65 días y muchos planes del trabajo y del Mercado dan hasta 180; su carta de denegación indica su fecha límite exacta."
      },
      "guideTitle": "Guía de apelaciones gratis",
      "guideSubtitle": "Guía lista para imprimir con listas de verificación y modelos de cartas",
      "guideDownload": "Descargar la guía gratis (en español)"
    },
    "nav": {
      "ariaLabel": "Secciones de la página",
      "prompt": "Haga clic en cualquier sección para explorarla:",
      "whyDenied": "¿Por qué negaron?",
      "stepTherapy": "Terapia escalonada",
      "generics": "Genérico vs. de marca",
      "howToAppeal": "Cómo apelar"
    },
    "whyDenied": {
      "title": "Por qué el seguro dice que no",
      "intro": "Su carta de denegación le dice por qué dijeron que no. Estas son las razones más comunes:",
      "reasons": {
        "priorAuth": {
          "title": "Necesita autorización previa",
          "description": "Su médico necesita pedir permiso primero antes de que el seguro lo cubra."
        },
        "notOnList": {
          "title": "No está en la lista",
          "description": "Su medicamento no está en la lista de medicamentos que su seguro cubre (en inglés la llaman \"formulary\")."
        },
        "stepTherapy": {
          "title": "Pruebe otra cosa primero",
          "description": "Quieren que primero pruebe un medicamento más barato (terapia escalonada)."
        },
        "quantityLimits": {
          "title": "Límites de cantidad",
          "description": "Dicen que usted está recibiendo demasiado de este medicamento."
        },
        "generic": {
          "title": "Use el genérico",
          "description": "Quieren que use una versión genérica más barata."
        }
      },
      "remember": "Recuerde: una denegación NO es la respuesta final. Es solo el primer \"no\", ¡y usted puede pelearla!"
    },
    "stepTherapy": {
      "title": "Terapia escalonada: \"Pruebe esto primero\"",
      "intro": "La <strong>terapia escalonada</strong> significa que su seguro quiere que pruebe un medicamento más barato antes de pagar por el que su médico eligió. Algunas personas lo llaman \"fallar primero\".",
      "risky": {
        "title": "Por qué esto puede ser riesgoso",
        "items": [
          "Los medicamentos antirrechazo necesitan niveles exactos en la sangre. Los cambios pequeños importan mucho.",
          "Probar el medicamento equivocado podría dañar su trasplante.",
          "Su equipo de trasplante eligió su medicamento por buenas razones.",
          "Cambiar significa más pruebas de sangre y visitas al médico."
        ]
      },
      "canDo": {
        "title": "Lo que usted puede hacer",
        "items": [
          "Puede pedirles que no le apliquen la terapia escalonada.",
          "Los medicamentos de trasplante muchas veces se aprueban cuando su médico explica por qué.",
          "Una carta de su médico de trasplante ayuda mucho.",
          "Muchos estados tienen leyes que protegen a los pacientes."
        ]
      },
      "proTip": "Consejo: pregúntele a su médico por la \"excepción a la terapia escalonada\", ¡su médico puede pedirla en su nombre!"
    },
    "generics": {
      "title": "Medicamentos genéricos vs. de marca",
      "basics": {
        "title": "Lo básico",
        "items": [
          "Los medicamentos genéricos tienen el mismo ingrediente principal que los de marca.",
          "La FDA dice que funcionan de la misma manera.",
          "Para la mayoría de los medicamentos, los genéricos están bien."
        ]
      },
      "different": {
        "title": "Por qué los medicamentos de trasplante son diferentes",
        "intro": "Los medicamentos antirrechazo son especiales. Hasta los cambios más pequeños pueden causar problemas:",
        "tooLittle": "<strong>Muy poco:</strong> Su cuerpo podría rechazar el trasplante",
        "tooMuch": "<strong>Demasiado:</strong> Efectos secundarios y toxicidad"
      },
      "brandNeed": {
        "title": "Cuándo podría necesitar el de marca",
        "items": [
          "Sus niveles del medicamento han estado estables con esta marca",
          "Tuvo problemas cuando cambió antes",
          "Su centro de trasplante exige el de marca",
          "A su cuerpo le cuesta absorber el medicamento"
        ]
      }
    },
    "howToAppeal": {
      "title": "Cómo apelar: paso a paso"
    },
    "tracker": {
      "progressLabel": "Su progreso",
      "progress": "{{completed}} de {{total}} pasos",
      "instruction": "¡Haga clic en cada paso cuando lo haya completado para seguir su progreso!",
      "tipLabel": "Consejo:",
      "steps": [
        {
          "title": "Pídalo por escrito",
          "description": "Pida una carta que diga exactamente por qué dijeron que no. La necesita para saber qué decir en su apelación.",
          "tips": "Llame al número de su tarjeta del seguro y pida una 'carta de denegación por escrito' o una 'explicación de beneficios'."
        },
        {
          "title": "Esté pendiente del tiempo",
          "description": "Tiene al menos 60 días para apelar; su carta de denegación indica su fecha límite exacta. Marque la fecha en su calendario. No la deje pasar.",
          "tips": "¡Ponga un recordatorio en su teléfono 2 semanas antes de la fecha límite!"
        },
        {
          "title": "Reúna sus papeles",
          "description": "Pida a su equipo de trasplante: una carta de su médico, sus registros del trasplante, resultados recientes de laboratorio y notas sobre por qué otros medicamentos no funcionarán.",
          "tips": "¡Use el creador de cartas a continuación para ayudar a su médico a escribir una carta de apoyo!"
        },
        {
          "title": "Envíe su apelación",
          "description": "Envíe todo junto. Guarde copias de todo lo que envíe.",
          "tips": "Envíelo por fax o por correo certificado para tener prueba de que lo recibieron."
        },
        {
          "title": "Pida una revisión rápida si la necesita",
          "description": "Si su medicina se le va a acabar pronto, pida una revisión acelerada (rápida). Para los medicamentos de trasplante, esto casi siempre cuenta como urgente.",
          "tips": "Diga: 'Necesito una apelación acelerada porque quedarme sin mi medicamento de trasplante pone en riesgo mi vida.'"
        },
        {
          "title": "Sepa qué viene después",
          "description": "Si vuelven a decir que no, puede pedir una revisión externa hecha por alguien fuera de la compañía. La oficina de seguros de su estado también puede ayudar.",
          "tips": "No se rinda después de la primera denegación de la apelación, ¡las revisiones externas muchas veces cambian las decisiones!"
        }
      ],
      "congratsTitle": "¡Felicidades! ¡Completó todos los pasos!",
      "congratsText": "Va por muy buen camino para ganar su apelación. ¡Ánimo, no se rinda!"
    },
    "letter": {
      "title": "Escriba una carta para su médico",
      "subtitle": "Pídale a su médico que le ayude con su apelación",
      "why": "<strong>¿Por qué escribirle a su médico?</strong> Su médico tiene el conocimiento médico para explicar por qué usted necesita su medicamento específico. Una carta de necesidad médica de su médico muchas veces es la clave para ganar una apelación.",
      "note": "<strong>Nota:</strong> Su médico ya tiene acceso a un modelo detallado de carta de necesidad médica. Esta carta es para que <em>usted</em> le pida su ayuda y le dé la información que necesita.",
      "yourName": "Su nombre",
      "yourNamePlaceholder": "Su nombre completo",
      "doctorName": "Nombre del médico",
      "doctorNamePlaceholder": "p. ej., Smith",
      "medicationName": "Nombre del medicamento",
      "medicationNamePlaceholder": "p. ej., Tacrolimus, Prograf",
      "transplantType": "Tipo de trasplante",
      "transplantTypePlaceholder": "p. ej., riñón, hígado, corazón",
      "transplantDate": "Fecha del trasplante ",
      "transplantDatePlaceholder": "p. ej., enero de 2023",
      "denialReason": "Motivo de la denegación ",
      "denialReasonPlaceholder": "p. ej., no está en el formulario (la lista de medicamentos cubiertos), exigen terapia escalonada",
      "additionalInfo": "Información adicional ",
      "additionalInfoPlaceholder": "Cualquier otro detalle que pueda ayudar a su médico (p. ej., reacciones previas a medicamentos, por qué necesita este medicamento específico, etc.)",
      "optional": "(opcional)",
      "ifKnown": "(si lo sabe)",
      "blankPrompt": "¿Prefiere no escribir sus datos en línea? Descargue una carta en blanco para imprimirla y llenarla a mano.",
      "blankButton": "Descargar carta en blanco (instrucciones en español)",
      "englishNote": "Su carta se genera en inglés porque va dirigida a su compañía de seguros.",
      "generate": "Generar mi carta",
      "previewTitle": "Su carta para el Dr. ",
      "doctorFallback": "[Nombre del médico]",
      "copied": "¡Copiado!",
      "copyText": "Copiar texto",
      "nextStep": "<strong>Siguiente paso:</strong> Imprima esta carta o envíela por correo electrónico a su médico junto con una copia de su carta de denegación."
    },
    "resources": {
      "title": "Recursos gratis para descargar",
      "subtitle": "Imprima estas guías para ayudarle con su apelación",
      "appealGuide": {
        "title": "Guía completa de apelaciones",
        "description": "Instrucciones paso a paso, listas de verificación, modelos de cartas y consejos para ganar su apelación. Escrita en lenguaje sencillo.",
        "items": [
          "Listas de verificación para imprimir",
          "Modelo de carta de apelación",
          "Guiones para llamar al seguro por teléfono"
        ],
        "download": "Descargar la guía de apelaciones (en español)"
      },
      "doctorTemplate": {
        "title": "Modelo de carta para el médico",
        "description": "Compártalo con su médico de trasplante. Un modelo de carta de necesidad médica listo para usar que puede personalizar para su apelación.",
        "items": [
          "Formato médico profesional",
          "Referencias a guías clínicas",
          "Secciones para llenar los espacios"
        ],
        "download": "Descargar el modelo gratis (instrucciones en español)"
      }
    },
    "spGuide": {
      "title": "Guía de farmacias especializadas",
      "subtitle": "Conozca sus derechos y opciones cuando su seguro lo obliga a usar cierta farmacia.",
      "builder": {
        "title": "Creador de cartas de apelación para farmacia especializada",
        "intro": "Llene sus datos a continuación para crear una carta que puede copiar y enviar a su compañía de seguros.",
        "yourName": "Su nombre",
        "yourNamePlaceholder": "Su nombre",
        "medicationName": "Nombre del medicamento",
        "medicationNamePlaceholder": "Nombre del medicamento",
        "reason": "Motivo de la apelación",
        "reasonFinancial": "Dificultad económica",
        "reasonAccess": "Problemas de acceso (horarios/entrega)",
        "reasonClinical": "Estabilidad clínica (ya está estable)",
        "generate": "Generar carta",
        "generateAria": "Generar carta de apelación para farmacia especializada",
        "preview": "Vista previa:",
        "copyAria": "Copiar el texto de la carta al portapapeles"
      },
      "howTo": {
        "title": "Cómo apelar: una guía paso a paso",
        "medicare": {
          "title": "Apelaciones de Medicare",
          "note": "Importante: actúe a tiempo.",
          "step1": "<strong>Decisión de cobertura:</strong> Pida a su plan que pague por la farmacia que usted elija.",
          "step2": "<strong>Nivel 1 (segunda revisión):</strong> Si dicen que no, tiene 65 días desde la fecha de la carta de denegación para presentar su apelación.",
          "step3": "<strong>Nivel 2 (revisión externa):</strong> Un grupo externo revisa su caso si le niegan otra vez.",
          "link": "Guía oficial de Medicare",
          "linkAria": "Visitar la Guía oficial de Medicare (se abre en una pestaña nueva)"
        },
        "medicaid": {
          "title": "Apelaciones de Medicaid",
          "text": "Cada estado maneja sus propias apelaciones. Llame a la oficina de Medicaid de su estado."
        },
        "private": {
          "title": "Seguro privado",
          "text": "Puede pedirle a su compañía que lo revise otra vez. Si siguen diciendo que no, puede pedir una revisión externa."
        }
      }
    },
    "footer": {
      "title": "Recuerde: usted no está solo",
      "text": "Miles de pacientes de trasplante apelan sus denegaciones con éxito cada año. Su salud importa, y usted tiene todo el derecho de luchar por los medicamentos que necesita. ¡Ánimo, y no se rinda!"
    }
  },
  "medications": {
    "search": {
      "title": "Buscar medicamentos",
      "subtitle": "Busque sus medicamentos para crear una lista de precios que puede compartir.",
      "safety": {
        "title": "Nota de seguridad importante para pacientes de trasplante",
        "text": "Nunca cambie de un medicamento de marca a uno genérico (ni entre genéricos de diferentes fabricantes) sin la aprobación de su equipo de trasplante. En los medicamentos de trasplante, un cambio pequeño en la cantidad de medicina que llega a la sangre (la 'biodisponibilidad') puede causar el rechazo del órgano. <strong>\"Más barato\" no siempre es \"seguro\"</strong> si el fabricante cambia.",
        "link": "Conozca los genéricos frente a los de marca "
      },
      "inputLabel": "Buscar medicamentos",
      "placeholder": "Escriba el nombre del medicamento (p. ej., Prograf, Ozempic)...",
      "instructions": "Escriba el nombre del medicamento y presione Enter o haga clic en el botón de búsqueda",
      "searchingAria": "Buscando",
      "clearAria": "Borrar la búsqueda",
      "button": "Buscar",
      "loadingResultsAria": "Cargando los resultados de la búsqueda",
      "searchingText": "Buscando medicamentos...",
      "resultsAria": "Resultados de la búsqueda",
      "helpBanner": "La ayuda está aquí; encontrémosla juntos. Escriba sus medicamentos y buscaremos ahorros, programas de asistencia al paciente, ayudas económicas y opciones de farmacias con buenos precios.",
      "resultsHeading": "Resultados de la búsqueda",
      "alreadyAddedAria": "Ya agregado",
      "added": "Agregado",
      "add": "Agregar",
      "noMatches": "No hay resultados en nuestra base de datos de trasplante",
      "noMatchesHint": "Pruebe con otra forma de escribirlo o use la opción a continuación para agregarlo como medicamento personalizado.",
      "addCustomLabel": "Agregar \"{{term}}\" a la lista",
      "checkExternal": "Consultar el precio en sitios externos",
      "addCustom": "Agregar personalizado",
      "addAsCustom": "Agregar \"{{term}}\" como medicamento personalizado",
      "emptyTitle": "Su lista está vacía",
      "emptyText": "Busque arriba para agregar medicamentos a su lista, o elija uno de la lista completa de abajo. Puede agregar medicamentos comunes de trasplante o cualquier otro medicamento que tome.",
      "browseAllTitle": "Vea los {{count}} medicamentos, de la A a la Z",
      "browseAllText": "Todos los medicamentos de nuestra base de datos. Abra uno para ver sus precios y los programas que ayudan a pagarlo."
    },
    "verify": {
      "title": "Sus medicamentos",
      "subtitle": "Estos son los medicamentos que usted seleccionó.",
      "printAria": "Imprimir su lista de medicamentos",
      "print": "Imprimir",
      "alertTitle": "Por favor verifique sus medicamentos",
      "alertText": "Revise con cuidado la lista de medicamentos a continuación. Si toma otros medicamentos de trasplante que no aparecen, agréguelos con el cuadro de búsqueda.",
      "alertNote": "La información correcta de sus medicamentos nos ayuda a encontrar las mejores opciones de ahorro para usted.",
      "addMoreLabel": "Agregar más medicamentos",
      "addMorePlaceholder": "Agregar otro medicamento...",
      "removeAria": "Quitar {{name}}",
      "ready": {
        "title": "¿Listo para encontrar ahorros?",
        "text": "Haga clic en el botón <strong>\"Opciones para ahorrar en sus medicamentos\"</strong> a continuación para ver dónde puede ahorrar dinero en cada medicamento. Le mostraremos tarjetas de copago, programas de asistencia al paciente, farmacias de descuento y más."
      },
      "savingsButton": "Opciones para ahorrar en sus medicamentos",
      "selectInsuranceFirst": "Por favor seleccione arriba su tipo de seguro para continuar",
      "back": "Volver a los medicamentos",
      "options": {
        "title": "Sus opciones",
        "howToRead": "Cómo leer esta página",
        "subtitle": "Cada tarjeta muestra uno de sus medicamentos. Haga clic en las pestañas para ver:",
        "assistance": "Asistencia",
        "assistanceDesc": "Programas de medicina gratis y tarjetas de copago",
        "price": "Precio",
        "priceDesc": "Los estimados varían según las pastillas recetadas o la dosis",
        "overview": "Resumen",
        "overviewDesc": "Información básica sobre el medicamento",
        "print": "Imprimir",
        "printDesc": "Resumen fácil de imprimir"
      },
      "fpl": {
        "aria": "Referencia de elegibilidad por ingresos",
        "title": "100% del Nivel Federal de Pobreza (ingreso anual)",
        "familyOf_one": "1 persona:",
        "familyOf_other": "Familia de {{size}}:",
        "dontDisqualify": "No asuma que no califica",
        "papRange": ", los Programas de Asistencia al Paciente (PAP) a menudo aceptan ingresos de hasta 3, 4 o hasta 5 veces estas cantidades. Si no está seguro, solicite de todos modos: no cuesta nada."
      },
      "help": {
        "title": "¿Necesita ayuda para solicitar asistencia?",
        "text": "Aprenda paso a paso cómo llenar las solicitudes de los Programas de Asistencia al Paciente.",
        "aria": "Ayudas económicas y fundaciones: guía de solicitudes paso a paso",
        "button": "Ayudas económicas y fundaciones"
      }
    },
    "insurance": {
      "heading": "¿Cuál es su tipo de seguro médico (plan médico)?",
      "text": "Necesitamos saber su tipo de seguro para mostrarle las opciones de ahorro correctas. Las tarjetas de copago solo están disponibles para el seguro comercial, mientras que otros programas varían según la cobertura.",
      "selectAria": "Seleccionar {{label}} como su tipo de seguro",
      "options": {
        "commercial": "Comercial / Del empleador",
        "medicare": "Medicare",
        "medicaid": "Medicaid (estatal)",
        "tricare_va": "TRICARE / VA",
        "ihs": "Indian Health Service (Servicio de Salud Indígena)",
        "uninsured": "Sin seguro / Pago por cuenta propia"
      }
    },
    "priceReport": {
      "errorInvalid": "Por favor escriba un precio válido mayor de $0",
      "errorSaving": "Error al guardar el reporte de precio. Por favor intente de nuevo.",
      "title": "Reportar un precio",
      "via": "{{name}} vía {{source}}",
      "closeAria": "Cerrar el cuadro de diálogo",
      "priceLabel": "Precio pagado (USD) ",
      "locationLabel": "Farmacia/Lugar (opcional)",
      "locationPlaceholder": "p. ej., CVS en Seattle, WA",
      "dateLabel": "Fecha de compra",
      "note": "Su reporte ayuda a otros pacientes de trasplante a estimar los costos. Los datos se guardan solamente en su dispositivo.",
      "cancel": "Cancelar",
      "submitting": "Enviando...",
      "submit": "Enviar reporte"
    },
    "card": {
      "cash": {
        "badge": "PRECIO EN EFECTIVO MÁS BAJO",
        "source": {
          "costplus": "Mark Cuban Cost Plus Drugs",
          "goodrx": "Precio con descuento de GoodRx",
          "singlecare": "Precio con descuento de SingleCare"
        },
        "text": "Ninguna tarjeta de copago del fabricante le aplica, pero el precio en efectivo muchas veces es más bajo que un copago. No necesita seguro para usarlo.",
        "compare": "Compare los precios de todas las farmacias",
        "sourceTypical": "Precio en efectivo típico para este tipo de medicamento",
        "estimateTypical": "Es un rango típico para esta clase de medicamento, no un precio para este medicamento. Compare los precios actuales antes de comprar.",
        "estimate": "Solo es un estimado; el precio de su farmacia puede ser diferente."
      },
      "perMo": "/mes",
      "trumpRxGuideHref": "/es/trumprx",
      "context": {
        "insuranceLabel": "Seguro:",
        "commercial": "Comercial / Del empleador",
        "medicare": "Medicare",
        "medicaid": "Medicaid",
        "tricare": "TRICARE",
        "ihs": "Indian Health Service (Servicio de Salud Indígena)",
        "uninsured": "Sin seguro",
        "transplantLabel": "Trasplante:",
        "stagePost1yr": "1+ años",
        "stageUnder1yr": "<1 año",
        "situationLabel": "Situación:",
        "struggling": "Con dificultades",
        "challenging": "Complicada",
        "managing": "Manejable"
      },
      "header": {
        "lowCost": "Costo bajo",
        "mediumCost": "Costo medio",
        "highCost": "Costo alto",
        "specialtyTier": "Nivel de especialidad",
        "tier": "Nivel {{tier}}",
        "generic": "Genérico",
        "genericAvailable": " disponible",
        "readAloud": "Leer en voz alta",
        "removeAria": "Quitar {{name}} de la lista",
        "removeTitle": "Quitar de la lista"
      },
      "savings": {
        "title": "Sus ahorros posibles",
        "withoutHelp": "Sin ayuda",
        "withCopayCard": "Con tarjeta de copago",
        "annual": "Ahorro anual"
      },
      "withdrawn": "{{name}} fue retirado del mercado de EE. UU. en {{year}}. Pregunte a su equipo de trasplante qué tomar en su lugar.",
      "nextStep": {
        "label": "Siguiente paso",
        "copay": "Pida la tarjeta de copago de este medicamento. La mayoría de los pacientes con seguro comercial paga de $0 a $10 al mes.",
        "pap": "Solicite el Programa de Asistencia al Paciente del fabricante. Puede darle este medicamento sin costo si usted califica.",
        "cash": "Compare los precios en efectivo. Si tiene seguro, los pagos en efectivo no cuentan para su deducible. Revise las dos opciones antes de pagar.",
        "medicaid": "Medicaid normalmente cubre este medicamento. Si se lo niegan, pregunte a su equipo de trasplante sobre una autorización previa o una apelación.",
        "foundation": "Busque ayudas económicas de fundaciones para el costo de sus medicamentos."
      },
      "filters": {
        "label": "Filtrar:",
        "all": "Todas las opciones",
        "eligible": "✓ Solo elegibles",
        "free": "Opciones gratis",
        "under50": "Menos de $50"
      },
      "tabs": {
        "aria": "Pestañas de información para {{name}}",
        "assistance": "Programas de asistencia",
        "price": "Precios estimados",
        "overview": "Resumen",
        "print": "Imprimir resumen"
      },
      "fallbacks": {
        "copayCardName": "Tarjeta de copago de {{manufacturer}}",
        "papName": "Asistencia al paciente de {{manufacturer}}",
        "brandCopayCard": "Tarjeta de copago de {{name}}",
        "manufacturerPap": "Programa de Asistencia al Paciente de {{manufacturer}}",
        "manufacturerPapShort": "PAP de {{manufacturer}}",
        "visitManufacturerProgram": "Visitar el programa del fabricante",
        "searchOnDrugsCom": "Buscar el programa en Drugs.com"
      },
      "overview": {
        "manufacturerLabel": "Fabricante: ",
        "commonlyPrescribed": "Comúnmente recetado para receptores de: ",
        "recipients": ".",
        "stageLabel": "Etapa: ",
        "tip": "<strong>Consejo:</strong> Siempre verifique con su médico si puede cambiar entre la versión de marca y la genérica.",
        "drugFactsAria": "Leer toda la información del medicamento en Drugs.com: {{name}} (se abre en una pestaña nueva)",
        "drugFactsLink": "Leer toda la información del medicamento en Drugs.com ",
        "pharmaciesTitle": "Farmacias (dónde surtir o despachar su receta)",
        "thPharmacy": "Farmacia",
        "thDescription": "Descripción",
        "costPlusDesc": "Farmacia en línea con modelo de precio de costo más un margen fijo; a menudo es la más barata para genéricos",
        "trumpRxDesc": "Precios en efectivo negociados por el gobierno en más de 800 medicamentos de marca y genéricos; solo pago en efectivo, no cuenta para su deducible, algunos excluyen Medicare/Medicaid. ",
        "trumpRxGuideLink": "Vea nuestra guía para trasplante",
        "walmartDesc": "Precios bajos constantes; lista de genéricos de $4 disponible",
        "costcoDesc": "Margen bajo; no se necesita membresía para la farmacia",
        "cvsDesc": "Amplia disponibilidad; acepta la mayoría de las tarjetas de descuento",
        "walgreensDesc": "Gran cadena nacional; acepta la mayoría de las tarjetas de descuento",
        "krogerDesc": "Precios competitivos; conveniente si usted ya hace sus compras allí",
        "discountToolsTitle": "Herramientas de descuento (compare precios y obtenga cupones)",
        "thTool": "Herramienta",
        "goodRxDesc": "Cupones y comparación de precios en más de 70,000 farmacias de todo el país",
        "singleCareDesc": "Tarjeta de descuento gratis con precios en más de 35,000 farmacias",
        "rxSaverDesc": "Cupones y comparación de precios; no requiere registro",
        "scriptSaveDesc": "Tarjeta de ahorros gratis aceptada en la mayoría de las farmacias de EE. UU."
      },
      "assistance": {
        "takesGenericTitle": "Usted toma el genérico",
        "takesGenericText": "Los medicamentos genéricos no tienen tarjetas de copago del fabricante; esas son solo para medicamentos de marca. La buena noticia: los genéricos suelen ser mucho más baratos. Compare los precios en efectivo a continuación, especialmente <strong>Mark Cuban Cost Plus Drugs</strong>, GoodRx y SingleCare.",
        "recommended": "RECOMENDADO PARA USTED",
        "eligible": "Usted es elegible",
        "copayFor": "Para seguro comercial/del empleador • Programa del fabricante",
        "perMonth": "/mes",
        "getCardAria": "Obtener tarjeta de copago para {{name}} (se abre en una pestaña nueva)",
        "getCard": "Obtener tarjeta ",
        "linkVerified": "Enlace verificado {{date}}",
        "incomeBased": "Según ingresos",
        "checkEligibility": "Consulte con el programa si usted califica",
        "papNotEligible": "No es para su seguro",
        "papUseCopayInstead": "Este programa es para personas con Medicare, Medicaid o sin seguro. Con seguro comercial o del trabajo, su opci\u00f3n es la tarjeta de copago de arriba.",
        "papNotEligibleText": "Este programa es para personas con Medicare, Medicaid o sin seguro. Los programas var\u00edan, as\u00ed que vale la pena preguntarle a su equipo de trasplante qu\u00e9 le aplica a usted.",
        "papFor": "Para Medicare, Medicaid o sin seguro \u2022 Ingresos de hasta {{multiple}} veces el nivel federal de pobreza \u2014 unos {{amount}} para una persona",
        "free": "GRATIS",
        "ifEligible": "si es elegible",
        "applyAria": "Solicitar asistencia al paciente para {{name}} (se abre en una pestaña nueva)",
        "apply": "Solicitar ",
        "foundations": "Fundaciones",
        "andGrants": " y ayudas económicas",
        "foundationsText": "Estos grupos pueden ayudarle a pagar su medicina. Consulte HealthWell y TotalAssist.",
        "fundFinderAria": "Consultar los fondos de TotalAssist (se abre en una pestaña nueva)",
        "fundFinderLink": "Consultar los fondos de TotalAssist ",
        "partDTitle": "Información de Medicare Parte D",
        "partDText": "Conozca los cambios de cobertura de Medicare Parte D y las opciones de ahorro para {{name}}.",
        "partDAria": "Ver detalles de Medicare Parte D para {{name}} (se abre en una pestaña nueva)",
        "viewDetails": "Ver detalles ",
        "copayCommercialOnly": "Las tarjetas de copago son solo para seguro comercial/del empleador",
        "pricesNote": "Los precios son para un suministro de 30 días. Su precio puede ser diferente. Llame a la farmacia para saber el precio exacto.",
        "formsTitle": "¿Necesita ayuda para llenar los formularios?",
        "formsText": "Nuestra guía le muestra paso a paso cómo llenar los formularios. Tenemos listas de verificación y ejemplos para ayudarle.",
        "viewGuideAria": "Ver ayudas económicas y fundaciones: guía completa de solicitudes",
        "viewGrants": "Ver ayudas económicas y fundaciones"
      },
      "warning": {
        "title": "Importante: las tarjetas de descuento no ayudan con su seguro",
        "word": "Advertencia:",
        "pre": " Las tarjetas de descuento (GoodRx, SingleCare) y los pagos en efectivo ",
        "notCount": "NO cuentan para su ",
        "deductible": "deducible",
        "notCountPost": " ni para su máximo de gastos de bolsillo.",
        "text2": "Si usa una tarjeta demasiado pronto, podría pagar más dinero durante el año. La tarjeta paga por usted, pero ese dinero no cuenta. Usted todavía tiene que pagar su deducible completo después.",
        "usingInsurance": "✅ Usando el seguro",
        "usingInsuranceDesc": "Paga más al principio → después $0 el resto del año",
        "discountCards": "❌ Tarjetas de descuento y efectivo",
        "discountCardsDesc": "Paga menos cada vez → pero paga todo el año",
        "learnMore": "Aprenda más "
      },
      "price": {
        "guideTitle": "Guía de opciones de precios",
        "legendCopay": "Tarjetas de copago",
        "legendCopayDesc": "El mejor ahorro: $0-$10/mes",
        "legendPap": "Asistencia al paciente",
        "legendPapDesc": "Gratis si es elegible",
        "legendDiscount": "Tarjetas de descuento",
        "legendCash": "Precio en efectivo",
        "legendCashDesc": "Comparación base",
        "legendTrumpRxDesc": "Efectivo con descuento del gobierno",
        "estimatesNotice": "<strong>Estos son solo estimados.</strong> Su precio real puede ser diferente. Siempre confirme el precio real con la farmacia.",
        "caption": "Precios estimados para {{name}}",
        "thPharmacyTool": "Farmacia / Herramienta",
        "thEstimatedPrice": "Precio estimado",
        "thAction": "Acción",
        "copayForShort": "Para seguro comercial/del empleador",
        "copayRange": "$0 - $10/mes",
        "manufacturerProgram": "Programa del fabricante",
        "viewCopayAria": "Obtener tarjeta: ver los detalles de la tarjeta de copago para {{name}}",
        "papForShort": "Para Medicare, Medicaid o sin seguro",
        "incomeRules": "Debe cumplir con las reglas de ingresos",
        "viewPapAria": "Solicitar: ver los detalles de asistencia al paciente para {{name}}",
        "goodRxDesc": "Cupones gratis en más de 70,000 farmacias",
        "singleCareDesc": "Tarjeta gratis en más de 35,000 farmacias",
        "costPlusDesc": "Farmacia en línea con precios bajos",
        "community": "Comunidad: ${{min}}-${{max}} ({{num}} reportes)",
        "estUpdated": "Est. actualizado en {{date}}",
        "checkLiveGoodRxAria": "Ver precio actual en GoodRx para {{name}} (se abre en una pestaña nueva)",
        "checkLiveSingleCareAria": "Ver precio actual en SingleCare para {{name}} (se abre en una pestaña nueva)",
        "checkLiveCostPlusAria": "Ver precio actual en Cost Plus Drugs (se abre en una pestaña nueva)",
        "checkLive": "Ver precio actual ",
        "reportPrice": "Reportar precio",
        "trumpRxDesc": "Precio en efectivo con descuento del gobierno",
        "trumpRxExclude": "Puede excluir Medicare/Medicaid",
        "ourGuideAria": "Nuestra guía de TrumpRx para pacientes de trasplante",
        "ourGuide": "Nuestra guía ",
        "visitTrumpRxAria": "Visitar TrumpRx.gov (se abre en una pestaña nueva)",
        "footerNote": "Estos precios son para un suministro de 30 días. Su precio puede ser diferente. Llame a la farmacia para saber su precio exacto. (Última actualización: {{date}})",
        "communityNote": "<strong>Los precios de la comunidad</strong> son precios reales que otras personas pagaron en los últimos 90 días. ¡Ayude a otros contándonos lo que usted pagó!",
        "costPlusNote": "<strong>Acerca de Cost Plus Drugs:</strong> Esta es una farmacia de pago en efectivo. Lo que usted paga allí no cuenta para su deducible. Pero el precio aún puede ser más bajo que el copago de su seguro. ¡Compare antes de decidir!",
        "trumpRxNotePre": "<strong>Acerca de TrumpRx.gov:</strong> Este es un descuento de pago en efectivo; NO cuenta para su deducible ni para su máximo de gastos de bolsillo.",
        "trumpRxNoteMedicare": " Algunos cupones de TrumpRx pueden excluir a los pacientes de Medicare/Medicaid.",
        "trumpRxNoteCompare": " Siempre compare primero con el copago de su seguro. ",
        "readFullGuide": "Lea nuestra guía completa"
      },
      "print": {
        "detailsTitle": "Detalles del medicamento",
        "brandName": "Nombre de marca:",
        "genericName": "Nombre genérico:",
        "category": "Categoría:",
        "manufacturer": "Fabricante:",
        "organs": "Órganos:",
        "stage": "Etapa:",
        "notAvailable": "N/D",
        "priceTitle": "Precios estimados",
        "copayCardFallback": "Tarjeta de copago del fabricante",
        "papFallback": "Asistencia al paciente (PAP)",
        "freeIfEligible": "GRATIS (si es elegible)",
        "assistanceTitle": "Programas de asistencia",
        "copayAvailableFallback": "Tarjeta de copago disponible",
        "copayEligibilityFallback": "Solo para seguro comercial/del empleador.",
        "papProgramFallback": "Programa de Asistencia al Paciente (PAP)",
        "papEligibilityFallback": "Para pacientes con Medicare, Medicaid, sin seguro o con seguro insuficiente.",
        "foundationGrants": "Ayudas económicas de fundaciones",
        "foundationCheck": "Consulte HealthWell y TotalAssist.",
        "checklistTitle": "Lista de acciones",
        "applyFor": "Solicitar ",
        "checkFoundation": "Consultar la elegibilidad en las fundaciones (HealthWell, TotalAssist)",
        "comparePrices": "Comparar precios en GoodRx y SingleCare",
        "askTeam": "Preguntar al equipo de trasplante sobre alternativas genéricas",
        "printButton": "Imprimir este resumen"
      }
    },
    "external": {
      "label": "Búsqueda externa / personalizada",
      "note": "<strong>Nota:</strong> Este medicamento no está en nuestra base de datos educativa. Use los enlaces a continuación para buscar precios directamente.",
      "navAria": "Opciones externas para consultar el precio de {{name}}",
      "checkCostPlusAria": "Consultar el precio de {{name}} en Cost Plus Drugs (se abre en una pestaña nueva)",
      "checkGoodRxAria": "Consultar el precio de {{name}} en GoodRx (se abre en una pestaña nueva)",
      "checkSingleCareAria": "Consultar el precio de {{name}} en SingleCare (se abre en una pestaña nueva)",
      "searchDrugsAria": "Buscar \"{{name}}\" en Drugs.com para encontrar programas de asistencia (se abre en una pestaña nueva)",
      "searchDrugsLink": "Buscar \"{{name}}\" en Drugs.com para encontrar programas de asistencia "
    },
    "detail": {
      "meta": {
        "title": "Cómo pagar {{name}}: tarjetas de copago y asistencia | Transplant Medication Navigator™",
        "description": "Encuentre tarjetas de copago, Programas de Asistencia al Paciente y ayudas de fundaciones para {{name}}. Vea cómo bajar el costo de su medicamento de trasplante.",
        "notFoundTitle": "Medicamento no encontrado | Transplant Medication Navigator™",
        "notFoundDescription": "No pudimos encontrar esta página de medicamento. Busque en nuestra lista completa de medicamentos de trasplante y programas de asistencia."
      },
      "priceRangeSingle": "{{price}} al mes",
      "priceRangeBetween": "{{min}} a {{max}} al mes",
      "notFound": {
        "title": "Medicamento no encontrado",
        "text": "No pudimos encontrar ese medicamento. Busque en nuestra lista completa para encontrar tarjetas de copago y programas de asistencia.",
        "button": "Buscar medicamentos"
      },
      "breadcrumbAria": "Ruta de navegación",
      "home": "Inicio",
      "medications": "Medicamentos",
      "heading": "Cómo pagar {{name}}",
      "introIs": " es un medicamento de tipo ",
      "introUsedBy": " que usan los pacientes de trasplante",
      "introTail": ". Estas son las formas de bajar lo que usted paga, desde tarjetas de copago hasta programas que lo dan gratis.",
      "estPricePre": "Precio estimado en efectivo con descuento: ",
      "estPricePost": " (varía según la farmacia; su precio puede ser más bajo con seguro o asistencia).",
      "waysTitle": "Formas de ahorrar en {{name}}",
      "copayTitle": "Tarjeta de copago del fabricante",
      "copayText": "Para seguro comercial o del empleador. Las tarjetas de copago pueden bajar su costo hasta solo $0–$10 al mes. No son válidas con Medicare ni Medicaid.",
      "copayLink": "Obtener la tarjeta de copago ",
      "papTitle": "Programa de Asistencia al Paciente (medicamento gratis)",
      "papText": "Si usted no tiene seguro, su seguro no cubre lo suficiente, o tiene Medicare o Medicaid y cumple con los límites de ingresos, puede recibir {{name}} sin costo.",
      "papAsk": " Pregunte a su equipo de trasplante sobre las opciones del fabricante o de fundaciones para este medicamento.",
      "papLink": "Solicitar asistencia ",
      "grantsTitle": "Ayudas económicas de fundaciones",
      "grantsText": "Las fundaciones caritativas pueden ayudar a cubrir copagos y otros costos, según los ingresos y el diagnóstico.",
      "grantsLink": "Ver ayudas económicas y cómo solicitarlas ",
      "genericTitle": "Versión genérica",
      "genericText": "Hay un genérico ({{generic}}) disponible que normalmente cuesta mucho menos. Para los medicamentos contra el rechazo, quédese con el mismo fabricante y hable con su equipo de trasplante antes de cambiar.",
      "isGenericTitle": "Usted ya toma el genérico",
      "isGenericText": "{{generic}} es el genérico de {{brand}} y normalmente cuesta mucho menos. Los genéricos no tienen tarjeta de copago del fabricante, así que compare los precios en efectivo más abajo. Para los medicamentos contra el rechazo, quédese con el mismo fabricante y hable con su equipo de trasplante antes de cambiar.",
      "isGenericNoBrandText": "{{generic}} es el genérico y normalmente cuesta mucho menos que una versión de marca. Los genéricos no tienen tarjeta de copago del fabricante, así que compare los precios en efectivo más abajo.",
      "genericLink": "Genéricos frente a los de marca: lo que debe saber",
      "discountTitle": "Tarjetas de descuento y precios en efectivo",
      "discountText": "Compare GoodRx, SingleCare, Amazon Pharmacy y Mark Cuban Cost Plus Drugs. Para algunos medicamentos, el precio en efectivo es mejor que el copago de su seguro.",
      "discountLink": "Comparar precios para {{name}} ",
      "ctaTitle": "Averigüe cuánto podría pagar por {{name}}",
      "ctaText": "Responda unas preguntas y le mostraremos las tarjetas de copago, los programas de asistencia y los precios para los que usted califica.",
      "ctaQuiz": "Haga el cuestionario gratis de 2 minutos ",
      "ctaSearch": "Buscar todos los medicamentos",
      "faqTitle": "Preguntas comunes sobre {{name}}",
      "faq": {
        "copayQ": "¿Hay una tarjeta de copago para {{name}}?",
        "copayA": "Sí. Si usted tiene seguro comercial o del empleador, la tarjeta de copago del fabricante para {{name}} puede bajar su costo mensual, a menudo hasta solo $0–$10. Las tarjetas de copago no se pueden usar con Medicare, Medicaid ni otros seguros del gobierno.",
        "freeQ": "¿Cómo puedo recibir {{name}} gratis?",
        "freeA": "Si usted no tiene seguro, tiene seguro insuficiente o tiene Medicare/Medicaid y cumple con los límites de ingresos, un Programa de Asistencia al Paciente (PAP) puede darle {{name}} sin costo. Las ayudas económicas de fundaciones también pueden cubrir su parte del costo. Haga el cuestionario gratis de 2 minutos para ver para qué programas califica.",
        "genericQ": "¿Hay un genérico para {{name}}?",
        "genericA": "Sí, hay una versión genérica de {{generic}} disponible que normalmente cuesta mucho menos. Para los medicamentos contra el rechazo del trasplante, quédese con el mismo fabricante y hable con su equipo de trasplante antes de cambiar, porque los cambios pequeños pueden afectar sus niveles del medicamento.",
        "isGenericQ": "¿Este es el genérico?",
        "isGenericA": "Sí. {{generic}} es el genérico de {{brand}} y normalmente cuesta mucho menos. Para los medicamentos contra el rechazo del trasplante, quédese con el mismo fabricante y hable con su equipo de trasplante antes de cambiar, porque los cambios pequeños pueden afectar sus niveles del medicamento.",
        "isGenericNoBrandA": "Sí. {{generic}} es el genérico, así que no hay una versión de marca de la cual cambiarse, y normalmente cuesta mucho menos. Hable con su equipo de trasplante antes de cambiar cómo o dónde lo surte.",
        "costQ": "¿Cuánto cuesta {{name}}?",
        "costA": "Los precios en efectivo varían según la farmacia, pero un precio estimado con descuento es de alrededor de {{price}}. Su costo real depende de su seguro, y las tarjetas de copago o los programas de asistencia pueden bajarlo aún más."
      },
      "relatedPre": "Otros medicamentos de tipo ",
      "relatedPost": "",
      "genericTag": "Genérico",
      "disclaimer": "Información educativa solamente; no es consejo médico. Los precios son estimados y varían según la farmacia y el plan. Siempre hable con su equipo de trasplante antes de cambiar cómo o dónde surte (despacha) sus medicamentos."
    },
    "categories": {
      "Immunosuppressant": "Inmunosupresor",
      "Immunosuppressants": "Inmunosupresores",
      "Induction": "Inducción",
      "Steroid": "Esteroide",
      "Anti-viral": "Antiviral",
      "Antibiotic": "Antibiótico",
      "Anti-fungal": "Antifúngico",
      "Hepatitis B": "Hepatitis B",
      "Hepatitis C": "Hepatitis C",
      "Liver Support": "Apoyo para el hígado",
      "Enzymes": "Enzimas",
      "Heart Failure": "Insuficiencia cardíaca",
      "Heart/Kidney Support": "Apoyo para el corazón y los riñones",
      "Kidney Support": "Apoyo para los riñones",
      "Diuretic": "Diurético",
      "Beta Blocker": "Betabloqueador",
      "Stomach Protection": "Protección del estómago",
      "Pulmonary Hypertension": "Hipertensión pulmonar",
      "Anemia (ESRD)": "Anemia (ESRD)",
      "Iron Supplement (ESRD)": "Suplemento de hierro (ESRD)",
      "Vitamin D (ESRD)": "Vitamina D (ESRD)",
      "Hyperparathyroidism (ESRD)": "Hiperparatiroidismo (ESRD)",
      "Phosphate Binder (ESRD)": "Quelante de fósforo (ESRD)",
      "Acute Rejection": "Rechazo agudo",
      "Antibody-Mediated Rejection": "Rechazo mediado por anticuerpos",
      "ACE Inhibitor": "Inhibidor de la ECA",
      "ARB": "BRA",
      "Calcium Channel Blocker": "Bloqueador de los canales de calcio",
      "Statin": "Estatina",
      "Antiplatelet": "Antiplaquetario",
      "Anticoagulant": "Anticoagulante",
      "Cardiac Glycoside": "Glucósido cardíaco",
      "Diabetes": "Diabetes",
      "Insulin": "Insulina",
      "Thyroid": "Tiroides",
      "Bronchodilator": "Broncodilatador",
      "Respiratory": "Respiratorio",
      "Inhaled Corticosteroid": "Corticosteroide inhalado",
      "Asthma Biologic": "Biológico para el asma",
      "Asthma Biologic / Allergy": "Biológico para el asma / Alergia",
      "Leukotriene Modifier": "Modificador de leucotrienos",
      "Antihistamine": "Antihistamínico",
      "Nasal Corticosteroid": "Corticosteroide nasal",
      "Nasal Antihistamine": "Antihistamínico nasal",
      "Mast Cell Stabilizer": "Estabilizador de mastocitos",
      "Proton Pump Inhibitor": "Inhibidor de la bomba de protones",
      "H2 Blocker": "Bloqueador H2",
      "Pain Relief": "Alivio del dolor",
      "Nerve Pain": "Dolor de los nervios",
      "NSAID": "AINE",
      "Antidepressant": "Antidepresivo",
      "Antidepressant/Sleep": "Antidepresivo/Sueño",
      "Anxiety": "Ansiedad",
      "Sleep Aid": "Ayuda para dormir",
      "Antipsychotic": "Antipsicótico",
      "Vitamin": "Vitamina",
      "Gout": "Gota",
      "Fatty Liver Disease (NASH)": "Enfermedad de hígado graso (NASH)",
      "GI Support": "Apoyo gastrointestinal",
      "Supplement": "Suplemento",
      "Antiarrhythmic": "Antiarrítmico",
      "Antiemetic": "Antiemético",
      "Electrolyte": "Electrolito",
      "Pulmonary Fibrosis": "Fibrosis pulmonar",
      "Cystic Fibrosis": "Fibrosis quística",
      "Inhaled Antibiotic": "Antibiótico inhalado",
      "Mucolytic": "Mucolítico",
      "Anemia": "Anemia",
      "Anticoagulation": "Anticoagulación",
      "Antifungals": "Antifúngicos",
      "Antivirals": "Antivirales",
      "Blood Pressure": "Presión arterial",
      "Blood Support": "Apoyo para la sangre",
      "Cholesterol": "Colesterol",
      "Diuretics": "Diuréticos",
      "GI / Acid Suppression": "Digestivo / Supresión de ácido",
      "Hepatitis B/C": "Hepatitis B/C",
      "Induction Agents": "Agentes de inducción",
      "Infection Prevention": "Prevención de infecciones",
      "Mental Health": "Salud mental",
      "Pain Management": "Manejo del dolor",
      "Steroids": "Esteroides"
    },
    "conditions": {
      "rejection-prevention": "Prevención del rechazo del trasplante",
      "rejection-treatment": "Tratamiento del rechazo del trasplante",
      "infection": "Infección",
      "hepatitis": "Hepatitis B y C",
      "liver-disease": "Enfermedad del hígado",
      "kidney-disease": "Enfermedad del riñón",
      "anemia": "Anemia",
      "low-white-cells": "Recuento bajo de glóbulos blancos",
      "blood-clots": "Coágulos de sangre",
      "high-blood-pressure": "Presión arterial alta",
      "heart-failure": "Insuficiencia cardíaca",
      "heart-rhythm": "Latidos irregulares del corazón",
      "high-cholesterol": "Colesterol alto",
      "fluid-retention": "Retención de líquidos",
      "pulmonary-hypertension": "Hipertensión pulmonar",
      "asthma-copd": "Asma y EPOC",
      "cystic-fibrosis": "Fibrosis quística",
      "pulmonary-fibrosis": "Fibrosis pulmonar",
      "allergies": "Alergias",
      "diabetes": "Diabetes",
      "thyroid": "Enfermedad de la tiroides",
      "gout": "Gota",
      "acid-reflux": "Reflujo ácido y úlceras",
      "digestive": "Síntomas digestivos",
      "pancreatic-insufficiency": "Insuficiencia pancreática",
      "pain": "Dolor",
      "mental-health": "Salud mental y sueño",
      "nutrition": "Nutrición y suplementos",
      "electrolytes": "Desequilibrio de electrolitos"
    }
  },
  "savings": {
    "page": {
      "backLink": "Mis medicamentos",
      "backAria": "Volver a la página Mis medicamentos",
      "title": "Calculadora de ahorros",
      "subtitle": "Vea cuánto podría ahorrar con los programas de asistencia",
      "tablistAria": "Opciones de ahorro",
      "tabCalculator": "Estimar ahorros",
      "tabTracker": "Registrar ahorros reales",
      "syncMessage_one": "Sincronizamos {{count}} registro pendiente",
      "syncMessage_other": "Sincronizamos {{count}} registros pendientes",
      "tipsTitle": "Consejos para llevar el registro",
      "tip1": "Anote cada surtido de receta cuando lo recoja",
      "tip2": "Incluya lo que habría pagado sin la asistencia",
      "tip3": "Busque en el recibo de la farmacia la cantidad que dice \"You Saved\" (usted ahorró)",
      "tip4": "Registre los distintos tipos de programas para ver cuál le ahorra más",
      "ctaTitle": "¿Quiere ahorrar más?",
      "ctaText": "Use nuestra búsqueda de medicamentos para encontrar programas de asistencia al paciente (PAP), ayudas de fundaciones y tarjetas de copago para sus medicamentos.",
      "ctaButton": "Buscar medicamentos"
    },
    "calculator": {
      "title": "Estime sus ahorros en medicamentos",
      "intro": "Los medicamentos de trasplante son caros, pero usted no tiene por qué pagar de más. Use nuestra calculadora para ver cuánto podría ahorrar con los programas de asistencia.",
      "listTitle": "Lista de medicamentos",
      "listSubtitle": "Agregue sus recetas actuales para calcular sus posibles ahorros",
      "medicationLabel": "Medicamento {{number}}",
      "selectPlaceholder": "Seleccione un medicamento...",
      "quantityLabel": "Cantidad por mes",
      "removeAria": "Quitar {{name}} de la lista",
      "removeFallbackName": "el medicamento",
      "medicationError": "Seleccione un medicamento",
      "quantityError": "La cantidad debe estar entre 1 y 12",
      "addButton": "Agregar otro medicamento",
      "calculateButton": "Calcular mis ahorros",
      "annualSavingsLabel": "Ahorro anual estimado",
      "annualSavingsNote": "Rango estimado según precios típicos en efectivo y con descuento; no es una cotización",
      "monthlyRetailLabel": "Costo mensual de venta al público",
      "monthlyNewLabel": "Nuevo costo mensual",
      "caveatBold": "Estas cifras son estimaciones, no una cotización.",
      "caveatText": "Su costo real depende de su seguro, su farmacia y su dosis.",
      "caveatRough": "Algunos medicamentos usan promedios por categoría porque todavía no tenemos precios específicos de ese medicamento, así que su rango es más amplio.",
      "caveatSearch": "Busque en los programas de asistencia a continuación para ver sus opciones reales.",
      "priceDataUpdated": "Datos de precios actualizados por última vez el {{date}}.",
      "breakdownTitle": "Desglose de los ahorros",
      "perMonth": "/mes",
      "perYear": "/año",
      "roughEstimate": "(estimación aproximada)",
      "unlockTitle": "Consiga estos ahorros",
      "unlockText": "Encuentre los programas de asistencia, las tarjetas de copago y el apoyo al paciente para sus medicamentos.",
      "unlockButton": "Buscar programas de asistencia",
      "trustVerifiedTitle": "Programas verificados",
      "trustVerifiedText": "Solo publicamos programas de asistencia al paciente y descuentos del fabricante verificados.",
      "trustDataTitle": "Datos de precios reales",
      "trustDataText": "Nuestras estimaciones usan datos actuales de precios NADAC (precios promedio de adquisición) y de venta al público.",
      "trustPatientTitle": "El paciente primero",
      "trustPatientText": "Creado por pacientes de trasplante, para pacientes de trasplante. Siempre con transparencia."
    },
    "form": {
      "title": "Registre sus ahorros",
      "intro": "¿Acaba de surtir una receta con un programa de asistencia? Anótelo aquí para llevar la cuenta de sus ahorros.",
      "anonymousBold": "Registro anónimo:",
      "anonymousText": "Sus datos se guardan solo en su dispositivo.",
      "requiredSr": "(obligatorio)",
      "medicationNameLabel": "Nombre del medicamento",
      "medicationNamePlaceholder": "p. ej., Tacrolimus, Eliquis",
      "programNameLabel": "Programa que usó",
      "programNamePlaceholder": "p. ej., HealthWell Foundation",
      "programTypeLabel": "Tipo de programa",
      "programTypePlaceholder": "Seleccione el tipo...",
      "originalPriceLabel": "Precio original",
      "originalPriceHint": "(sin asistencia)",
      "paidPriceLabel": "Lo que usted pagó",
      "paidPriceHint": "(con asistencia)",
      "savedPreviewLabel": "Usted ahorró",
      "fillDateLabel": "Fecha del surtido",
      "notesLabel": "Notas",
      "notesHint": "(opcional)",
      "notesPlaceholder": "Cualquier detalle adicional...",
      "submitButton": "Registrar el ahorro",
      "submitLoading": "Guardando...",
      "errorMedication": "Escriba el nombre del medicamento",
      "errorOriginalPrice": "Escriba el precio original",
      "errorPaidPrice": "Escriba lo que pagó (puede ser $0)",
      "errorPaidExceeds": "Lo que pagó no puede ser mayor que el precio original",
      "successMessage": "¡Ahorró ${{amount}}! Ahorro total: ${{total}}",
      "offlineWarning": "No se pudo guardar en línea. El registro quedó guardado en su dispositivo y se sincronizará después."
    },
    "dashboard": {
      "errorLoading": "Hay un problema para cargar la información. Inténtelo de nuevo en un momento.",
      "tryAgain": "Intentar de nuevo",
      "retry": "Reintentar",
      "deleteTitle": "Eliminar registro",
      "deleteMessage": "¿Seguro que quiere eliminar este registro de ahorro? Esto no se puede deshacer.",
      "deleteConfirm": "Eliminar",
      "deleteCancel": "Cancelar",
      "deleteErrorTitle": "Error",
      "deleteErrorMessage": "No se pudo eliminar el registro. Inténtelo de nuevo.",
      "shareText": "¡He ahorrado ${{total}} en mis medicamentos con Transplant Med Navigator! Registre sus ahorros también: transplantmednavigator.com",
      "shareCopiedTitle": "¡Copiado!",
      "shareCopiedMessage": "El resumen de sus ahorros se copió al portapapeles.",
      "shareCopiedOk": "Aceptar",
      "totalTitle": "Su ahorro total",
      "refreshAria": "Actualizar los datos de ahorro",
      "refreshTitle": "Actualizar",
      "loadingSr": "Cargando...",
      "shareAria": "Compartir sus ahorros en redes sociales",
      "shareTitle": "Compartir sus ahorros",
      "fills_one": "en {{count}} surtido",
      "fills_other": "en {{count}} surtidos",
      "progressTo": "Progreso hacia {{label}}",
      "milestone100": "Primeros $100",
      "milestone500": "Club de los $500",
      "milestone1000": "$1,000 ahorrados",
      "milestone2500": "Héroe de los $2,500",
      "milestone5000": "Leyenda de los $5,000",
      "milestone10000": "Campeón de los $10,000",
      "avgPerFill": "Promedio por surtido",
      "medications": "Medicamentos",
      "totalFills": "Surtidos en total",
      "milestones": "Logros",
      "monthlyTitle": "Ahorros por mes",
      "byProgramTitle": "Ahorros por tipo de programa",
      "byProgramFills": "({{count}} surtidos)",
      "recentTitle": "Ahorros recientes",
      "hideEntries": "Ocultar registros",
      "showAll": "Ver todos ({{count}})",
      "deleteEntryAria": "Eliminar el registro de ahorro de {{name}}",
      "emptyTitle": "Todavía no ha registrado ahorros",
      "emptyText": "Use el formulario anterior para registrar su primer ahorro en medicamentos y empezar a ver su progreso."
    },
    "programTypes": {
      "copay_card": "Tarjeta de copago",
      "pap": "Programa de Asistencia al Paciente (PAP)",
      "foundation": "Ayuda de una fundación",
      "discount_card": "Tarjeta de descuento (GoodRx y otras)",
      "negotiated_price": "Precio negociado de Medicare",
      "medicare_negotiated": "Precio negociado de Medicare",
      "generic": "Cambio a genérico",
      "other": "Otro"
    }
  },
  "feedback": {
    "header": {
      "title": "Comparta sus comentarios",
      "subtitle": "Ayúdenos a entender cómo les está funcionando esta herramienta a los pacientes"
    },
    "q1": {
      "title": "¿Encontró un programa que le ayudó?",
      "found_copay_card": "Sí, encontré una tarjeta de copago",
      "found_pap": "Sí, encontré un programa de asistencia al paciente (PAP)",
      "found_not_tried": "Encontré opciones, pero todavía no las he probado",
      "no_didnt_qualify": "No, no califiqué para los programas",
      "no_not_listed": "No, mi medicamento no estaba en la lista"
    },
    "q2": {
      "title": "¿Cuánto le ayudó a ahorrar?",
      "subtitle": "Calcule su ahorro mensual con el programa que encontró.",
      "unsure": "Todavía no lo sé"
    },
    "rescue": {
      "title": "Vamos a conseguirle el medicamento hoy",
      "intro": "El medicamento antirrechazo no es algo que pueda saltarse ni estirar sin peligro. Su centro de trasplante resuelve esto todo el tiempo, y hay opciones que funcionan el mismo día.",
      "step1": "<strong>Llame hoy mismo a su equipo de trasplante.</strong> Pida hablar con el farmacéutico de trasplante o con el trabajador social. Dígales claramente que está por quedarse sin medicamento y que no puede pagar el resurtido (refill).",
      "step2": "<strong>Pida a su farmacia un suministro de emergencia</strong> mientras resuelve el costo. Lleve su frasco de pastillas o el nombre y la dosis del medicamento.",
      "cta": "Vea cómo conseguir el medicamento hoy",
      "continue": "Ahora no, terminar la pregunta",
      "stillTitle": "¿Todavía necesita el medicamento hoy?",
      "stillText": "No se salte ni estire las dosis mientras espera. Aquí le decimos cómo conseguir un suministro puente."
    },
    "q3": {
      "title": "¿Qué habría hecho sin esta herramienta?",
      "paid_full": "Pagar el precio completo",
      "skipped_rationed": "Saltarme o racionar dosis",
      "called_coordinator": "Llamar a mi coordinador de trasplante",
      "not_filled": "No surtir la receta",
      "other": "Otra cosa"
    },
    "q4": {
      "title": "Comparta su historia (opcional)",
      "subtitle": "Su historia puede ayudar a otros pacientes y a mejorar el sistema. Los comentarios son anónimos; por favor no incluya su nombre ni información de contacto.",
      "commentLabel": "Su comentario o experiencia",
      "commentPlaceholder": "Cuéntenos cómo le fue al buscar asistencia para sus medicamentos...",
      "submit": "Enviar comentarios",
      "submitting": "Enviando...",
      "skip": "Omitir y enviar"
    },
    "submitted": {
      "title": "¡Gracias!",
      "text": "Sus comentarios nos ayudan a mejorar y ayudan a los centros de trasplante a entender las necesidades de los pacientes.",
      "backHome": "Volver al inicio"
    },
    "privacyBold": "Privacidad:",
    "privacyText": "Sus comentarios son anónimos, a menos que usted proporcione un correo electrónico"
  },
  "legal": {
    "terms": {
      "title": "Términos y Condiciones",
      "lastUpdated": "Última actualización: 6 de julio de 2026",
      "intro1": "Bienvenido al sitio web Transplant Medication Navigator (el \"Sitio Web\"), operado por TransplantNav LLC (\"nosotros\" o \"nuestro\"). Estos Términos y Condiciones (los \"Términos\") rigen su acceso y uso del Sitio Web y su contenido, cuyo propósito es servir como recurso educativo para pacientes de trasplante y sus cuidadores.",
      "intro2": "Al acceder o usar el Sitio Web, usted acepta quedar obligado por estos Términos. Si no está de acuerdo con estos Términos, no puede acceder ni usar el Sitio Web.",
      "s1Title": "1. No es consejo médico",
      "s1P1": "Esta herramienta ofrece información educativa para ayudarle a encontrar opciones de asistencia con sus medicamentos. No sustituye el consejo médico profesional. Consulte siempre a su equipo de trasplante o a su proveedor de salud si tiene preguntas sobre su afección médica o su tratamiento.",
      "s1P2": "Nunca ignore el consejo médico profesional ni retrase buscarlo por algo que haya leído en este Sitio Web.",
      "s1Emergency": "Si cree que puede tener una emergencia médica, llame a su médico o al 911 de inmediato.",
      "s2Title": "2. Uso de la información",
      "s2P1": "El Sitio Web ofrece información sobre programas de asistencia al paciente, tarjetas de copago y otros recursos. No avalamos, ni somos responsables de, la exactitud o fiabilidad de la información del Sitio Web. No somos responsables de las decisiones que usted tome basándose en la información del Sitio Web.",
      "s3Title": "3. Enlaces de terceros",
      "s3P1": "El Sitio Web puede contener enlaces a sitios web o servicios de terceros que no son propiedad de TransplantNav LLC ni están bajo su control. No tenemos control sobre el contenido, las políticas de privacidad o las prácticas de los sitios web o servicios de terceros, y no asumimos responsabilidad por ellos. Usted además reconoce y acepta que TransplantNav LLC no será responsable, directa ni indirectamente, de ningún daño o pérdida causados o presuntamente causados por el uso de dichos contenidos, bienes o servicios disponibles en esos sitios o servicios, o en conexión con ellos.",
      "s4Title": "4. Propiedad intelectual",
      "s4P1": "El Sitio Web y su contenido, funciones y funcionalidad originales son y seguirán siendo propiedad exclusiva de TransplantNav LLC y sus licenciantes. El Sitio Web está protegido por las leyes de derechos de autor, marcas y otras leyes de los Estados Unidos y de otros países. Nuestras marcas y nuestra imagen comercial no pueden usarse en relación con ningún producto o servicio sin el consentimiento previo por escrito de TransplantNav LLC.",
      "s5Title": "5. Limitación de responsabilidad",
      "s5P1": "En ningún caso TransplantNav LLC, ni sus directores, empleados, socios, agentes, proveedores o afiliados, serán responsables de daños indirectos, incidentales, especiales, consecuentes o punitivos, incluidos, entre otros, la pérdida de ganancias, datos, uso, buena reputación u otras pérdidas intangibles, que resulten de (i) su acceso o uso del Sitio Web, o su imposibilidad de acceder a él o usarlo; (ii) cualquier conducta o contenido de terceros en el Sitio Web; (iii) cualquier contenido obtenido del Sitio Web; y (iv) el acceso, uso o alteración no autorizados de sus transmisiones o contenido, ya sea con base en garantía, contrato, responsabilidad extracontractual (incluida la negligencia) o cualquier otra teoría legal, hayamos sido informados o no de la posibilidad de tal daño, e incluso si se determina que un remedio previsto en estos Términos no cumplió su propósito esencial.",
      "s6Title": "6. Descargo de responsabilidad",
      "s6P1": "El uso del Sitio Web es bajo su propio riesgo. El Sitio Web se ofrece \"TAL CUAL\" y \"SEGÚN DISPONIBILIDAD\". El Sitio Web se ofrece sin garantías de ningún tipo, ya sean expresas o implícitas, incluidas, entre otras, las garantías implícitas de comerciabilidad, idoneidad para un propósito particular, no infracción o curso de desempeño.",
      "s6P2": "TransplantNav LLC, sus subsidiarias, afiliadas y licenciantes no garantizan que a) el Sitio Web funcione de forma ininterrumpida, segura o disponible en un momento o lugar determinado; b) se corrijan los errores o defectos; c) el Sitio Web esté libre de virus u otros componentes dañinos; o d) los resultados de usar el Sitio Web cumplan con sus expectativas.",
      "s7Title": "7. Ley aplicable",
      "s7P1": "Estos Términos se regirán e interpretarán de acuerdo con las leyes del Estado de Texas y la ley federal aplicable, sin considerar sus disposiciones sobre conflictos de leyes.",
      "s7P2": "Que no hagamos valer algún derecho o disposición de estos Términos no se considerará una renuncia a esos derechos. Si un tribunal determina que alguna disposición de estos Términos es inválida o inaplicable, las demás disposiciones seguirán vigentes. Estos Términos constituyen el acuerdo completo entre nosotros respecto al Sitio Web, y sustituyen y reemplazan cualquier acuerdo previo que pudiéramos haber tenido respecto al Sitio Web.",
      "s8Title": "8. Cambios",
      "s8P1": "Nos reservamos el derecho, a nuestra sola discreción, de modificar o reemplazar estos Términos en cualquier momento. Si un cambio es importante, intentaremos avisar con al menos 30 días de anticipación antes de que los nuevos términos entren en vigor. Qué constituye un cambio importante se determinará a nuestra sola discreción.",
      "s8P2": "Al seguir accediendo o usando nuestro Sitio Web después de que esos cambios entren en vigor, usted acepta quedar obligado por los términos modificados. Si no está de acuerdo con los nuevos términos, por favor deje de usar el Sitio Web.",
      "s9Title": "9. Contáctenos",
      "s9Pre": "Si tiene alguna pregunta sobre estos Términos, contáctenos en",
      "asideTitle": "¿Tiene preguntas?",
      "asideText": "Si tiene preguntas sobre estos términos o sobre cómo usar nuestro sitio, estamos aquí para ayudarle.",
      "asideFaq": "Ver preguntas frecuentes",
      "asideHome": "Volver al inicio"
    },
    "privacy": {
      "title": "Política de Privacidad",
      "lastUpdated": "Última actualización: 6 de julio de 2026",
      "intro1": "TransplantNav LLC (\"nosotros\" o \"nuestro\") opera el sitio web Transplant Medication Navigator (el \"Sitio Web\"). Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos su información cuando visita nuestro Sitio Web.",
      "intro2": "Lea esta Política de Privacidad con atención. Al usar el Sitio Web, usted acepta la recopilación y el uso de información de acuerdo con esta política.",
      "s1Title": "1. Información que recopilamos",
      "s1Intro": "Diseñamos el Sitio Web para que la información sobre su salud se quede con usted. Esto es exactamente lo que se recopila y a dónde va:",
      "cardDeviceTitle": "Información que se queda en su dispositivo",
      "cardDeviceText": "Sus respuestas del cuestionario Mi Camino, sus listas de medicamentos guardadas, sus registros de ahorro y su progreso se guardan solo en su propio navegador (almacenamiento local). No se envían a nuestros servidores. No exigimos una cuenta, y no recopilamos su nombre, su correo electrónico ni su información de pago.",
      "cardUsageTitle": "Datos de uso anónimos",
      "cardUsageText": "Contamos eventos como visitas a páginas, inicios y finalizaciones del cuestionario, búsquedas de medicamentos y clics en enlaces de programas de asistencia, junto con conteos anónimos de respuestas (por ejemplo, cuántos visitantes eligieron cada tipo de seguro). Estos conteos no contienen nombre, correo electrónico, dirección IP ni ningún otro identificador, y nuestro punto de recolección rechaza activamente cualquier solicitud que contenga campos identificadores.",
      "cardFeedbackTitle": "Comentarios, encuestas y reportes de precios",
      "cardFeedbackText": "Si responde nuestras preguntas de comentarios o encuestas, o envía un reporte comunitario de precios (medicamento, precio pagado y ubicación de la farmacia), sus respuestas se guardan de forma anónima. No recopilamos nombres, fechas de nacimiento, números de expediente médico ni información de contacto con ellas, y le pedimos que no incluya datos que lo identifiquen en los comentarios de texto libre.",
      "cardEpicTitle": "Importación del expediente de salud (Epic / MyChart)",
      "cardEpicText": "Si usted decide conectar la cuenta de su sistema de salud, su sistema de salud envía su lista de medicamentos activos a través de nuestro servidor seguro directamente a su navegador. No guardamos en nuestros servidores su lista de medicamentos, los identificadores de su expediente ni sus credenciales de acceso. Solo registramos que se completó un inicio de sesión en un sistema de salud determinado, sin información sobre quién inició sesión.",
      "cardCookiesTitle": "Cookies de analítica opcionales",
      "cardCookiesText": "Google Analytics funciona solo si usted lo acepta en nuestro aviso de consentimiento. Si lo rechaza, o si su navegador envía la señal Global Privacy Control, no se carga ningún script de Google Analytics ni se instalan cookies de analítica. Puede cambiar su decisión en cualquier momento con el enlace \"Opciones de privacidad\" al pie de la página.",
      "s2Title": "2. Cómo usamos su información",
      "s2Intro": "Usamos la información que recopilamos de las siguientes maneras:",
      "s2Items": [
        "Para ofrecer, operar y mantener el Sitio Web",
        "Para mejorar el Sitio Web y entender qué recursos ayudan más a los pacientes",
        "Para compartir estadísticas agregadas y anónimas (nunca datos individuales) con los centros de trasplante y socios que usan la herramienta",
        "Para cumplir con obligaciones legales"
      ],
      "s3Title": "3. Divulgación de su información",
      "s3Intro": "Podemos compartir su información en las siguientes situaciones:",
      "s3ProvidersLabel": "Proveedores de servicios:",
      "s3ProvidersText": "El Sitio Web funciona con los siguientes proveedores, que procesan datos en nuestro nombre: Netlify (alojamiento del sitio y funciones sin servidor), Neon (base de datos para datos de uso anónimos, comentarios y reportes de precios) y Google Analytics (solo si usted acepta las cookies de analítica). Si conecta un expediente de salud, su propio sistema de salud (por ejemplo, a través de Epic MyChart) también participa en ese intercambio.",
      "s3LegalLabel": "Requisitos legales:",
      "s3LegalText": "Podemos divulgar información si la ley lo exige o en respuesta a solicitudes válidas de las autoridades públicas.",
      "s3TransfersLabel": "Transferencias de negocio:",
      "s3TransfersText": "Si participamos en una fusión, adquisición o venta de activos, la información puede transferirse como parte de esa transacción.",
      "s3NoSell": "No vendemos su información personal, y no la compartimos con fines publicitarios.",
      "s4Title": "4. Cookies y tecnologías de seguimiento",
      "s4P1": "Las únicas cookies de seguimiento que usamos son las cookies opcionales de Google Analytics descritas antes, y están desactivadas hasta que usted las acepte en el aviso de consentimiento. Respetamos la señal del navegador Global Privacy Control como un rechazo. El Sitio Web también usa el almacenamiento local de su navegador para guardar en su dispositivo su progreso del cuestionario y sus listas de medicamentos; esa información nunca sale de su navegador y usted puede borrarla en cualquier momento desde la configuración de su navegador. Puede cambiar su decisión sobre la analítica en cualquier momento con el enlace \"Opciones de privacidad\" al pie de la página.",
      "s5Title": "5. Seguridad de los datos",
      "s5P1": "Usamos medidas de seguridad administrativas, técnicas y físicas para proteger su información personal. Aunque hemos tomado medidas razonables para proteger la información que usted nos proporciona, tenga en cuenta que ninguna medida de seguridad es perfecta o impenetrable, y no podemos garantizar que su información no será accedida, divulgada, alterada o destruida.",
      "s6Title": "6. Conservación de los datos",
      "s6P1": "Los eventos de uso anónimos, las respuestas de comentarios y los reportes comunitarios de precios se conservan hasta por 24 meses; después se eliminan o se conservan solo como totales agregados. Las conversaciones del chat no se guardan en nuestros sistemas. La información guardada en el almacenamiento local de su navegador permanece en su dispositivo hasta que usted la borre. Podemos conservar información por más tiempo cuando sea necesario para cumplir con obligaciones legales o resolver disputas.",
      "s7Title": "7. Sus derechos de privacidad",
      "s7Intro": "Según donde viva, las leyes estatales de privacidad (como la Ley de Privacidad del Consumidor de California o la ley My Health My Data del estado de Washington) pueden darle derechos sobre su información personal y sus datos de salud de consumidor, entre ellos:",
      "s7AccessLabel": "Acceso:",
      "s7AccessText": "Puede solicitar acceso a la información personal que tengamos sobre usted.",
      "s7CorrectionLabel": "Corrección:",
      "s7CorrectionText": "Puede solicitar que corrijamos información inexacta o incompleta.",
      "s7DeletionLabel": "Eliminación:",
      "s7DeletionText": "Puede solicitar que eliminemos su información personal, con ciertas excepciones.",
      "s7OptOutLabel": "Rechazar la analítica:",
      "s7OptOutText": "Rechace o retire su consentimiento de analítica en cualquier momento con el enlace \"Opciones de privacidad\" al pie de la página, o usando un navegador que envíe la señal Global Privacy Control.",
      "s7P2": "Como no guardamos su nombre, su información de contacto ni datos de cuenta, en la mayoría de los casos no tenemos nada que pueda vincularse con usted. Para ejercer cualquiera de estos derechos o preguntar qué información tenemos, contáctenos con los datos de abajo y responderemos dentro del plazo que exija la ley aplicable. También puede autorizar a un agente para que presente una solicitud por usted, y no lo discriminaremos por ejercer sus derechos.",
      "s8Title": "8. Información de salud y HIPAA",
      "s8P1": "No somos un proveedor de atención médica, un plan de salud ni un centro de intercambio de información de salud, así que no somos una \"entidad cubierta\" según HIPAA, y la información que usted ingresa en este Sitio Web no está protegida por HIPAA. En cambio, está protegida por esta Política de Privacidad, por las decisiones de diseño descritas antes (la información relacionada con su salud se queda en su dispositivo o se recopila sin identificadores) y por las leyes de protección al consumidor, incluidas la Ley de la FTC y la Regla de Notificación de Filtraciones de Datos de Salud de la FTC. Sus expedientes médicos en su hospital o clínica siguen protegidos por HIPAA en esas organizaciones; conectar su expediente de salud aquí es su decisión y solo copia su lista de medicamentos activos a su propio navegador.",
      "s9Title": "9. Sitios web de terceros",
      "s9P1": "El Sitio Web puede contener enlaces a sitios web y servicios de terceros que no son de nuestra propiedad ni están bajo nuestro control. No somos responsables de las prácticas de privacidad de esos terceros. Le recomendamos revisar las políticas de privacidad de los sitios de terceros que visite.",
      "s10Title": "10. Privacidad de los menores",
      "s10P1": "El Sitio Web no está dirigido a menores de 13 años. No recopilamos a sabiendas información personal de menores de 13 años. Si usted es padre, madre o tutor y cree que su hijo nos ha proporcionado información personal, contáctenos para que podamos eliminarla.",
      "s11Title": "11. Cambios a esta Política de Privacidad",
      "s11P1": "Podemos actualizar esta Política de Privacidad de vez en cuando. Le avisaremos de cualquier cambio publicando la nueva Política de Privacidad en esta página y actualizando la fecha de \"Última actualización\". Le recomendamos revisar esta Política de Privacidad periódicamente.",
      "s12Title": "12. Contáctenos",
      "s12Pre": "Si tiene alguna pregunta sobre esta Política de Privacidad o nuestras prácticas de privacidad, contáctenos en",
      "asideTitle": "¿Tiene preguntas?",
      "asideText": "Si tiene preguntas sobre nuestras prácticas de privacidad o sobre cómo manejamos sus datos, estamos aquí para ayudarle.",
      "asideTerms": "Ver Términos y Condiciones",
      "asideHome": "Volver al inicio"
    },
    "a11y": {
      "title": "Accesibilidad y cumplimiento de la Sección 504",
      "lastUpdated": "Última actualización: 12 de febrero de 2026",
      "s504Title": "Aviso de no discriminación de la Sección 504",
      "s504NoticePre": "De acuerdo con la",
      "s504NoticeStrong": "Sección 504 de la Ley de Rehabilitación de 1973",
      "s504NoticeMid": "y la",
      "s504NoticeLink": "Regla Final del Departamento de Salud y Servicios Humanos de EE. UU. (HHS)",
      "s504NoticePost": ", TransplantNav LLC no discrimina por motivos de discapacidad en sus programas, servicios o actividades. Este sitio web está diseñado para ser accesible para todos los usuarios, incluidas las personas con discapacidades.",
      "s504P1Pre": "Estamos comprometidos a que nuestro contenido digital cumpla con los estándares de accesibilidad que exige la regla final de la Sección 504 del HHS, la cual requiere conformidad con las",
      "s504WcagLink": "Pautas de Accesibilidad para el Contenido Web (WCAG) 2.1 Nivel AA",
      "s504P1Post": "para el contenido web dirigido a pacientes antes del 11 de mayo de 2026.",
      "commitTitle": "Nuestro compromiso",
      "commitP1": "TransplantNav LLC está comprometida a hacer que el sitio web Transplant Medication Navigator sea accesible para todos, incluidas las personas con discapacidades. Creemos que todos los pacientes de trasplante merecen acceso igualitario a la información de asistencia con medicamentos, sin importar su capacidad.",
      "commitP2": "Trabajamos para seguir las Pautas de Accesibilidad para el Contenido Web (WCAG) 2.1 Nivel AA. Estas pautas ayudan a que el contenido web sea más fácil de usar para las personas con discapacidades y mejor para todos.",
      "confTitle": "Estado de conformidad",
      "confBadgeStrong": "Parcialmente conforme",
      "confBadgeRest": "con WCAG 2.1 Nivel AA. \"Parcialmente conforme\" significa que algunas partes del contenido no cumplen totalmente con el estándar. Trabajamos continuamente para mantener y mejorar la accesibilidad en todas las funciones.",
      "confP1": "Realizamos una autoevaluación de este sitio web el 12 de febrero de 2026 y encontramos que cumple con la mayoría de los criterios de éxito de WCAG 2.1 Nivel AA. Desde el 6 de julio de 2026 también ejecutamos pruebas automatizadas de accesibilidad (axe-core, reglas WCAG 2.1 A y AA) en nuestras páginas principales antes de cada lanzamiento. Actualmente no se detectan problemas graves ni críticos. Las pruebas automatizadas no pueden detectar todas las barreras. Seguimos haciendo revisiones manuales y agradecemos sus reportes. Un resumen de nuestros hallazgos aparece a continuación.",
      "featTitle": "Funciones de accesibilidad",
      "featIntro": "Este sitio web incluye las siguientes funciones de accesibilidad:",
      "featKeyboardTitle": "Navegación con teclado",
      "featKeyboardText": "Todos los elementos interactivos se pueden alcanzar y usar con el teclado. Use <kbd>Tab</kbd> para moverse entre elementos, <kbd>Enter</kbd> o <kbd>Espacio</kbd> para activar botones, y <kbd>Escape</kbd> para cerrar diálogos y ventanas de ayuda.",
      "featScreenReaderTitle": "Compatibilidad con lectores de pantalla",
      "featScreenReaderText": "Usamos HTML semántico y atributos ARIA para que los lectores de pantalla entiendan la estructura de la página. Hacemos pruebas con JAWS, NVDA, VoiceOver y TalkBack.",
      "featRouteTitle": "Anuncios de cambio de página",
      "featRouteText": "Cuando usted navega a una página nueva, el título de la página se anuncia a los lectores de pantalla mediante una región activa. Así los usuarios de lectores de pantalla saben cuándo cambió la página.",
      "featSkipTitle": "Salto de navegación",
      "featSkipText": "Un enlace para \"Saltar al contenido principal\" aparece en la parte superior de cada página al presionar <kbd>Tab</kbd>. Esto permite a los usuarios de teclado saltarse el menú de navegación.",
      "featContrastTitle": "Color y contraste",
      "featContrastText": "Los colores del texto cumplen los requisitos de contraste de WCAG AA (al menos 4.5:1 para texto normal y 3:1 para texto grande). Usamos una paleta de alto contraste diseñada para pacientes de trasplante que pueden tener cambios en la visión por los medicamentos. El color nunca es la única forma de transmitir información.",
      "featFocusTitle": "Indicadores de foco",
      "featFocusText": "Todos los elementos interactivos muestran un contorno verde visible cuando se enfocan con el teclado. Sobre fondos oscuros, el contorno cambia a blanco para verse mejor.",
      "featMotionTitle": "Movimiento reducido",
      "featMotionText": "Respetamos la configuración del sistema \"prefers-reduced-motion\" (preferir menos movimiento). Si usted la tiene activada en su sistema operativo, las animaciones y transiciones se desactivan.",
      "featHcTitle": "Alto contraste y colores forzados",
      "featHcText": "Somos compatibles con la opción \"prefers-contrast\" y con el Modo de Alto Contraste de Windows (colores forzados). Los indicadores de foco, los botones y los campos de los formularios se adaptan al tema de su sistema.",
      "featSpacingTitle": "Espaciado del texto",
      "featSpacingText": "El contenido sigue siendo legible y funcional cuando el usuario ajusta el espaciado del texto. La altura de línea y el espaciado entre letras, palabras y párrafos pueden aumentarse sin perder contenido ni funciones (WCAG 1.4.12).",
      "featFormsTitle": "Formularios",
      "featFormsText": "Todos los campos de los formularios tienen etiquetas visibles. Los campos obligatorios están claramente marcados. Los mensajes de error se anuncian a los lectores de pantalla.",
      "featTouchTitle": "Áreas táctiles",
      "featTouchText": "Los botones y enlaces tienen un tamaño mínimo de 44 por 44 píxeles, cumpliendo los requisitos de WCAG 2.1. La mayoría mide 48 píxeles para que sea más fácil tocarlos en dispositivos móviles.",
      "featPlainTitle": "Lenguaje sencillo",
      "featPlainText": "El contenido está escrito a un nivel de lectura de 5.º a 7.º grado. Los términos médicos se explican en lenguaje sencillo con ventanas de ayuda que muestran definiciones.",
      "featSimpleTitle": "Modo de letra grande",
      "featSimpleText": "El botón \"Letra grande\" en el encabezado aumenta el tamaño de letra, sube el contraste, oculta los elementos decorativos y simplifica el diseño. El botón indica si la letra grande está activada o no, para que el estado siempre esté a la vista.",
      "featReadTitle": "Lectura en voz alta",
      "featReadText": "Un botón de \"Leer en voz alta\" está disponible en las páginas principales; usa la función de texto a voz de su navegador para leer el contenido en voz alta.",
      "techTitle": "Detalles técnicos",
      "techIntro": "Este sitio web está construido con React y usa elementos semánticos de HTML5. Las funciones de accesibilidad incluyen:",
      "techItem1": "Roles de referencia: <code>banner</code>, <code>navigation</code>, <code>main</code>, <code>contentinfo</code>",
      "techItem2": "Atributos ARIA para contenido dinámico (<code>aria-live</code>, <code>aria-expanded</code>, <code>aria-pressed</code>, <code>aria-modal</code>)",
      "techItem3": "Manejo del foco y confinamiento del foco en los diálogos modales",
      "techItem4": "Anuncio del título de la página al cambiar de ruta mediante una región <code>aria-live</code>",
      "techItem5": "Tamaño de letra base mínimo de 16 px, ampliable con el zoom del navegador hasta 200%",
      "techItem6": "Compatibilidad con el espaciado de texto según WCAG 1.4.12 (el contenido se adapta al espaciado modificado por el usuario)",
      "techItem7": "Reajuste adaptable a una sola columna en pantallas angostas (WCAG 1.4.10)",
      "techItem8": "Hoja de estilos de impresión optimizada para la información de medicamentos y programas",
      "compatTitle": "Compatibilidad",
      "compatIntro": "Este sitio web está diseñado para funcionar con:",
      "compatItems": [
        "Lectores de pantalla: JAWS, NVDA, VoiceOver (macOS/iOS), TalkBack (Android)",
        "Software de ampliación de pantalla",
        "Software de reconocimiento de voz",
        "Navegación solo con teclado",
        "Zoom del navegador hasta 200%",
        "Modo de Alto Contraste de Windows"
      ],
      "compatP2": "Recomendamos usar la versión más reciente de Chrome, Firefox, Safari o Edge para la mejor experiencia.",
      "limitsTitle": "Limitaciones conocidas",
      "limitsIntro": "Conocemos los siguientes problemas de accesibilidad y estamos trabajando para corregirlos:",
      "limitsInfographicLabel": "Imágenes de infografías:",
      "limitsInfographicText": "Dos gráficos informativos contienen texto que no está disponible como HTML. Planeamos agregar descripciones largas en texto.",
      "limitsThirdPartyLabel": "Contenido de terceros:",
      "limitsThirdPartyText": "Parte del contenido incrustado de servicios externos puede no cumplir totalmente con los estándares de accesibilidad.",
      "limitsP2": "Si alguno de estos problemas afecta su uso del sitio, contáctenos y le proporcionaremos la información en un formato alternativo.",
      "testTitle": "Cómo hacemos las pruebas",
      "testIntro": "Evaluamos la accesibilidad mediante:",
      "testItems": [
        "Autoevaluación según los criterios de éxito de WCAG 2.1 Nivel AA",
        "Pruebas automatizadas con Lighthouse y axe-core",
        "Pruebas manuales de navegación solo con teclado",
        "Pruebas con los lectores de pantalla NVDA y VoiceOver",
        "Análisis del contraste de color de todos los textos y elementos interactivos",
        "Revisiones del nivel de lectura con herramientas Flesch-Kincaid",
        "Comentarios de los usuarios, incluidas personas con discapacidades"
      ],
      "testP2": "Nuestra evaluación más reciente se completó el 12 de febrero de 2026.",
      "grievTitle": "Procedimiento de quejas de la Sección 504",
      "grievIntro": "TransplantNav LLC ha adoptado un procedimiento interno de quejas para la resolución rápida y justa de reclamos por cualquier acción prohibida por la Sección 504 de la Ley de Rehabilitación de 1973.",
      "grievFileTitle": "Cómo presentar una queja",
      "grievFileText": "Cualquier persona que crea que ha sido objeto de discriminación por motivos de discapacidad puede presentar una queja. Las quejas deben presentarse por escrito dentro de los 60 días siguientes a la fecha en que la persona se entera de la presunta acción discriminatoria.",
      "grievSubmitTitle": "Envíe su queja a",
      "grievCoordinator": "Coordinador de la Sección 504",
      "grievCompany": "TransplantNav LLC",
      "grievEmailLabel": "Correo electrónico:",
      "grievResTitle": "Proceso de resolución",
      "grievResSteps": [
        "Se le enviará un acuse de recibo por escrito de su queja dentro de 5 días hábiles.",
        "Se realizará una investigación, que puede incluir entrevistas y la revisión de documentos relevantes.",
        "Se emitirá una determinación por escrito dentro de los 30 días siguientes a la recepción de la queja.",
        "Si no está satisfecho con la resolución, puede apelar dentro de los 15 días siguientes a recibir la determinación."
      ],
      "grievAltTitle": "Formatos alternativos",
      "grievAltText": "Este procedimiento de quejas está disponible en formatos alternativos si lo solicita. Si necesita esta información en otro formato debido a una discapacidad, contáctenos y se la proporcionaremos con prontitud.",
      "fbTitle": "Comentarios",
      "fbIntro": "Agradecemos sus comentarios sobre la accesibilidad de este sitio web. Si encuentra una barrera o tiene una sugerencia, contáctenos:",
      "fbEmailLabel": "Correo electrónico:",
      "fbSubjectLabel": "Asunto:",
      "fbSubjectValue": "\"Accessibility Feedback\" (comentarios de accesibilidad)",
      "fbHelpIntro": "Al reportar un problema, ayuda que incluya:",
      "fbHelpItems": [
        "La dirección de la página web (URL) donde ocurrió el problema",
        "Qué estaba tratando de hacer",
        "Qué pasó en su lugar",
        "La tecnología de asistencia que usa (si usa alguna)",
        "Su navegador y sistema operativo"
      ],
      "fbResponse": "Nuestro objetivo es responder a los comentarios de accesibilidad dentro de 5 días hábiles y trabajar para corregir con prontitud los problemas válidos.",
      "extTitle": "Quejas externas",
      "extP1Pre": "Si no está satisfecho con nuestra respuesta a sus comentarios de accesibilidad o a su queja de la Sección 504, puede presentar una queja ante la",
      "extP1Link": "Oficina de Derechos Civiles del Departamento de Salud y Servicios Humanos de EE. UU.",
      "extP1Post": ". Por lo general, las quejas deben presentarse dentro de los 180 días siguientes al presunto acto discriminatorio.",
      "extOcr": "Oficina de Derechos Civiles del HHS",
      "extPhoneLabel": "Teléfono:",
      "extTddLabel": "TDD:",
      "extOnlineLabel": "En línea:",
      "extPortal": "Portal de quejas de la OCR del HHS",
      "asideTitle": "¿Necesita ayuda?",
      "asideText": "Si necesita ayuda para acceder a cualquier contenido de este sitio web o tiene inquietudes de accesibilidad, estamos aquí para ayudarle.",
      "asideContact": "Contáctenos",
      "asideHome": "Volver al inicio"
    }
  },
  "privacyNotice": {
    "title": "Antes de continuar",
    "epic": "Si conecta la cuenta de su sistema de salud, su sistema de salud envía su lista de medicamentos actuales a través de nuestro servidor seguro directamente a su navegador. No guardamos en nuestros servidores su lista de medicamentos, los identificadores de su expediente ni sus credenciales de acceso; solo registramos que se completó un inicio de sesión en un sistema de salud determinado, no quién inició sesión. La lista importada se guarda solo en este dispositivo, y usted puede eliminarla en cualquier momento borrando los medicamentos o los datos de su navegador. Incluya solo la información necesaria.",
    "appeals": "Los datos que escriba aquí (su nombre, medicamento, tipo y fecha del trasplante, y detalles de la denegación) se usan solo en este dispositivo para crear su carta. No se envían a nuestros servidores ni se guardan en ellos. No incluya información que no sea necesaria para la carta.",
    "policyLink": "Lea nuestra Política de Privacidad completa"
  },
  "epic": {
    "title": "Conectar con mi sistema de salud",
    "description": "Conéctese de forma segura a su sistema de salud para importar automáticamente sus medicamentos actuales. Esto ahorra tiempo y nos ayuda a encontrar los programas de asistencia adecuados para usted.",
    "errorSelectFirst": "Primero seleccione su sistema de salud.",
    "errorInvalidSelection": "La selección del sistema de salud no es válida.",
    "errorNotConfigured": "La integración con Epic no está configurada correctamente:",
    "errorConnect": "No pudimos conectar con su sistema de salud. Inténtelo de nuevo.",
    "errorConnectNetwork": "No pudimos conectar con su sistema de salud. Revise su conexión e inténtelo de nuevo.",
    "imported_one": "Importamos {{count}} medicamento de su sistema de salud.",
    "imported_other": "Importamos {{count}} medicamentos de su sistema de salud.",
    "unmatchedIntro_one": "No pudimos encontrar {{count}} de sus medicamentos. Si es un medicamento de trasplante, búsquelo a continuación y agréguelo a mano:",
    "unmatchedIntro_other": "No pudimos encontrar {{count}} de sus medicamentos. Si alguno es un medicamento de trasplante, búsquelo a continuación y agréguelo a mano:",
    "programsFound_one": "Encontramos {{count}} programa de asistencia para sus medicamentos.",
    "programsFound_other": "Encontramos {{count}} programas de asistencia para sus medicamentos.",
    "doseNote": "Las búsquedas de tarjetas de copago y asistencia al paciente se basan en el nombre del medicamento, no en la dosis (mg).",
    "notInDb_one": "{{count}} medicamento de su expediente todavía no está en nuestra base de datos de asistencia para trasplantes; tendrá que buscarlo por su cuenta:",
    "notInDb_other": "{{count}} medicamentos de su expediente todavía no están en nuestra base de datos de asistencia para trasplantes; tendrá que buscarlos por su cuenta:",
    "notInDbHint": "No tenemos detalles de tarjetas de copago ni de asistencia al paciente para estos. Pregunte a su farmacéutico o revise el sitio web del fabricante para ver si hay una tarjeta de copago o un programa de asistencia al paciente.",
    "selectorLabel": "Seleccione su sistema de salud",
    "selectorHelp": "Empiece a escribir el nombre de su hospital o sistema de salud. No se preocupe si no lo escribe exactamente: con escribirlo más o menos basta.",
    "searchPlaceholder": "Busque su hospital o sistema de salud...",
    "noMatches": "No se encontraron sistemas de salud. Contáctenos para agregar el suyo.",
    "moreResults": "{{count}} más; siga escribiendo para reducir la búsqueda.",
    "sandboxTag": "(solo para pruebas)",
    "connectButton": "Conectar con mi sistema de salud",
    "connecting": "Conectando...",
    "connectAria": "Conectar con su sistema de salud para importar sus medicamentos",
    "securityNote": "Sus datos se transmiten de forma segura con PKCE. No guardamos sus credenciales de acceso."
  },
  "myMeds": {
    "privacyTitle": "Sus datos se quedan en este dispositivo",
    "privacyText": "Los medicamentos se guardan solo en su navegador. No se envían a ningún servidor. Si borra los datos de su navegador, esta lista se eliminará. Use Exportar para guardar una copia de seguridad.",
    "calcTitle": "Calculadora de ahorros",
    "calcSubtitle": "Vea cuánto podría ahorrar",
    "remindersTitle": "Recordatorios de tarjetas de copago",
    "remindersSubtitle": "No se pierda ninguna renovación",
    "title": "Mis medicamentos",
    "subtitle": "Lleve el control de sus medicamentos de trasplante y sus fechas de renovación",
    "export": "Exportar",
    "exportTitle": "Exportar medicamentos",
    "import": "Importar",
    "formReady": "Formulario listo",
    "addTitle": "Agregar un medicamento",
    "requiredSr": "(obligatorio)",
    "optional": "(opcional)",
    "nameLabel": "Nombre del medicamento",
    "namePlaceholder": "p. ej., Tacrolimus",
    "nameHint": "Escriba el nombre genérico o de marca de su medicamento",
    "brandLabel": "Nombre de marca",
    "brandPlaceholder": "p. ej., Prograf",
    "dosageLabel": "Dosis",
    "dosagePlaceholder": "p. ej., 1 mg dos veces al día",
    "costLabel": "Costo mensual ($)",
    "costPlaceholder": "p. ej., 150.00",
    "costHint": "Escriba la cantidad en dólares estadounidenses",
    "renewalLabel": "Fecha de renovación",
    "renewalTypeLabel": "Tipo de renovación",
    "renewalTypeSelect": "-- Seleccione --",
    "renewalCalendarOption": "Año calendario (1 de enero)",
    "renewalAnniversaryOption": "Aniversario de inscripción",
    "renewalMaxOption": "Al llegar al beneficio máximo",
    "renewalCalendar": "Año calendario",
    "renewalAnniversary": "Aniversario de inscripción",
    "renewalMax": "Al llegar al máximo",
    "saveButton": "Guardar medicamento",
    "errorName": "Escriba el nombre del medicamento",
    "savedMessage": "¡Medicamento guardado!",
    "imported_one": "Importamos {{count}} medicamento",
    "imported_other": "Importamos {{count}} medicamentos",
    "errorInvalidFile": "El formato del archivo no es válido",
    "errorReadFile": "Error al leer el archivo",
    "insuranceQuestion": "¿Tiene seguro comercial?",
    "insuranceHelp": "El seguro comercial es la cobertura que recibe a través de un empleador o del Mercado de Seguros (ACA), o que compra por su cuenta; no incluye Medicare, Medicaid ni TRICARE. Las tarjetas de copago solo están disponibles con seguro comercial, así que esto nos ayuda a mostrarle los programas de ahorro correctos.",
    "insuranceAria": "Estado del seguro comercial",
    "yes": "Sí",
    "no": "No",
    "insuranceYesBold": "¡Las tarjetas de copago pueden ayudarle!",
    "insuranceYesText": "Con seguro comercial, las tarjetas de copago del fabricante pueden bajar su costo a $0-$50 al mes para muchos medicamentos de trasplante.",
    "insuranceNoBold": "Los Programas de Asistencia al Paciente (PAP) pueden ayudarle.",
    "insuranceNoText": "Los fabricantes de medicamentos ofrecen programas de medicamentos gratis para pacientes que califican según sus ingresos. Las fundaciones también pueden ayudar con los copagos.",
    "listTitle": "Sus medicamentos",
    "answerPrompt": "Responda la pregunta sobre el seguro para ver los programas de ahorro para sus medicamentos.",
    "emptyList": "Todavía no ha guardado medicamentos.",
    "brandField": "Marca:",
    "dosageField": "Dosis:",
    "costField": "Costo mensual:",
    "renewalField": "Renovación:",
    "typeField": "Tipo:",
    "deleteAria": "Eliminar {{name}}",
    "deleteTitle": "Eliminar medicamento",
    "deleteMessage": "¿Seguro que quiere eliminar este medicamento de su lista?",
    "deleteConfirm": "Eliminar",
    "deleteCancel": "Cancelar",
    "copayAvailable": "Tarjetas de copago disponibles",
    "papAvailable": "Programas de asistencia al paciente disponibles",
    "phoneLabel": "Teléfono:",
    "incomeLimitLabel": "Límite de ingresos:",
    "apply": "Solicitar",
    "assistanceTitle": "Programas de asistencia",
    "noPapText": "No encontramos un PAP específico del fabricante para este medicamento. Revise estas fundaciones que pueden ayudar:",
    "healthwellDesc": "- ayuda con copagos y primas",
    "totalAssistDesc": "- casi 150 fondos para copagos y costos del tratamiento",
    "copayCardsTitle": "Tarjetas de copago",
    "noCopayPre": "No encontramos una tarjeta de copago específica para este nombre de medicamento. Pruebe con el nombre de marca exacto, o visite",
    "noCopayLink": "PhRMA Patient Assistance",
    "noCopayPost": "para buscar los programas disponibles.",
    "adherenceQuestion": "¿Recibió su medicamento hoy?",
    "adherenceAria": "Registro de cumplimiento del medicamento",
    "adherenceYes": "Sí",
    "adherenceNoExpensive": "No – sigue siendo muy caro",
    "adherenceNoPharmacy": "No – probaré en otra farmacia",
    "adherenceNoOther": "No – otra razón",
    "adherenceYesText": "¡Muy bien! Tomar sus medicamentos a tiempo es una de las cosas más importantes que puede hacer por la salud de su trasplante.",
    "adherenceExpensiveText": "Saltarse dosis puede poner en riesgo su trasplante. El costo no debería ser la razón — aquí puede conseguir ayuda:",
    "adherenceSave": "Ver formas de ahorrar",
    "adherenceApply": "Ayuda para solicitar asistencia",
    "adherenceFind": "Buscar programas para mis medicamentos",
    "adherenceExpensiveNote": "Las tarjetas de copago y los programas de asistencia para sus medicamentos también aparecen junto a cada uno más arriba. Si está a punto de quedarse sin medicamento, llame hoy al farmacéutico o al trabajador social de su equipo de trasplante.",
    "adherenceOtherText": "Saltarse dosis puede poner en riesgo su trasplante. Si el costo es una barrera, revise los programas de asistencia junto a sus medicamentos más arriba o hable con su equipo de trasplante."
  },
  "share": {
    "prompt": "\u00bfConoce a otro paciente de trasplante que est\u00e9 pagando de m\u00e1s?",
    "button": "Env\u00edele esto a alguien",
    "copied": "Enlace copiado",
    "copiedAnnounce": "Se copiaron el enlace y el mensaje.",
    "title": "Transplant Medication Navigator",
    "message": "Ayuda gratis para pagar los medicamentos de trasplante: tarjetas de copago, programas de asistencia y cu\u00e1nto deber\u00eda costar de verdad su receta. No necesita crear una cuenta."
  },
  "widgets": {
    "readAloud": {
      "label": "Leer en voz alta",
      "stop": "Detener",
      "stopAria": "Dejar de leer en voz alta"
    },
    "feedbackThanks": "Sus comentarios ayudan a los centros de trasplante a entender las necesidades de los pacientes.",
    "chat": {
      "tabChat": "Chat",
      "tabQuiz": "Cuestionario Mi Camino",
      "openAria": "Abrir la asistencia con medicamentos",
      "launcherContinue": "Continúe donde lo dejó",
      "launcherHelp": "¿Necesita ayuda con el costo de sus medicamentos?",
      "dialogAria": "Asistencia con medicamentos",
      "headerTitle": "Navegador de Medicamentos",
      "headerSubtitle": "Guía automatizada · Encuentre programas de asistencia",
      "startOver": "Empezar de nuevo",
      "close": "Cerrar",
      "fallbackGreeting": "¡Hola! Soy su Navegador de Medicamentos. Le ayudaré a encontrar programas de asistencia para sus medicamentos de trasplante. ¡Empecemos!\n\nPrimero, ¿a quién estoy ayudando hoy?",
      "resultsError": "Lo sentimos, hubo un problema al buscar los programas. Inténtelo de nuevo.",
      "resultsErrorMessage": "Disculpe, en este momento tengo problemas para conectarme a nuestra base de datos. Inténtelo de nuevo en un momento, o visite nuestra página de recursos para ver los programas de asistencia.",
      "freeTextError": "Lo siento, no pude procesar eso. Elija una de las opciones anteriores o haga su pregunta de nuevo.",
      "finding": "Buscando las mejores opciones para usted...",
      "generalAssistanceFull": "Asistencia general (sin un medicamento específico)",
      "generalAssistance": "Asistencia general",
      "selectedMeds": "Medicamentos seleccionados ({{count}}):",
      "selectedMedsAria": "Medicamentos seleccionados",
      "removeMedAria": "Quitar {{name}} de la selección",
      "searchLabel": "Buscar un medicamento",
      "searchPlaceholderAdd": "Agregar otro medicamento...",
      "searchPlaceholderType": "Escriba el nombre del medicamento...",
      "searchingSr": "Buscando medicamentos...",
      "resultsAria": "Resultados de la búsqueda de medicamentos",
      "resultsCount_one": "Se encontró {{count}} medicamento",
      "resultsCount_other": "Se encontraron {{count}} medicamentos",
      "addedTag": "Agregado",
      "customAddTitle": "Agregar \"{{name}}\"",
      "customAddDesc": "Agregar este medicamento a su lista",
      "customEntry": "Entrada personalizada",
      "continueWith_one": "Continuar con {{count}} medicamento",
      "continueWith_other": "Continuar con {{count}} medicamentos",
      "skipTitle": "Saltar este paso",
      "skipDesc": "Mostrar programas de asistencia generales",
      "introTitle": "Encuentre su camino con los medicamentos",
      "introSubtitle": "Responda unas preguntas rápidas y le mostraremos programas de asistencia para los que puede calificar.",
      "introDiscover": "Lo que va a descubrir:",
      "introItem1": "Ayuda con copagos y tarjetas de ahorro",
      "introItem2": "Programas de asistencia al paciente (medicamentos gratis)",
      "introItem3": "Ayudas de fundaciones para gastos de bolsillo",
      "introItem4": "Farmacias alternativas de bajo costo",
      "introPrivacy": "Sus respuestas se quedan en su dispositivo. No necesita una cuenta.",
      "introStart": "Empezar el Cuestionario Mi Camino",
      "introTime": "Toma unos 2 minutos • {{count}} preguntas sencillas",
      "progressSr": "Pregunta {{current}} de {{total}}. {{percent}}% completado.",
      "progressLabel": "Pregunta {{current}} de {{total}}",
      "progressPercent": "{{percent}}% completado",
      "progressAria": "Progreso del cuestionario: {{percent}}% completado",
      "urgentTag": "Urgente",
      "helpfulTip": "Consejo útil",
      "previousQuestion": "Pregunta anterior",
      "previousAria": "Volver a la pregunta {{number}}",
      "kbdNavigate": "para navegar",
      "kbdSelect": "para seleccionar",
      "resultsTitle": "Sus resultados personalizados",
      "resultsSubtitle": "Según su perfil, estos son programas para los que puede calificar",
      "profileTitle": "Su perfil",
      "profileInsurance": "Seguro:",
      "profileStage": "Etapa:",
      "profileOrgan": "Órgano:",
      "profileCost": "Costos:",
      "lowCostBadge": "Bajo costo",
      "discountCardBadge": "Tarjeta de descuento",
      "benefitLabel": "Beneficio:",
      "costPlusBenefit": "Costo mayorista + 15% + $5 de tarifa de farmacia",
      "costPlusDesc": "La farmacia de precios transparentes de Mark Cuban; muchas veces 50-90% menos que el precio de venta al público",
      "costPlusDescShort": "Precios transparentes de bajo costo",
      "goodrxDesc": "Cupones gratis aceptados en más de 70,000 farmacias; muchas veces 50-80% de descuento",
      "goodrxDescShort": "Cupones gratis en más de 70,000 farmacias",
      "singlecareDesc": "Tarjeta gratis en más de 35,000 farmacias; compare y ahorre en recetas genéricas",
      "singlecareDescShort": "Tarjeta gratis en más de 35,000 farmacias",
      "checkPrice": "Ver precio",
      "apply": "Solicitar",
      "badgeCopay": "Tarjeta de copago",
      "badgePap": "Medicinas gratis",
      "badgeFoundation": "Fundación",
      "foundationTip": "💡 Consejo: Los fondos abren durante todo el año; vuelva a revisar si ahora está cerrado.",
      "contactSocialWorker": "Contacte al trabajador social de su centro de trasplante para ver opciones de asistencia.",
      "contactCenterShort": "Contacte a su centro de trasplante.",
      "noPrograms": "No se encontraron programas específicos. Contacte a su centro de trasplante para recibir asistencia.",
      "printTitle": "Plan de Acción de Asistencia con Medicamentos",
      "printGenerated": "Generado:",
      "printProfile": "Su perfil",
      "printInsurance": "Seguro:",
      "printStage": "Etapa del trasplante:",
      "printOrgan": "Tipo de órgano:",
      "printNotSpecified": "No especificado",
      "printRecommended": "Programas recomendados",
      "printBenefit": "Beneficio:",
      "printEligibility": "Requisitos:",
      "printApply": "Solicitar:",
      "printContactSw": "Contacte al trabajador social de su centro de trasplante para recibir asistencia.",
      "printFooter": "Generado por TransplantMedicationNavigator.com",
      "popupBlockedTitle": "Ventana emergente bloqueada",
      "popupBlockedText": "Permita las ventanas emergentes en la configuración de su navegador para imprimir su plan de acción.",
      "dismissAria": "Cerrar el aviso",
      "printButton": "Imprimir plan de acción",
      "newSearch": "Empezar una búsqueda nueva",
      "goToWizard": "Empezar el Cuestionario Mi Camino",
      "inputPlaceholder": "O escriba una pregunta...",
      "sendAria": "Enviar mensaje",
      "switchToChat": "Cambie al modo Chat para hacer preguntas",
      "disclaimer": "Asistente de IA (inteligencia artificial): información educativa; no es consejo médico y puede cometer errores. Confirme los detalles con su equipo de trasplante. No escriba su nombre ni sus datos de contacto."
    }
  },
  "chatQuiz": {
    "role": {
      "question": "¿A quién estoy ayudando hoy?",
      "tip": "Los trabajadores sociales y los cuidadores pueden completar este cuestionario en nombre de un paciente para encontrar programas de asistencia.",
      "options": {
        "patient": {
          "label": "Paciente",
          "description": "Soy el paciente de trasplante"
        },
        "carepartner": {
          "label": "Cuidador / Familiar",
          "description": "Estoy ayudando a un ser querido"
        },
        "social_worker": {
          "label": "Trabajador social / Coordinador",
          "description": "Soy profesional de la salud"
        }
      }
    },
    "transplant_stage": {
      "question": "¿En qué etapa del proceso de trasplante está?",
      "tip": "Algunos programas tienen requisitos distintos según el tiempo desde el trasplante. El primer año suele tener más opciones.",
      "options": {
        "pre": {
          "label": "Antes del trasplante",
          "description": "En lista de espera o en evaluación"
        },
        "post_1yr": {
          "label": "Después del trasplante (menos de 1 año)",
          "description": "Dentro del primer año"
        },
        "post_1yr_plus": {
          "label": "Después del trasplante (más de 1 año)",
          "description": "Más de un año después del trasplante"
        }
      }
    },
    "organ_type": {
      "question": "¿Qué tipo de trasplante?",
      "tip": "Con un trasplante de varios órganos, puede calificar para la asistencia de varias fundaciones específicas de cada órgano.",
      "options": {
        "kidney": {
          "label": "Riñón"
        },
        "liver": {
          "label": "Hígado"
        },
        "heart": {
          "label": "Corazón"
        },
        "lung": {
          "label": "Pulmón"
        },
        "pancreas": {
          "label": "Páncreas"
        },
        "multi": {
          "label": "Varios órganos"
        },
        "other": {
          "label": "Otro"
        }
      }
    },
    "insurance_type": {
      "question": "¿Cuál es su seguro principal?",
      "tip": "Las tarjetas de copago funcionan mejor con seguro comercial. Los pacientes con Medicare o Medicaid suelen tener acceso a los Programas de Asistencia al Paciente (PAP) con medicamentos gratis.",
      "options": {
        "commercial": {
          "label": "Seguro comercial",
          "description": "De mi trabajo, del trabajo de mi cónyuge, o lo compré por mi cuenta"
        },
        "medicare": {
          "label": "Medicare",
          "description": "El programa para personas de 65+ años o con discapacidades"
        },
        "medicaid": {
          "label": "Medicaid",
          "description": "Programa estatal para personas con ingresos más bajos"
        },
        "tricare_va": {
          "label": "TRICARE o VA (veteranos)",
          "description": "Beneficios militares o de veteranos"
        },
        "ihs": {
          "label": "Indian Health Service",
          "description": "Programas de salud tribales"
        },
        "uninsured": {
          "label": "No tengo seguro",
          "description": "Sin cobertura de seguro en este momento"
        }
      }
    },
    "has_multiple_insurance": {
      "question": "¿Tiene más de un tipo de seguro de salud?",
      "tip": "Tener varios planes de seguro (como Medicare más un plan del trabajo) afecta qué programas de asistencia puede usar. Esto se llama Coordinación de Beneficios.",
      "options": {
        "yes": {
          "label": "Sí",
          "description": "Tengo varios planes de seguro"
        },
        "no": {
          "label": "No",
          "description": "Solo tengo un plan de seguro"
        }
      }
    },
    "insurance_combination": {
      "question": "¿Cuál de las siguientes opciones aplica en su caso?",
      "tip": "Su combinación de seguros determina para qué programas califica. Medicare + cobertura activa del trabajo es especial: el plan del trabajo paga primero, ¡así que las tarjetas de copago pueden estar disponibles!",
      "options": {
        "medicare_employer_active": {
          "label": "Medicare + cobertura del trabajo (trabajando)",
          "description": "Yo o mi cónyuge trabajamos actualmente y tenemos seguro del trabajo"
        },
        "medicare_retiree": {
          "label": "Medicare + beneficios de jubilado",
          "description": "Tengo beneficios de salud de jubilado de un antiguo empleador"
        },
        "medicare_medicaid": {
          "label": "Medicare + Medicaid (doble elegibilidad)",
          "description": "Califico para Medicare y Medicaid"
        },
        "other_combination": {
          "label": "Otra combinación",
          "description": "Mi situación es diferente de las opciones anteriores"
        }
      }
    },
    "medication": {
      "question": "¿Con qué medicamento necesita ayuda?",
      "skipLabel": "No estoy seguro / Mostrar todas las opciones",
      "tip": "Busque su medicamento por el nombre de marca (como Prograf o Envarsus) o el nombre genérico (como tacrolimus). Puede agregar varios medicamentos."
    },
    "cost_burden": {
      "question": "¿Cómo describiría los costos actuales de sus medicamentos?",
      "tip": "Si está en crisis, comuníquese de inmediato con el trabajador social de su centro de trasplante. Nunca se salte dosis; hay opciones de emergencia disponibles.",
      "options": {
        "manageable": {
          "label": "Manejables",
          "description": "Puedo pagar mis medicamentos"
        },
        "challenging": {
          "label": "Difíciles",
          "description": "Es apretado, pero me las arreglo"
        },
        "unaffordable": {
          "label": "Casi no puedo pagarlos",
          "description": "Me cuesta mucho pagar los medicamentos"
        },
        "crisis": {
          "label": "Crisis",
          "description": "Me he saltado o he racionado dosis"
        }
      }
    },
    "transplant_pharmacy": {
      "question": "¿Surte sus recetas en la farmacia de su centro de trasplante?",
      "tip": "Algunos centros de trasplante tienen su propia farmacia con precios más bajos que los pacientes no conocen. Vale la pena una llamada para preguntar; podría ahorrar mucho en sus medicamentos.",
      "options": {
        "yes": {
          "label": "Sí",
          "description": "Uso la farmacia de mi centro de trasplante"
        },
        "no": {
          "label": "No",
          "description": "Uso otra farmacia"
        },
        "not_sure": {
          "label": "No estoy seguro",
          "description": "No sé si mi centro tiene una"
        },
        "will_check": {
          "label": "¡Voy a preguntar!",
          "description": "Buena idea, llamaré para preguntar"
        }
      }
    }
  },
  "survey": {
    "landing": {
      "title": "Comparta su experiencia",
      "subtitle": "Su experiencia puede cambiar el sistema",
      "transplantTitle": "Encuesta sobre su vida con el trasplante",
      "transplantText": "Para pacientes de trasplante que lidian con medicinas antirrechazo, farmacias y seguros.",
      "transplantMeta": "8 áreas de temas - complete solo las que apliquen a usted",
      "transplantStart": "Comenzar la encuesta de trasplante",
      "generalTitle": "Encuesta general sobre medicamentos",
      "generalText": "Para cualquier persona que tenga problemas para conseguir o pagar sus medicinas.",
      "generalMeta": "5 áreas de temas - toma unos 5 minutos",
      "generalStart": "Comenzar la encuesta general",
      "whyTitle": "Por qué preguntamos",
      "whyQuote": "\"Cuando comparte su historia, ayuda a otros pacientes. Juntos estamos creando la guía que nos hubiera gustado tener. Su voz nos ayuda a arreglar un sistema que no funciona.\"",
      "whyAttribution": "— Lorrinda, presidenta de TRIO y receptora de un trasplante de hígado",
      "privacyLabel": "Privacidad:",
      "privacyText": "No se recogen nombres, fechas ni expedientes médicos"
    },
    "common": {
      "yes": "Sí",
      "no": "No",
      "na": "No aplica",
      "intro": "Elija los temas que más le importan. Puede enviar cada sección por separado.",
      "completedCount": "{{completed}} de {{total}} secciones completadas",
      "thankYou": "- ¡Gracias por compartir su experiencia!",
      "submitted": "✓ Enviada",
      "questionCount": "{{count}} preguntas",
      "answeredCount": "({{count}} respondidas)",
      "backToTopicsAria": "Volver a los temas",
      "backToTopics": "← Volver a los temas",
      "update": "Actualizar respuestas ✓",
      "submitSection": "Enviar esta sección ✓",
      "privacyTitle": "Su privacidad está protegida:",
      "privacyLine1": "No se recogen nombres, fechas ni números de expediente médico.",
      "privacyLine2": "Todas las respuestas son anónimas y nos ayudan a abogar por un mejor acceso a los medicamentos.",
      "poweredBy": "Con el apoyo de TransplantMedicationNavigator.com. Por pacientes, para pacientes."
    },
    "transplant": {
      "title": "Encuesta sobre su experiencia con medicamentos de trasplante",
      "sections": {
        "discharge": {
          "title": "Al salir del hospital",
          "description": "Qué pasó cuando volvió a casa después de su trasplante",
          "q": {
            "meds_in_hand_at_discharge": {
              "label": "¿Salió del hospital con todas sus medicinas?"
            },
            "discharge_med_education": {
              "label": "¿Qué tan bien le enseñó el hospital sobre sus medicinas?",
              "options": [
                "Muy bien - me sentí listo(a)",
                "Bien - tenía casi toda la información",
                "Regular - hubo vacíos",
                "Mal - no me sentí preparado(a)",
                "Nada - lo aprendí por mi cuenta"
              ]
            },
            "knew_costs_before_discharge": {
              "label": "¿Sabía cuánto costarían sus medicinas antes de salir?"
            },
            "social_worker_met": {
              "label": "¿Un trabajador social habló con usted sobre el costo de las medicinas?"
            },
            "first_refill_gap": {
              "label": "¿Se quedó sin medicina antes de su primera renovación?"
            }
          }
        },
        "immunosuppressants": {
          "title": "Medicinas antirrechazo",
          "description": "Problemas con sus medicinas antirrechazo",
          "q": {
            "generic_switch_forced": {
              "label": "¿Alguna vez le cambiaron a otra marca sin preguntarle?"
            },
            "generic_switch_problems": {
              "label": "Si le cambiaron, ¿tuvo problemas con sus niveles en sangre o efectos secundarios?"
            },
            "trough_timing_issues": {
              "label": "¿Ha tenido problemas para coordinar sus análisis de sangre con su medicina?"
            },
            "dose_change_delay": {
              "label": "Después de un cambio de dosis, ¿cuánto tardó en recibir la nueva receta?",
              "options": [
                "El mismo día",
                "1-2 días",
                "3-5 días",
                "Más de 5 días",
                "Tuve que usar la dosis anterior mientras esperaba"
              ]
            },
            "ever_missed_immunosuppressant": {
              "label": "¿Alguna vez perdió una dosis porque no pudo conseguir su medicina (no porque se le olvidó)?"
            },
            "missed_reason": {
              "label": "Si respondió sí, ¿cuál fue la razón principal?",
              "options": [
                "El costo",
                "Demora de la farmacia",
                "El seguro pedía aprobación",
                "No había en existencia",
                "Problema de envío",
                "El seguro dijo que no",
                "No aplica"
              ]
            }
          }
        },
        "specialty": {
          "title": "Farmacia especializada",
          "description": "Su experiencia con farmacias especializadas o de envío por correo",
          "q": {
            "uses_specialty_pharmacy": {
              "label": "¿Recibe alguna medicina de trasplante de una farmacia especializada?"
            },
            "specialty_choice": {
              "label": "¿Pudo elegir su farmacia especializada?",
              "options": [
                "Sí, yo la elegí",
                "No, la eligió el seguro",
                "No, la eligió el centro de trasplante",
                "No estoy seguro(a)",
                "No uso una"
              ]
            },
            "specialty_shipping_issues": {
              "label": "¿Ha tenido problemas con demoras de envío o medicinas que llegan muy calientes o muy frías?"
            },
            "specialty_refill_calls": {
              "label": "¿Cuántas llamadas necesita para renovar su medicina?",
              "options": [
                "Ninguna - es automático",
                "1 llamada",
                "2-3 llamadas",
                "4 o más llamadas",
                "No uso una"
              ]
            },
            "specialty_coordinator_helpful": {
              "label": "Si tiene un asistente de farmacia, ¿qué tan útil es?",
              "options": [
                "Muy útil",
                "Algo útil",
                "No es útil",
                "Nunca he hablado con uno",
                "No tengo uno"
              ]
            }
          }
        },
        "insurance": {
          "title": "Seguro y cobertura",
          "description": "Problemas con el seguro después de su trasplante",
          "q": {
            "insurance_changed_post_tx": {
              "label": "¿Ha cambiado su seguro desde su trasplante?"
            },
            "coverage_gap_experienced": {
              "label": "¿Ha pasado un tiempo sin seguro después de su trasplante?"
            },
            "medicare_36_month_aware": {
              "label": "¿Sabía que antes Medicare dejaba de cubrir las medicinas antirrechazo después de 36 meses?",
              "options": [
                "Sí, me afectó",
                "Sí, pero no me afectó",
                "No, no lo sabía",
                "No tengo Medicare"
              ]
            },
            "prior_auth_immunosuppressants": {
              "label": "¿Su seguro le ha pedido aprobación previa para surtir sus medicinas antirrechazo?"
            },
            "step_therapy_post_tx": {
              "label": "¿El seguro le ha hecho probar una medicina distinta a la que quería su médico?"
            },
            "annual_oop_range": {
              "label": "¿Cuánto paga al año de su bolsillo por las medicinas de trasplante, más o menos?",
              "options": [
                "Menos de $500",
                "$500-$1,000",
                "$1,000-$2,500",
                "$2,500-$5,000",
                "$5,000-$10,000",
                "Más de $10,000"
              ]
            }
          }
        },
        "center": {
          "title": "Ayuda del centro de trasplante",
          "description": "La ayuda que recibe de su equipo de trasplante",
          "q": {
            "center_has_pharmacy": {
              "label": "¿Su centro de trasplante tiene su propia farmacia?",
              "options": [
                "Sí, y la uso",
                "Sí, pero no la uso",
                "No",
                "No estoy seguro(a)"
              ]
            },
            "coordinator_helps_with_meds": {
              "label": "¿Su coordinador de trasplante le ayuda a conseguir su medicina?",
              "options": [
                "Sí, mucho",
                "A veces",
                "Casi nunca",
                "Nunca",
                "No tengo coordinador"
              ]
            },
            "center_told_about_assistance": {
              "label": "¿Su centro de trasplante le habló de programas que ayudan a pagar las medicinas?"
            },
            "center_helped_apply": {
              "label": "¿Alguien de su centro le ayudó a solicitar programas de ayuda?"
            },
            "knows_who_to_call": {
              "label": "¿Sabe a quién llamar en su centro si tiene un problema con una medicina?",
              "options": [
                "Sí, a una persona específica",
                "Sí, a un número general",
                "No sé a quién llamar",
                "No tengo a quién llamar"
              ]
            }
          }
        },
        "pap": {
          "title": "Programas de ayuda",
          "description": "Programas que ayudan a pagar su medicina",
          "q": {
            "uses_pap": {
              "label": "¿Usa algún programa que ayude a pagar sus medicinas de trasplante?"
            },
            "pap_types_used": {
              "label": "¿Qué tipos ha usado? (Marque todos los que apliquen)",
              "options": [
                "Tarjeta de copago del fabricante",
                "Ayuda de una fundación",
                "Programa estatal",
                "Caridad del hospital",
                "Tarjeta de descuento de farmacia",
                "Ninguno"
              ]
            },
            "pap_found_how": {
              "label": "¿Cómo supo por primera vez de los programas de ayuda?",
              "options": [
                "Centro de trasplante",
                "Trabajador social",
                "Grupo de apoyo",
                "Lo encontré en internet",
                "Farmacia",
                "Me acabo de enterar"
              ]
            },
            "pap_gap_experienced": {
              "label": "¿Alguna vez se quedó sin ayuda porque un programa terminó antes de poder renovarlo?"
            },
            "pap_application_burden": {
              "label": "¿Qué tan difícil es solicitar y mantener sus programas de ayuda?",
              "options": [
                "Fácil",
                "Algo de trabajo",
                "Difícil - toma mucho tiempo",
                "Muy difícil - casi me rindo",
                "No he solicitado"
              ]
            }
          }
        },
        "communication": {
          "title": "Comunicación",
          "description": "Qué tan bien le mantienen informado(a)",
          "q": {
            "pharmacy_center_communicate": {
              "label": "¿Su farmacia y su centro de trasplante se comunican bien entre sí?",
              "options": [
                "Sí, muy bien",
                "Casi siempre",
                "A veces",
                "Casi nunca",
                "Yo tengo que ser el intermediario"
              ]
            },
            "notified_of_changes": {
              "label": "¿Le avisan con tiempo cuando van a cambiar los costos o la cobertura de su medicina?",
              "options": [
                "Siempre",
                "Casi siempre",
                "A veces",
                "Casi nunca",
                "Nunca"
              ]
            },
            "understood_all_meds": {
              "label": "¿Sabe para qué sirve cada una de sus medicinas?",
              "options": [
                "Sí, completamente",
                "En su mayoría",
                "Más o menos",
                "No mucho",
                "No"
              ]
            },
            "feels_like_burden": {
              "label": "¿Con qué frecuencia manejar sus medicinas se siente como un segundo trabajo?",
              "options": [
                "Nunca",
                "A veces",
                "Con frecuencia",
                "Siempre"
              ]
            }
          }
        },
        "about": {
          "title": "Sobre usted",
          "description": "Opcional - nos ayuda a entender quién responde esta encuesta",
          "q": {
            "organ_type": {
              "label": "¿Qué tipo de trasplante recibió?",
              "options": [
                "Riñón",
                "Hígado",
                "Corazón",
                "Pulmón",
                "Páncreas",
                "Más de un órgano",
                "Otro",
                "Prefiero no decir"
              ]
            },
            "years_post_transplant": {
              "label": "¿Hace cuánto fue su trasplante?",
              "options": [
                "Menos de 1 año",
                "1-2 años",
                "3-5 años",
                "5-10 años",
                "Más de 10 años",
                "Todavía estoy en espera"
              ]
            },
            "num_medications": {
              "label": "¿Cuántas medicinas toma al día, más o menos?",
              "options": [
                "1-5",
                "6-10",
                "11-15",
                "16-20",
                "Más de 20"
              ]
            },
            "insurance_type": {
              "label": "¿Cuál es su seguro principal?",
              "options": [
                "De mi trabajo",
                "Mercado de seguros (ACA)",
                "Solo Medicare",
                "Solo Medicaid",
                "Medicare + Medicaid",
                "Medicare + plan adicional",
                "VA",
                "Sin seguro",
                "Otro"
              ]
            },
            "region": {
              "label": "¿Dónde vive?",
              "options": [
                "Noreste",
                "Sureste",
                "Medio Oeste",
                "Suroeste",
                "Costa Oeste",
                "Fuera de EE. UU."
              ]
            }
          }
        }
      }
    },
    "general": {
      "title": "Encuesta general sobre medicamentos",
      "sections": {
        "affordability": {
          "title": "Pagar la medicina",
          "description": "Cómo le afectan los costos de las medicinas",
          "q": {
            "cost_barrier": {
              "label": "¿Alguna vez dejó de surtir una receta porque costaba demasiado?"
            },
            "cost_frequency": {
              "label": "¿Con qué frecuencia el costo afecta sus decisiones sobre medicinas?",
              "options": [
                "Nunca",
                "Casi nunca",
                "A veces",
                "Con frecuencia",
                "Siempre"
              ]
            },
            "rationing": {
              "label": "¿Alguna vez saltó dosis o partió pastillas para que la medicina durara más?"
            },
            "monthly_spend": {
              "label": "¿Cuánto gasta en medicinas al mes, más o menos?",
              "options": [
                "Menos de $50",
                "$50-$100",
                "$100-$250",
                "$250-$500",
                "$500-$1,000",
                "Más de $1,000"
              ]
            },
            "financial_stress": {
              "label": "¿Cuánto estrés le causan los costos de sus medicinas?",
              "options": [
                "Nada",
                "Un poco",
                "Algo",
                "Mucho",
                "Muchísimo"
              ]
            }
          }
        },
        "pharmacy": {
          "title": "Farmacia",
          "description": "Cómo surte sus recetas",
          "q": {
            "pharmacy_type": {
              "label": "¿Dónde surte sus recetas normalmente?",
              "options": [
                "Farmacia local",
                "Farmacia de cadena (CVS, Walgreens)",
                "Por correo",
                "Farmacia especializada",
                "Farmacia del hospital",
                "En distintos lugares"
              ]
            },
            "stockout_frequency": {
              "label": "¿Con qué frecuencia falta su medicina en la farmacia cuando la necesita?",
              "options": [
                "Nunca",
                "Casi nunca",
                "A veces",
                "Con frecuencia",
                "Muy seguido"
              ]
            },
            "refill_difficulty": {
              "label": "¿Qué tan difícil es renovar su medicina?",
              "options": [
                "Muy fácil",
                "Fácil",
                "Regular",
                "Difícil",
                "Muy difícil"
              ]
            },
            "pharmacist_helpful": {
              "label": "¿Su farmacéutico le ayuda cuando tiene preguntas?",
              "options": [
                "Me ayuda mucho",
                "Me ayuda algo",
                "Regular",
                "No me ayuda",
                "Nunca he hablado con uno"
              ]
            },
            "auto_refill": {
              "label": "¿Usa renovaciones automáticas?"
            }
          }
        },
        "insurance": {
          "title": "Seguro",
          "description": "Cómo el seguro afecta su medicina",
          "q": {
            "has_insurance": {
              "label": "¿Tiene seguro que cubra medicinas?"
            },
            "insurance_type": {
              "label": "¿Qué tipo de seguro tiene?",
              "options": [
                "De mi trabajo",
                "Mercado de seguros (ACA)",
                "Medicare Parte D",
                "Medicaid",
                "VA",
                "Sin seguro",
                "Otro"
              ]
            },
            "prior_auth_experienced": {
              "label": "¿Su seguro le ha pedido aprobación antes de poder recibir una medicina?"
            },
            "prior_auth_delayed": {
              "label": "Si respondió sí, ¿esto retrasó su medicina?"
            },
            "formulary_switch": {
              "label": "¿Su seguro le ha hecho cambiar a otra medicina?"
            },
            "coverage_denial": {
              "label": "¿Su seguro le ha negado una medicina que necesitaba?"
            }
          }
        },
        "assistance": {
          "title": "Programas de ayuda",
          "description": "Programas que ayudan a pagar la medicina",
          "q": {
            "knows_about_pap": {
              "label": "¿Sabía que hay programas que ayudan a pagar las medicinas?"
            },
            "uses_assistance": {
              "label": "¿Usa algún programa de ayuda ahora?"
            },
            "assistance_types": {
              "label": "¿Qué tipos ha usado? (Marque todos los que apliquen)",
              "options": [
                "Tarjeta de copago del fabricante",
                "Programa de medicina gratuita",
                "GoodRx u otro descuento similar",
                "Programa estatal",
                "Caridad o fundación",
                "Ninguno"
              ]
            },
            "assistance_found_how": {
              "label": "¿Cómo supo por primera vez de los programas de ayuda?",
              "options": [
                "Médico",
                "Farmacéutico",
                "Búsqueda en internet",
                "Amigo o familiar",
                "Trabajador social",
                "Me acabo de enterar"
              ]
            },
            "assistance_difficulty": {
              "label": "¿Qué tan difícil fue solicitar la ayuda?",
              "options": [
                "Muy fácil",
                "Fácil",
                "Regular",
                "Difícil",
                "Muy difícil",
                "No he solicitado"
              ]
            }
          }
        },
        "management": {
          "title": "Tomar su medicina",
          "description": "Cómo maneja sus medicinas diarias",
          "q": {
            "num_medications": {
              "label": "¿Cuántas medicinas recetadas toma con regularidad?",
              "options": [
                "1-2",
                "3-5",
                "6-10",
                "11-15",
                "Más de 15"
              ]
            },
            "adherence_difficulty": {
              "label": "¿Qué tan difícil es tomar sus medicinas como dice su médico?",
              "options": [
                "Muy fácil",
                "Fácil",
                "Regular",
                "Difícil",
                "Muy difícil"
              ]
            },
            "missed_doses": {
              "label": "¿Con qué frecuencia pierde dosis?",
              "options": [
                "Nunca",
                "Casi nunca",
                "A veces",
                "Con frecuencia",
                "Muy seguido"
              ]
            },
            "understands_meds": {
              "label": "¿Sabe para qué sirve cada una de sus medicinas?",
              "options": [
                "Sí, completamente",
                "En su mayoría",
                "Más o menos",
                "No mucho",
                "No"
              ]
            },
            "condition_type": {
              "label": "¿Qué problemas de salud tiene? (Marque todos los que apliquen)",
              "options": [
                "Diabetes",
                "Enfermedad del corazón",
                "Presión alta",
                "Problema del sistema inmunitario",
                "Salud mental",
                "Dolor continuo",
                "Cáncer",
                "Otra condición continua",
                "Prefiero no decir"
              ]
            }
          }
        }
      }
    }
  },
  "pilot": {
    "partnerProgram": "Programa asociado de {{name}}",
    "welcomeGeneric": "Bienvenidos, pacientes de programas asociados",
    "welcomePartner": "Bienvenidos, pacientes de {{name}}",
    "heroGeneric": "Su proveedor de salud se ha asociado con nosotros para ayudarle a encontrar programas de asistencia para medicamentos.",
    "heroPartner": "{{name}} se ha asociado con Transplant Medication Navigator para ayudarle a encontrar programas de asistencia para medicamentos.",
    "getStarted": "Comience aquí",
    "ctaSearchTitle": "Buscar medicamentos",
    "ctaSearchText": "Encuentre sus medicamentos y compare precios",
    "ctaQuizTitle": "Cuestionario Mi Camino",
    "ctaQuizText": "Reciba recomendaciones de asistencia personalizadas",
    "ctaGrantsTitle": "Ayudas económicas y fundaciones",
    "ctaGrantsText": "Explore programas de asistencia económica",
    "whatTitle": "Qué puede hacer aquí",
    "what1": "Buscar sus medicamentos de trasplante y comparar precios",
    "what2": "Encontrar Programas de Asistencia al Paciente (PAP) que pueden darle el medicamento sin costo si usted califica",
    "what3": "Descubrir tarjetas de copago y programas de ahorro del fabricante",
    "what4": "Acceder a ayudas económicas de fundaciones",
    "what5": "Aprender sobre cómo navegar el seguro y las farmacias especializadas",
    "trustFreeTitle": "Educación gratuita",
    "trustFreeText": "Recursos educativos sin costo",
    "trustLoginTitle": "Sin cuenta",
    "trustLoginText": "No necesita crear una cuenta",
    "trustPrivacyTitle": "Privacidad protegida",
    "trustPrivacyText": "No se recogen datos personales",
    "safetyLabel": "Importante:",
    "safetyText": "Los Programas de Asistencia al Paciente legítimos nunca cobran por solicitar. Si un sitio dice ser un PAP pero cobra cuotas, es una estafa. Repórtelo.",
    "aboutText": "Transplant Medication Navigator™ fue creado por una receptora de trasplante para ayudar a los pacientes a encontrar asistencia para medicamentos con recursos educativos gratuitos.",
    "aboutLink": "Conozca más sobre nosotros"
  },
  "common": {
    "closeDialog": "Cerrar el diálogo",
    "loading": "Cargando el contenido",
    "helpfulTipAria": "Consejo útil"
  },
  "changes2027": {
    "banner": {
      "badge": "Nuevo para 2027",
      "text": "Las reglas de Medicare, Medicaid y el Mercado de Salud cambian el 1 de enero.",
      "link": "Vea lo que cambia"
    },
    "page": {
      "back": "Volver al inicio",
      "badge": "Actualizado el 26 de octubre de 2026",
      "title": "Lo que cambia en 2027",
      "intro": "Hay reglas nuevas desde el 1 de enero de 2027. Algunas bajan lo que usted paga por sus medicamentos. Otras pueden poner en riesgo su seguro si se salta un paso. Esto es lo que los pacientes de trasplante deben saber, y lo que deben hacer ahora.",
      "datesTitle": "Fechas clave",
      "dates": [
        {
          "when": "15 oct – 7 dic de 2026",
          "what": "Inscripción abierta de Medicare. Elija o cambie su plan de medicamentos para 2027."
        },
        {
          "when": "1 nov de 2026 – 15 ene de 2027",
          "what": "Inscripción abierta del Mercado de Salud (CuidadoDeSalud.gov). Inscríbase antes del 15 de diciembre para tener seguro desde el 1 de enero."
        },
        {
          "when": "Antes del 1 ene de 2027",
          "what": "Las reglas de trabajo de Medicaid empiezan en muchos estados. Algunos empiezan antes, y otros podrían tener más tiempo."
        },
        {
          "when": "1 ene de 2027",
          "what": "Empiezan los nuevos límites de Medicare y los precios más bajos de 15 medicamentos."
        }
      ],
      "partD": {
        "title": "Medicare Parte D: nuevo límite anual",
        "lead": "La Parte D es la cobertura de medicamentos de Medicare. En 2027, lo máximo que usted paga en un año por los medicamentos cubiertos sube.",
        "capLabel": "Límite anual de lo que usted paga",
        "deductibleLabel": "Deducible más alto que puede cobrar un plan",
        "was": "2026",
        "now": "2027",
        "p1": "Cuando su parte del costo de los medicamentos llega a $2,400, usted paga $0 por los medicamentos cubiertos el resto de 2027. La cuota mensual de su plan no cuenta para los $2,400.",
        "p2": "Muchos pacientes de trasplante toman varios medicamentos caros y llegan al límite al principio del año. Puede pedirle a su plan el Plan de Pago de Recetas de Medicare. Divide lo que debe en pagos mensuales, en vez de una sola cuenta grande en enero.",
        "actionTitle": "Haga esto antes del 7 de diciembre",
        "actions": [
          "Lea la carta \"Aviso Anual de Cambios\" que le envió su plan. Dice lo que cambia en 2027.",
          "Revise que cada medicamento de trasplante que toma esté en la lista de medicamentos de su plan para 2027. Revise también la forma exacta, como de marca o genérico, y cápsulas o líquido.",
          "Compare planes en Medicare.gov o llame al 1-800-MEDICARE (1-800-633-4227).",
          "Si tiene poco dinero, solicite la Ayuda Adicional. Puede bajar mucho lo que paga por sus medicamentos."
        ],
        "planFinder": "Compare los planes de 2027 en Medicare.gov"
      },
      "prices": {
        "title": "Precios más bajos de Medicare para 15 medicamentos",
        "lead": "Medicare negoció con los fabricantes. Los precios más bajos empiezan el 1 de enero de 2027 para las personas con cobertura de medicamentos de Medicare. Varios de estos medicamentos son comunes después de un trasplante.",
        "colDrug": "Medicamento",
        "colUse": "Se usa para",
        "colList": "Precio de lista (30 días)",
        "colNew": "Precio de Medicare en 2027",
        "uses": {
          "xifaxan": "Hígado: confusión por enfermedad del hígado (encefalopatía hepática)",
          "semaglutide": "Diabetes, salud del corazón, peso",
          "janumet": "Diabetes",
          "tradjenta": "Diabetes",
          "trelegy": "Pulmones: asma y EPOC",
          "breo": "Pulmones: asma y EPOC",
          "ofev": "Pulmones: cicatrices (fibrosis pulmonar)"
        },
        "othersLabel": "Los otros 8 medicamentos:",
        "others": "Xtandi, Pomalyst, Ibrance, Linzess, Calquence, Austedo, Vraylar y Otezla.",
        "note": "Los precios de lista son de 2024. Lo que usted paga sigue dependiendo de su plan. Un precio más bajo puede significar un copago más bajo, y puede ayudarle a pagar menos antes de llegar al límite de $2,400. Estos precios son solo para Medicare.",
        "round1": "Los primeros 10 precios de Medicare empezaron en enero de 2026. Incluyen Eliquis, Xarelto, Januvia, Jardiance, Farxiga y Entresto."
      },
      "medicaid": {
        "title": "Medicaid: nuevas reglas de trabajo",
        "warning": "Si pierde Medicaid, podría perder la cobertura de su medicamento contra el rechazo. No ignore las cartas de su oficina de Medicaid.",
        "whoTitle": "Quién tiene que seguir las nuevas reglas",
        "who": "Adultos de 19 a 64 años que recibieron Medicaid porque su estado lo amplió. Cada mes tendrá que mostrar 80 horas de trabajo, estudio, capacitación laboral o trabajo voluntario. Puede combinarlos.",
        "exemptTitle": "Quién no tiene que hacerlo",
        "exempt": [
          "Personas embarazadas o que acaban de tener un bebé",
          "Personas con una discapacidad, o \"médicamente frágiles\" (con un problema de salud grave o complejo)",
          "Padres y cuidadores de un niño menor de 14 años o de una persona con discapacidad",
          "Indígenas americanos y nativos de Alaska",
          "Algunas otras personas, según su estado"
        ],
        "transplantTitle": "Lo que esto significa después de un trasplante",
        "transplant": "Las reglas no nombran a los pacientes de trasplante. Muchos podrían contar como \"médicamente frágiles\". Pero es posible que tenga que mostrar que su salud le impide hacer 80 horas al mes. Cada estado decide qué pruebas pide.",
        "actionTitle": "Haga esto ahora",
        "actions": [
          "Pregúntele a su trabajador social de trasplante si las reglas de trabajo aplican para usted.",
          "Pídale a su equipo de trasplante una carta sobre su salud, por si su estado le pide pruebas.",
          "Abra y conteste cada carta de Medicaid antes de la fecha límite.",
          "Si pierde Medicaid, llame a su centro de trasplante ese mismo día."
        ],
        "notMedicare": "Estas reglas son solo para Medicaid. No cambian Medicare.",
        "stateLink": "Busque la oficina de Medicaid de su estado"
      },
      "marketplace": {
        "title": "Planes del Mercado de Salud: menos ayuda con la prima",
        "lead": "Los planes del Mercado de Salud son los seguros que compra en CuidadoDeSalud.gov o en el sitio de su estado.",
        "p1": "La ayuda extra con las primas que empezó en 2021 terminó después de 2025. El Congreso no la renovó. En 2027, los hogares que ganan más de 4 veces el nivel de pobreza no reciben ninguna ayuda con la prima. También se espera que la mayoría de los planes cuesten más.",
        "p2": "Las tarjetas de copago de los fabricantes todavía se pueden usar con los planes del Mercado de Salud.",
        "actionTitle": "Haga esto durante la inscripción abierta",
        "actions": [
          "Revise los precios de 2027. No deje que el plan del año pasado se renueve sin revisarlo.",
          "Revise que el plan cubra sus medicamentos de trasplante y su centro de trasplante.",
          "Inscríbase antes del 15 de diciembre para que su plan empiece el 1 de enero."
        ],
        "link": "Busque planes de 2027 en CuidadoDeSalud.gov"
      },
      "pending": {
        "title": "Lo que falta por anunciar",
        "p1": "Medicare todavía no ha fijado los costos de 2027 de la Parte B ni de la Parte B-ID. La Parte B-ID es la cobertura solo de medicamentos para pacientes de trasplante de riñón. Medicare suele anunciarlos en noviembre. En 2026, la Parte B-ID cuesta $121.60 al mes.",
        "p2": "Actualizaremos esta página cuando Medicare los anuncie."
      },
      "checklistTitle": "Su lista para 2027",
      "checklist": [
        "Medicare: revise la lista de medicamentos de su plan para 2027 antes del 7 de diciembre.",
        "Medicaid: pregunte si las reglas de trabajo aplican para usted, y pida una carta a su equipo de trasplante.",
        "Mercado de Salud: compare los planes de 2027 e inscríbase antes del 15 de diciembre.",
        "Todos: avísele a su farmacéutico de trasplante de cualquier cambio en su seguro."
      ],
      "helpTitle": "¿Necesita ayuda para pagar sus medicamentos?",
      "helpText": "Conteste 5 preguntas y le mostraremos los programas que podrían ayudarle.",
      "helpCta": "Ver mis opciones",
      "sourcesTitle": "De dónde viene esta información",
      "sourcesNote": "Las cifras son de los Centros de Servicios de Medicare y Medicaid (CMS). Las reglas pueden cambiar. Consulte con su plan o su estado antes de decidir.",
      "sources": {
        "partD": "CMS: límites de la Parte D para 2027 (abril de 2026, en inglés)",
        "prices": "CMS: precios negociados para 2027 (en inglés)",
        "medicaid": "CMS: reglas de trabajo de Medicaid (junio de 2026, en inglés)",
        "healthcare": "CuidadoDeSalud.gov: fechas de inscripción"
      },
      "externalNote": "(se abre en una pestaña nueva)"
    }
  }
}
